const en = {
  language: 'en',
  aiChat: {
    title: 'Glow Intelligence',
    close: 'Close',
    resize: 'Resize panel',
    move: 'Drag or use the arrow keys to move',
    send: 'Send',
    stop: 'Stop',
    placeholder: 'Ask about how Glow works…',
    empty: 'Ask anything about how Glow works.',
    disclaimer: 'Answers are generated by AI and can be wrong. The assistant has no access to your shipment data.',
    error: 'Something went wrong while answering.',
    retry: 'Try again',
    helpful: 'Helpful',
    notHelpful: 'Not helpful',
    commentLabel: 'Add a comment',
    commentOptional: 'optional',
    commentPlaceholder: 'What was good or bad about this answer?',
    feedbackThanks: 'Thanks for your feedback.',
    beta: 'Beta',
    thinking: 'Thinking…',
    tools: {
      glossary: {
        running: 'Looking up {{detail}} in the glossary…',
        used: 'Looked up {{detail}} in the glossary'
      },
      fallback: {
        running: 'Fetching information…',
        used: 'Fetched information'
      }
    },
    newChat: 'New chat',
    language: 'Answer language',
    copyAnswer: 'Copy answer',
    sources: 'Sources',
    sourceUpdated: 'Updated {{date}}',
    app: { 'internal-frontend': 'Glow', 'customer-frontend': 'Customer portal', tracking: 'Tracking' },
    copied: 'Copied',
    history: {
      open: 'Conversation history',
      back: 'Back to the chat',
      empty: 'No previous conversations.',
      error: 'Could not load your conversations.',
      loadError: 'Could not load that conversation.',
      delete: 'Delete conversation "{{title}}"',
      deleteConfirm: 'Delete conversation "{{title}}"?',
      deleteYes: 'Delete',
      deleteCancel: 'Cancel',
      deleteError: 'Could not delete that conversation.'
    },
    suggestions: {
      dispatch: 'How do I assign shipments to a route?',
      statuses: 'What do the different shipment statuses mean?',
      recurring: 'How do I set up a recurring route?',
      deviation: 'What does it mean when a shipment is deviated?'
    }
  },
  userRoles: {
    admin: 'Admin',
    planner: 'Normal',
    read_only_planner: 'Read Only',
    plus_planner: 'Plus',
    partner: 'Partner',
    handler: 'Handler',
    customer: 'Customer',
    customs_agent: 'Customs agent',
    support: 'Support'
  },
  welcomeToGlowWithName: 'Welcome to Glow, {{name}}!',
  emptyStates: {
    notFoundTitle: 'No results found'
  },
  welcomeToGlowDescription: 'Use the navigation to the left to start your work!',
  glowGlobeImage: 'Glow globe image',
  latestUpdatesHere: 'Here are the latest updates.',
  application: {
    all: 'All',
    filter: 'Filter',
    reset: 'Reset',
    cluster: 'Clustering',
    assigned: 'Assigned',
    created: 'Created',
    selected: 'Selected',
    lastUpdated: 'Last updated',
    requiredLocation: 'Location is required',
    save: 'Save',
    update: 'Update',
    search: 'Search...',
    required: '*Required field',
    requiredShort: '*Required',
    endsNextDay: 'ends the next day',
    logOut: 'Log out',
    courier: 'Courier',
    drivers: 'Drivers',
    consignments: 'Shipments',
    status: 'Status',
    address: 'Address',
    estimatedDepartureTime: 'ETD',
    adjusted: 'Adjusted',
    actual: 'Actual',
    tracking: 'Tracking',
    trackingPage: 'Recipient tracking page',
    phoneNumberShort: 'Phone',
    yes: 'Yes',
    no: 'No',
    notSelected: 'Not selected',
    sms: 'SMS',
    httpErrorToString: 'HTTP error: code {{status}} {{statusText}}',
    anErrorOccurred: 'An error occurred!',
    noAccessTitle: 'No access',
    noAccessMessage: 'You are not allowed to use this functionality',
    autoComplete: 'Search Places ...',
    autoCompleteWithoutDots: 'Search places',
    totalWeight: 'Total weight',
    totalVolume: 'Total volume',
    validDeviationCode: 'Please enter a valid value',
    columns: 'Columns',
    move: 'Move',
    title: {
      siteName: 'Glow',
      root: 'Welcome',
      planner: 'Planner',
      admin: 'Admin',
      settings: 'Settings',
      plannerLive: 'Planner - Live',
      plannerLiveSlot: 'Planner - Live - Slot',
      plannerCouriers: 'Planner - Couriers',
      templateRouteRules: 'Planner - Manage Route Rules',
      plannerUnits: 'Planner - Units',
      plannerImport: 'Planner - Import',
      plannerUnresolved: 'Planner - Unresolved',
      plannerCoordinates: 'Planner - Set coordinates',
      plannerConsignments: 'Planner - Shipments',
      plannerSearch: 'Planner - Search',
      plannerPlanning: 'Planner - Planning',
      waybills: 'Planner - Waybills',
      deliveryNotes: 'Planner - Delivery Notes',
      plannerInvoicing: 'Planner - Invoicing',
      plannerCreateBillingOrder: 'Planner - Create billing order',
      plannerEditBillingOrder: 'Planner - Edit billing order',
      plannerCreateCreditNote: 'Planner - Create credit note',
      plannerCopyToBillingOrder: 'Planner - Create copy to billing order',
      plannerVehicle: 'Planner - Vehicles',
      report: 'Reports',
      customerDepartmentLive: 'Live view',
      recipient: 'Package tracking - tracking - Bring',
      instant: 'Instant',
      instantBooking: 'Booking',
      h2Booking: 'H2 Booking',
      customerPortal: 'Customer Portal',
      financial: 'Financial rights',
      readAny: 'Read any',
      orderConfirmation: 'Order Confirmation',
      instantMap: 'Instant map',
      instantMap2: '$t(application.title.instantMap)',
      recurringOrder: 'Recurring orders',
      corrections: 'Order corrections',
      jobs: 'Jobs Monitoring',
      holidays: 'Holidays',
      shipmentLabels: 'Shipment Labels',
      addresses: 'Addresses',
      shd: 'SHD',
      preadvice: 'Preadvice',
      apollo: 'Apollo',
      routeReceiptList: 'Receipt list',
      routesOverview: 'Routes overview',
      loadList: 'Load List',
      pickupOrders: 'Pickup orders',
      customerBooking: 'Customer booking',
      manageReturns: 'Manage Returns',
      preAdviceFollowup: 'Manage preadvice',
      integrations: '$t(apolloAdmin.title)',
      parcelHub: '$t(parcelHubAdmin.title)',
      recurring: 'Planner - Recurring'
    },
    language: {
      en: 'English',
      nb: 'Norwegian',
      sv: 'Swedish',
      dk: 'Danish',
      fi: 'Finnish',
      fr: 'French'
    },
    country: {
      AllCountry: 'All countries',
      Country: 'Country',
      AD: 'Andorra',
      AT: 'Austria',
      BE: 'Belgium',
      BA: 'Bosnia and Herzegovina',
      BG: 'Bulgaria',
      HR: 'Croatia',
      CZ: 'Czechia',
      DK: 'Denmark',
      GB: 'United Kingdom',
      EE: 'Estonia',
      FO: 'Faroe Islands',
      FI: 'Finland',
      FR: 'France',
      DE: 'Germany',
      GI: 'Gibraltar',
      GR: 'Greece',
      HU: 'Hungary',
      IS: 'Iceland',
      IE: 'Ireland',
      IT: 'Italy',
      LV: 'Latvia',
      LT: 'Lithuania',
      LU: 'Luxembourg',
      MK: 'North Macedonia',
      MT: 'Malta',
      MC: 'Monaco',
      ME: 'Montenegro',
      NL: 'Netherlands',
      NO: 'Norway',
      PL: 'Poland',
      PT: 'Portugal',
      RO: 'Romania',
      RU: 'Russia',
      SM: 'San Marino',
      RS: 'Serbia',
      SK: 'Slovakia',
      SI: 'Slovenia',
      ES: 'Spain',
      SE: 'Sweden',
      CH: 'Switzerland',
      UA: 'Ukraine'
    },
    timeDistance: 'Planned time and distance',
    driverReturnToAddress: "Don't specify a return address",
    distance: 'Distance',
    helpLink: '(What is this?)',
    none: 'None',
    noOptions: 'No options',
    selectAll: 'Select all',
    allSelected: 'All selected',
    someSelected: '{{count}} selected',
    noneSelected: 'None selected',
    appBuild: 'App build',
    lastLogin: 'Last login',
    device: 'Device',
    model: 'Model',
    os: 'Os',
    units: 'Units',
    groups: 'Groups',
    departments: 'Departments',
    totalCustomerPrice: 'Total customer price',
    totalUnitPrice: 'Total unit price',
    notFound: 'Not found'
  },
  serviceLevel: {
    label: 'Downgrade service level',
    ingress:
      'Set a default email address that can receive a notification on order registration, pickup and/or delivery.',
    notSet: 'Not set',
    none: 'Off',
    standard: 'Standard',
    premium: 'Premium'
  },
  dropdown: {
    nrSelected: '{{count}} selected',
    nrSelected_other: '{{count}} selected',
    selectedCustomers: '{{count}} customer',
    selectedCustomers_other: '{{count}} customers',
    allCustomers: 'All customers',
    filterCustomers: 'Filter customers',
    selectedDepartments: '{{count}} department',
    selectedDepartments_other: '{{count}} departments',
    allDepartments: 'All departments',
    filterDepartments: 'Filter departments',
    selectedServiceCodes: '{{count}} service',
    selectedServiceCodes_other: '{{count}} services',
    allServiceCodes: 'All services',
    filterServiceCodes: 'Filter services',
    selectedVasCodes: '{{count}} vas',
    selectedVasCodes_other: '{{count}} vases',
    allVasCodes: 'All vases',
    filterVasCodes: 'Filter vases',
    selectedDestinations: '{{count}} destination',
    selectedDestinations_other: '{{count}} destinations',
    filterSelfBillingUnitIds: 'Filter self billing unit ids',
    allSelfBillingUnitIds: 'All self billing unit ids',
    selectedSelfBillingUnitIds: '{{count}} self billing unit id',
    selectedSelfBillingUnitIds_other: '{{count}} self billing unit ids'
  },
  button: {
    actions: 'Actions',
    edit: 'Edit',
    back: 'Back',
    cancel: 'Cancel',
    done: 'Done',
    clear: 'Clear',
    clearAll: 'Clear all',
    selectAll: 'Select all',
    close: 'Close',
    save: 'Save',
    saveAndPublish: 'Save and Publish',
    delete: 'Delete',
    export: 'Export',
    new: 'Create new',
    search: 'Search',
    add: 'Add',
    remove: 'Remove',
    assign: 'Assign',
    fullEdit: 'Full edit',
    confirm: 'Confirm',
    continue: 'Continue',
    copy: 'Copy',
    continueAndSave: 'Continue and save',
    triggerRollout: 'Trigger rollout',
    triggerRolloutAgain: 'Roll out again'
  },
  consignment: {
    packageType: 'Package type',
    palletFootprints: 'Pallet space',
    loadingMeters: 'Loading meters',
    includePreAdvice: 'Preadvice',
    onlyFailedPreAdvice: 'Preadvice failed',
    onlyReturnPreAdvice: 'Return to sender',
    search: 'Shipment search',
    noShipmentsFound: 'No shipments found',
    clickButtonToSearch: 'Click the search button to search',
    consignmentsForDate: 'Shipments {{date}}',
    showOnlyEditable: 'Only editable',
    showOnlyNotAssigned: 'Not assigned',
    withoutDate: 'Without date',
    extendedSearch: 'Extended Search',
    showDeleted: 'Show deleted',
    showDeviated: 'Show deviated',
    deletedBy: 'Deleted by',
    deletionReason: 'Reason',
    numberOfConsignments: 'Found {{number}} shipments',
    showAll: 'All',
    delivery: 'Delivery',
    pickup: 'Pickup',
    pickups: '{{count}} pickup',
    pickups_other: '{{count}} pickups',
    edit: 'Edit',
    deleteOrders: 'Delete',
    duplicateOrder: 'Duplicate',
    duplicateConfirmation: 'Are you sure you want to duplicate this order?',
    orderDuplicated: 'Order has been duplicated',
    orderDuplicatedFailed: 'Unable to duplicate order',
    copyOrder: 'Copy',
    editOrder: 'Edit',
    cantDeleteOfferedOrders: "You can only delete upcoming orders that haven't been added to a route yet",
    cantEditOfferedOrders: "You can only edit upcoming orders that haven't been added to a route yet",
    onlyCopyOne: 'You can only copy one order at once',
    onlyEditOne: 'You can only edit one order at once',
    deletedOrderNotCopyable: 'Deleted order cannot be copied because of insufficient order details in Glow',
    restoreOrder: 'Restore',
    deletedOrderNotRestorable: 'Deleted order cannot be restored because of insufficient order details in Glow',
    preplan: 'Preplan',
    deleteConfirmation: 'Are you sure you want to delete this shipment ?',
    deleteMultipleConfirmation: 'Are you sure you want to delete selected shipments ?',
    copyConfirmation: 'Are you sure you want to copy this shipment ?',
    editConsignment: 'Edit shipment information',
    changeDateAndTime: 'Change date and time',
    searchShipments: 'Search shipments:',
    searchCustomers: 'Search customers:',
    excelExportRemoved:
      'It will no longer be possible to Export to Excel from this page. Please use the <0>Import / Export</0> page or <0>SAGA</0> instead. This is part of a larger update, and additional functionality will be removed over time before the page is eventually decommissioned and shut down. All work should be done on <1>this page</1>.',
    filterBy: 'Filter by:',
    limitedShipmentsShownMessage: 'Showing a maximum of {{count}} shipments, consider narrowing your search',
    limitedUnresolvedAddressesShownMessage: 'Showing a maximum of {{count}} unresolved addresses',
    bulkActions: 'Bulk Actions',
    bulkActionsMultiple: 'Bulk Actions ({{count}})',
    moveShipmentsToDifferentDepartment: 'Move to different department',
    addToRecurringGroup: 'Add to recurring group',
    addEvents: 'Add events',
    disabledEditDeleteHelperText:
      'This order cannot be edited or deleted, please contact your local Bring office to change the order.',
    editPickupConsignment: 'Update pickup information',
    editDeliveryConsignment: 'Update delivery information',
    editPickupAndDeliveryTime: 'Update pickup and delivery times',
    editConsignmentLocation: ' Location',
    editConsignmentTime: ' Time',
    editConsignmentName: ' Name',
    editConsignmentPhone: ' Phone number',
    editConsignmentInstructions: ' Instructions',
    earliestPickupTime: 'Earliest pickup time *',
    latestPickupTime: 'Latest pickup time *',
    earliestDeliveryTime: 'Earliest delivery time',
    latestDeliveryTime: 'Latest delivery time',
    enterPickupInstructions: 'Enter pickup instructions',
    enterDeliveryInstructions: 'Enter delivery instructions',
    enterDeliveryName: 'Enter delivery name',
    enterPickupName: 'Enter pickup name',
    enterPickupPhone: 'Enter pickup phone number',
    enterDeliveryPhone: 'Enter delivery phone number',
    specificationSize: 'Specification size',
    enterSpecificationSize: 'Enter specification size',
    editSpecificationSize: 'Edit specification size',
    enterSpecificationDescription: 'Enter description',
    editSpecificationDescription: 'Edit description',
    editPickupInfoDescription: 'To be able to edit info you must choose either of the above options.',
    updateLocationFor: 'Update information for {{count}} shipments',
    updateLocationFor_other: 'Update pickup information for {{count}} shipments',
    comment: 'Comment',
    show: 'Show',
    filter: 'Filter shipments',
    state: 'State',
    estimatedDelivery: 'Estimated delivery',
    requestedTimePickup: 'Requested pickup time',
    requestedTimeDelivery: 'Requested delivery time',
    timeNotSet: 'Not set',
    customerReference: 'Customer reference',
    shipmentId: 'Shipment ID',
    packageId: 'Package ID',
    noCourier: 'No courier',
    noSlot: 'No slot',
    showEvents: 'Show events →',
    hideEvents: 'Hide events ←',
    events: 'Events',
    send: 'Send',
    sendMessage: 'Send message',
    sendCommentFailed: 'Comment save failed',
    recipient: 'Recipient',
    unresolved: 'Unresolved shipments',
    description: 'Description',
    pickupAddress: 'Pickup address',
    numberOfPackages: 'No of packages',
    registeredPickupAddress: 'Registered pickup address',
    pickupZipCode: 'Postal code',
    pickupZipArea: 'Area',
    deliveryAddress: 'Delivery address',
    deliveryZipCode: 'Postal code',
    deliveryZipArea: 'Area',
    deliveryLocation: 'Location',
    registeredDeliveryAddress: 'Registered delivery address',
    updated: 'Shipment has been updated',
    moved: 'Shipment has been moved',
    unresolvedMessage: "There is {{count}} shipment where we can't locate the address, please add it.",
    unresolvedMessage_other: "There are {{count}} shipments where we can't locate the address, please add them.",
    foundUnresolvedMessage:
      'We have found the following valid addresses for this shipment. If they are correct, press Update. Otherwise please find the correct address in the below map.',
    remove: 'Remove',
    optimizingNewSlot: 'Optimizing shipment in new slot',
    slotSelect: 'Choose slot',
    pickupInstructions: 'Pickup instructions',
    deliveryInstructions: 'Delivery instructions',
    specificationDescription: 'Description',
    tracking: 'Tracking',
    recipientPhone: 'Recipient phone number',
    customerRef: 'Customer ref',
    service: 'Service',
    message: {
      CREATED: 'Created',
      ASSIGNED: 'Assigned to route',
      UNASSIGNED: 'Unassigned',
      COLLECTED: 'Collected',
      DELIVERED: 'Delivered',
      DEVIATED: 'Deviated',
      COMMENT: 'Comment',
      RESOLVED: 'Resolved',
      UNRESOLVED: 'Unresolved',
      OFFERED: 'Offered',
      REJECTED: 'Rejected',
      ACCEPTED: 'Accepted',
      RETURNED: 'Returned',
      DELETED: 'Deleted',
      UNCONFIRMED: 'Unconfirmed',
      REFUSED: 'Refused'
    },
    adjustTabTitle: 'Adjust',
    bookingPanelTitle: 'Booking',
    mapPanelTitle: 'Map',
    recipientName: 'Recipient name',
    receivedBy: 'Received by:',
    manuallyChangeLocations: 'Manually change locations',
    manualOverrideDeviationTimeConfirm: 'Confirm manual override of deviation of selected shipment',
    manualOverrideDeliveryTimeConfirm: 'Confirm manual override of delivery of selected shipment',
    onManuallyChangeLocationsConfirm: 'Are you sure you want to make the shipment unresolved?',
    unresolveDeliveryAddress: 'Unresolve delivery address',
    unresolvePickupAddress: 'Unresolve pickup address',
    unresolveAddress: 'Unresolve address',
    reference: 'Reference',
    shipmentIdNumber: 'No',
    shipmentDetails: 'Shipment details',
    customer: 'Customer',
    subcustomer: 'Customer no',
    dateAndTime: 'Date and times',
    filterCustomer: 'Filter customer',
    searchShipmentDateError: 'Enter date range below 120 days.',
    searchPhraseLength: 'Search phrase should at least be {{minLength}} chars long for extended search.',
    moveOrder: 'Move shipment',
    moveOrderTitle: 'Move shipment to another department',
    moveOrderDefault: 'Select department',
    label: 'Label',
    createLabel: 'Create label',
    createDeliveryLabel: 'Create delivery label',
    createLabelShipment: 'Create label (Shipment)',
    createMultipleLabel: 'Create label ({{count}})',
    viewLabel: 'View label',
    viewLabels: 'View labels',
    generateLabelError: 'Error: {{error}}',
    generateLabelErrorTitle: 'Something went wrong',
    generateLabelErrorDescription: 'Sorry, we couldn’t generate labels at the moment. Try again later',
    generateLabelErrorButton: 'View error code',
    generatingLabels: 'Label PDFs are being generated...',
    labelsGeneratedSuccessfully: 'Labels were generated successfully',
    vas: 'Value added services (VAS)',
    price: 'Price',
    orderSources: {
      expressit: 'ExpressIT',
      glow: 'GLOW',
      glow_customerBooking: 'GLOW Customer booking',
      glow_excelImportV2: 'GLOW Excel',
      excel: 'GLOW Excel',
      HappyFlow: 'Happy Flow',
      98466118503: 'Mybring',
      98466118504: 'Mybring',
      glow_recurring: 'Recurring',
      ShipmentAPI: 'Shipment API',
      others: 'EDI'
    },
    pickupDeviation: 'Pickup deviation',
    deliveryDeviation: 'Delivery deviation',
    shipmentSyncStatus: {
      no: 'No',
      yes: 'Yes',
      partial: 'Partial'
    },
    selectOtherActions: 'Select other actions'
  },
  eventsList: {
    timeWindow: 'Time window',
    from: 'From',
    to: 'To'
  },
  status: {
    started: 'Started',
    notStarted: 'Not started'
  },
  consignmentEvent: {
    message: {
      'auto-dispatch-succeeded': 'Auto-dispatch initiated',
      'auto-dispatch-failed': 'Auto-dispatch failed',
      'optimizing-failed': 'Route optimization failed',
      'reoptimized-with-fallback-window': 'Route automatically reoptimized',
      routeName: 'Route name',
      comment: 'Comment',
      created: 'Created',
      completed: 'Completed',
      assigned: 'Assigned',
      plannedOnRoute: 'Planned on route',
      plannedOnRouteMoreInfo: 'Planned on route {{routeName}} ({{unitName}})',
      nameOfUnit: 'Name of unit',
      optimizeProviderId: 'Optimize ID',
      noOptimizationEngine: 'No optimization engine',
      failedOptimizeProviderId: 'Failed Optimize ID',
      retryOptimizeProviderId: 'Retry Optimize ID',
      optimizationTimeWindow: 'Optimization time window',
      extendedBy: 'Extended by {{minutes}} min',
      optimizingFailedOtherNotPlanned: 'Another shipment on the route could not be planned',
      optimizingFailedError: 'Optimization stopped with an error',
      delivered: 'Delivered',
      collected: 'Collected',
      returned: 'Returned',
      deviated: 'Deviated',
      damaged: 'Damaged',
      notification: 'Notification',
      slotChanged: 'Slot manually changed',
      unassigned: 'Unassigned',
      rejected: 'Rejected',
      image: 'Image',
      error: 'Error',
      started: 'Started',
      stopped: 'Stopped',
      accepted: 'Accepted',
      offered: 'Offered',
      unitName: 'Unit',
      driverName: 'Driver',
      'delivery-id-check': 'ID check',
      'deviation-sms-sent': 'Deviation SMS sent',
      'delivered-manually-overridden': 'Delivery manually overridden',
      'order-released-for-invoicing': 'Invoicing released',
      'order-excluded-from-invoicing': 'Excluded from invoicing',
      'order-paused-from-invoicing': 'Invoicing paused',
      'manually-set-invoicing-ok-for-order-invoicing': 'Invoiced OK',
      'manually-set-not-invoiced-for-order-invoicing': 'Not invoiced',
      'manually-set-excluded-from-invoicing': 'Excluded from invoicing',
      'unit-manually-added-for-invoicing': 'Unit manually added',
      'invoice-acknowledged-by-external-system': 'Order acknowledged by external system',
      'invoice-created-in-external-system': 'Invoice created in external system',
      'invoice-sent-to-customer': 'Invoice sent to customer',
      'invoice-paid-by-customer': 'Invoice paid by customer',
      'invoice-due-date-updated': 'Invoice due date updated',
      'invoice-paid-to-vendor': 'Invoice paid to vendor',
      'customer-invoiced': 'Customer invoiced',
      'deviated-manually-overridden': 'Deviation manually overridden',
      'collected-manually-overridden': 'Collection manually overridden',
      'pickup-location-changed': 'Pickup address changed',
      'delivery-time-estimated': 'Updated delivery time',
      'slot-manually-changed': 'Slot manually overridden',
      'pickup-time-changed': 'Pickup time changed',
      'manually-change-location': 'Manual override of locations',
      'pickup-consignment-data-changed': 'Pickup details changed',
      'delivery-consignment-data-changed': 'Delivery details changed',
      'specification-size-data-changed': 'Specification Size changed',
      'specification-description-data-changed': 'Description changed',
      'delivery-time-purchased': 'Upsales: Shorter time window ordered by recipient',
      'digital-identity-verified': "Recipient's identity verified digitally",
      'digital-identity-verification-failed': "Could not verify the recipient's identity digitally",
      'flex-delivery-ordered': 'Simplified delivery ordered by receiver',
      'flex-delivery-ordered-by-sender': 'Simplified delivery ordered by sender',
      'flex-delivery-changed': 'Simplified delivery changed',
      'flex-delivery-confirmation-sms-sent': 'Simplified delivery confirmation SMS sent',
      'flex-delivery-confirmation-app-notification': 'Push notification for simplified delivery confirmation sent',
      'return-to-pickup-point-delivery-deviated': 'Will be handed over to pickup point',
      recipientName: 'Recipient name',
      receivedBy: 'Received by',
      'reject-order-correction': 'Rejected order correction',
      'accept-order-correction': 'Accepted order correction',
      'handed-over-to-other-unit': 'Handed over to other unit',
      'handed-over': 'Handed over to other unit',
      deliveredWithoutSignature: 'Delivered without signature',
      deliveredWithoutSignatureReason: {
        left_package_outside: 'Placed as instructed',
        did_not_get_signature: 'In person',
        DELIVER_IN_PERSON: 'In person'
      },
      'returned-manually-overridden': 'Return manually overridden',
      'eta-sms-sent': 'ETA SMS sent',
      calculatedEta: 'Estimated arrival: {{eta}}',
      etaSmsLabel: 'Estimated arrival',
      scanned: 'Arrived at terminal',
      'arrived-at-terminal': 'Arrived at distributing terminal',
      'order-sorted': 'Sorted',
      'not-arrived-at-distributing-terminal': 'Not arrived at distributing terminal',
      'pickup-eta-sms-sent': 'Pickup ETA SMS sent',
      'handed-in-at-posten-terminal': 'Arrived at sorting terminal',
      'pickup-sms-sent': 'Tracking SMS sent',
      'pre-pickup-sms-sent': 'Tracking SMS pre-sent',
      'pickup-address-unresolved': 'Pickup address unresolved',
      'delivery-address-unresolved': 'Delivery address unresolved',
      'in-transit': 'In transit',
      'upcoming-pickup-sms-sent': 'SMS for upcoming delivery sent',
      'order-sorted-same-day': 'Date set to today by terminal app',
      'signature-sms-sent': 'Signature SMS sent',
      'flex-delivery-cancelled': 'Simplified delivery cancelled',
      'delivery-time-ordered': 'Delivery date changed by recipient',
      'delivery-time-ordered-internal': 'Delivery date changed',
      'delivery-time-updated-from-hf-sync': 'Delivery time synced from HF',
      'planned-delivery-date-ordered': 'Planned delivery date ordered',
      'delay-sms-sent': 'SMS regarding delayed delivery sent',
      'production-deviation': 'Production deviation',
      'manual-delay-sms-sent': 'Manual delay SMS sent',
      'route-planning-complete': 'Route complete',
      'signature-delivered': 'Signature from recipient',
      showPicture: 'Show picture',
      'external-address-wash': 'Delivery details changed',
      'order-note-changed': 'Note changed',
      'customer-details-changed': 'Customer details changed',
      'order-data-changed': 'Order changed',
      'order-moved-to-department': 'Moved between departments',
      'order-moved-to-department-with-data': 'Shipment moved from',
      'package-measurements-changed': 'Package measurements changed',
      'package-data-changed': 'Package data changed',
      'driver-deviated-from-route': 'Driver deviated from route',
      'driver-deviated-from-route-at-pickup': 'Driver deviated from route at pickup',
      'delivered-outside-service-time-window': 'Delivery or deviation outside the service time window',
      'delivered-outside-estimated-time-window': 'Delivery or deviation outside the estimated time window',
      'delivered-in-estimated-time-window': 'Delivery or deviation inside the estimated time window',
      'picked-up-outside-service-time-window': 'Pickup or deviation outside the service time window',
      'picked-up-outside-estimated-time-window': 'Pickup or deviation outside the estimated time window',
      'picked-up-in-estimated-time-window': 'Pickup or deviation inside the estimated time window',
      'ordered-delivery-time-set-by-production-time-window': 'Production time window set',
      'delivery-location-deviation': 'Delivery or deviation not at expected location',
      'seen-by-recipient': 'Tracking page seen by recipient',
      'first-estimated-times-seen': 'First estimated times seen by recipient',
      'pre-advice-push-sms-sent': 'Preadvice PUSH-SMS sent',
      'pre-advice-push-return-sms-sent': 'Preadvice PUSH-RETURN-SMS sent',
      'pre-advice-pull-sms-sent': 'Preadvice PULL-SMS sent',
      'pre-advice-pull-email-sent': 'Preadvice PULL-email sent',
      'pre-advice-pull-reminder-sms-sent': 'Preadvice PULL reminder SMS to receiver sent',
      'pre-advice-pull-reminder-email-sent': 'Preadvice PULL reminder email to receiver sent',
      'pre-advice-pup-sms-sent': 'Preadvice PUP-SMS sent',
      'pre-advice-return-sms-sent': 'Preadvice Return-SMS sent',
      'pre-advice-return-email-sent': 'Preadvice Return-email sent',
      'pre-advice-pull-reminder-to-sender-email-sent': 'Preadvice PULL reminder to sender email sent',
      'pre-advice-pup-reminder-to-sender-email-sent': 'Preadvice PUP reminder to sender email sent',
      'pre-advice-return-return-to-sender-email-sent': 'Preadvice RETURN return to sender email sent',
      'pre-advice-pull-return-to-sender-email-sent': 'Preadvice PULL return to sender email sent',
      'pre-advice-push-return-email-sent': 'Preadvice PUSH return to sender email sent',
      'pre-advice-manual-attempt': 'Manual preadvice attempt',
      'pre-advice-manual-request': 'Manual preadvice initiated',
      'pre-advice-active-return-to-customer-email-sent': 'Preadvice active return to customer email sent',
      'pre-advice-active-return-not-picked-up-email-sent':
        'Preadvice active return not picked up email sent to customer',
      'pre-advice-active-return-info-to-customer-email-sent':
        'Preadvice active-return information to customer email sent',
      'pre-advice-passive-return-to-customer-email-sent': 'Preadvice passive return to customer email sent',
      'notification-to-sender-failed': 'Email notification to customer failed',
      resolved: 'Address coordinates set',
      unresolved: 'Address coordinates not set',
      'pre-advice-status-changed': 'Preadvice status changed',
      'reported-damaged': 'Reported Damage',
      'reported-missing-article': 'Reported missing article(s)',
      'delivery-sms-sent': 'Delivery SMS Sent',
      'parcelbox-allocated': 'Space reserved in parcelbox',
      unconfirmed: 'Unconfirmed',
      refused: 'Refused',
      'accepted-by-planner': 'Accepted',
      'apartment-information-updated': 'Apartment information updated',
      'lock-code-entered': 'Gate code entered',
      'service-upgrade-purchased': 'Upsales: Carry-in service ordered by recipient',
      serviceUpgradePurchasedDescription: 'Carry-in Service ordered by recipient',
      'claim-registered-email-sent': 'Claim registered e-mail sent',
      'invoicing-failed': 'Invoicing failed',
      'invoiced-ok': 'Invoiced OK',
      'invoice-awaiting-acknowledgement': 'Order awaiting acknowledgement',
      'parcel-locker-delivery-selected': 'Parcel box selected',
      'cancelled-parcel-locker-delivery': 'Parcel box cancelled',
      'pre-advice-result': 'Preadvice',
      'order-credited': 'Order credited',
      'parcel-locker-tracking-sms-sent': 'Parcel box tracking sms sent',
      'time-window-cancelled-by-recipient': 'Time window cancelled by recipient',
      'hd-multileg-return-created': 'Return delivery leg created',
      'hd-multileg-return-failed': 'Return delivery leg failed',
      'return-address-updated': 'Return address updated',
      restored: 'Restored',
      'manually-marked-as-handled': 'Return marked as handled',
      'recipient-phone-number-updated': 'Recipient phone number updated',
      'recipient-email-address-updated': 'Recipient email address updated',
      'preliminary-loaded': 'Preliminary loaded',
      selfBillingUnitId: 'Self-billing unit ID',
      selfBillingUser: 'User',
      'manual-price-override': 'Price overridden',
      'incomplete-price-approved': 'Incomplete price approved',
      'incomplete-price-unapproved': 'Incomplete price approval revoked',
      'b2r-return-order-created': 'B2R return order created',
      unloaded: 'Unloaded',
      'manually-changed-measurements': 'Manually changed weight and volume',
      'internal-trade-order-created': 'Internal trade order created',
      'load-carrier-ready-for-distribution': 'Load carrier ready for distribution',
      'bom-articles-muted': 'BOM PU/DEL excluded from invoicing',
      'bom-articles-unmuted': 'BOM PU/DEL unexcluded from invoicing',
      'pickup-app-notification': 'Push notification for tracking sent',
      'duplicate-order-created': 'Duplicate order created',
      'ready-for-pickup': 'Ready for pickup (PUP at terminal)'
    },
    cause: {
      plannedStop: 'Pickup information has been updated because the order was loaded at a scheduled stop',
      planToScan: 'Delivery information has been updated because the shipment was scanned onto route',
      adhocHenteordre:
        'Delivery information has been updated because the route has a different end address than the terminal',
      sorted: 'Delivery information has been updated because the shipment was sorted',
      shipmentDelayed: 'Delivery information has been updated because the shipment is delayed',
      movedToNextWorkingDay: 'Moved to the next working day',
      optimizedInLoadCarrier:
        'Delivery information has been updated because the shipment was route planned as part of a load carrier'
    },
    source: 'Source',
    unassignedReason: 'Reason',
    returnAddressSource: {
      OrderSource: 'Return address provided by the customer in the booking file is used',
      CustomerAdmin: 'Return address configured in Customer Admin is used',
      SenderAddress: 'No Return Address is specified in the customer’s booking file, the sender’s address is used'
    },
    rejectedReason: {
      reason: 'Reason',
      private: 'Private reasons',
      notEnoughTime: 'Cant make the stop in time',
      notEnoughSpaceOnVehicle: 'Goods do not fit on vehicle',
      other: 'Other',
      CJ: '$t(consignmentEvent.rejectedReason.notEnoughSpaceOnVehicle)',
      CK: '$t(consignmentEvent.rejectedReason.other)',
      CL: '$t(consignmentEvent.rejectedReason.notEnoughTime)',
      OL1: 'Not on the route',
      OL2: 'Not enough space in the vehicle',
      OL3: 'Not enough time',
      OL4: 'Goods not found',
      OL5: 'Planned for later, but no terminal stops remain',
      comment: 'Comment'
    },
    idCheck: {
      idCheckFailed: 'ID check failed, but delivered with {{idCheckFailedResult}}',
      idCheckSummaryOther: 'Other ({{otherType}}), birth date {{birthDate}}',
      idCheckSummary: '{{idCheckType}}, birth date {{birthDate}}',
      idCheckSummaryOtherAgeConfirmed: 'Other ({{otherType}}), age requirement confirmed',
      idCheckSummaryAgeConfirmed: '{{idCheckType}}, age requirement confirmed',
      idCheckValueAgeConfirmed: 'Age requirement confirmed',
      idCheckSummaryOtherLabel: 'Other ({{otherType}})',
      idCheckValue: 'Birth date {{birthDate}}'
    },
    damaged: {
      damageType: 'Damage type',
      courierInput: 'Courier input',
      showPictureLink: 'Show picture {{idx}}',
      type: {
        A: 'Damage on parcel/wrapping',
        D: 'Pressure/squeeze damage',
        E: 'Complete damage'
      }
    },
    invoiceInitiationType: {
      automatic: 'Scheduled invoicing',
      'manual-department-level': 'Manual department invoicing by user',
      'manual-order-level': 'Manual order invoicing by user',
      'multiple-order-level': 'Manual invoicing of multiple orders by user'
    },
    autoDispatchFailedReason: {
      NO_MATCHING_ROUTE: 'No matching route found',
      DISPATCH_REJECTED: 'Failed to schedule optimization',
      RETRIES_EXHAUSTED: 'All retry attempts failed'
    },
    excludedFromInvoicingReason: {
      UNIT_NOT_SELF_BILLING_WITH_INTERNAL_TRADE:
        'Excluded automatically because the unit does not have both self billing and internal trade transaction active'
    },
    autoDispatchSucceeded: {
      matchedRange: 'Matched postal code range: {{from}}-{{to}}.',
      matchedPostalCode: 'Matched postal code: {{code}}.',
      viewRuleDetails: 'View rule details <a>here</a>',
      sentForOptimization: 'The order matched an auto-dispatch rule and has been sent for route optimization.'
    },
    invoiceCallback: {
      timeOfTransaction: 'Time of transaction',
      transactionNumber: 'Transaction number in {{systemId}}',
      invoiceLink: 'Click to view invoice'
    },
    changedFrom: 'Changed from -',
    blankText: '(blank)',
    name: 'Name',
    deliveryOrderedByReceiver: 'Parcel box delivery ordered by receiver',
    invoiceEventReason: {
      manuallySetByUser: 'Manually set by user',
      manualInvoiceInfo: 'Paused automatically because manual invoice information was provided on order'
    },
    unresolved: {
      missingPickupCoordinates: 'Missing pickup coordinates',
      missingDeliveryCoordinates: 'Missing delivery coordinates'
    },
    resolved: {
      source: {
        DepartmentLocation: 'department location',
        GeocodingAPI: 'Google',
        DatabaseLookup: 'pre-stored coordinates',
        PickupPointAPI: 'Pickup Point API',
        GlowFrontend: 'Glow',
        EDI: 'unknown',
        CustomerSite: 'customer site location',
        ParcelHub: 'ParcelHub',
        ParcelInMailbox: 'mailbox resolving job',
        Driver: 'driver',
        OriginalOrder: 'Original order',
        Google: 'Google',
        GoodsReturnAddress: 'goods return address'
      },
      pickup: {
        coordinatesSetBy: 'Pickup coordinates set by {{source}}',
        coordinatesManuallySet: 'Pickup coordinates have been manually set',
        coordinatesRestored: 'Pickup coordinates restored',
        coordinatesSwapped: 'Pickup coordinates set to previous delivery coordinates'
      },
      delivery: {
        coordinatesSetBy: 'Delivery coordinates set by {{source}}',
        coordinatesManuallySet: 'Delivery coordinates have been manually set',
        coordinatesRestored: 'Delivery coordinates restored',
        coordinatesSwapped: 'Delivery coordinates set to previous pickup coordinates'
      }
    },
    created: {
      recurringOrder: 'Created from recurring order.',
      showOriginalOrder: 'Show original',
      recurringRoute: 'Created from recurring route',
      recurringRouteLink: 'to route setup',
      showDuplicate: 'Show duplicate order',
      showOrder: 'Show order',
      fromThisOrder: 'Created from this order',
      fromOrder: 'Created from order'
    },
    outsideTimeWindow: {
      'delivered-outside-estimated-time-window': 'Estimated time window',
      'delivered-in-estimated-time-window': 'Estimated time window',
      'delivered-outside-service-time-window': 'Service time window',
      'picked-up-outside-estimated-time-window': 'Estimated time window',
      'picked-up-in-estimated-time-window': 'Estimated time window',
      'picked-up-outside-service-time-window': 'Service time window',
      actual: 'Actual delivery or deviation',
      actualPickup: 'Actual pickup or deviation'
    },
    deliveryInstructions: 'Delivery instructions'
  },
  jobs: {
    job: 'Job',
    lastStarted: 'Last Started',
    lastFinished: 'Last Finished',
    maxDuration: 'Max Duration',
    timeBetweenRuns: 'Time Between Runs',
    disable: 'Disable',
    enable: 'Enable',
    disabled: 'Disabled',
    disabledInConfig: 'Disabled in Config',
    mustBeASuperAdmin: 'You must be a Super Administrator to disable and enable jobs',
    showOnlyStruggling: 'Show only struggling jobs',
    runningLongerThanExpected: 'Running longer than expected',
    notStartedForLongerThanExpected: 'Has not started on time'
  },
  numberSeries: {
    numberSeries: 'Number Series',
    comparisonError: 'Maximum must be bigger than minimum',
    successfullyAdded: 'Number Series was successfully added to the list',
    successfullyDeleted: 'Number Series was successfully deleted',
    addNewNumberSeries: 'Add new number series',
    addedNumberSeries: 'Added number series',
    addedNumberSeriesSubHeading: 'Add number series (do not include check digits)',
    selectType: 'Select type',
    shipmentNumber: 'GSIN (Shipment Number)',
    packageNumber: 'SSCC (Package Number)',
    minimum: 'Minimum',
    maximum: 'Maximum',
    addNumberSeriesButton: 'Add number series to list',
    type: 'Type',
    currentNumber: 'Current number',
    maxNumber: 'Max number',
    numbersLeft: 'Numbers left',
    validMinimumValue: 'You must enter a valid minimum value',
    validMaximumValue: 'You must enter a valid maximum value',
    deleteModalTitle: 'Delete Number Series',
    deleteModalDescription: 'You will not be able to recover this action'
  },
  preadvice: {
    preadvice: 'Preadvice',
    hdDepartments: 'HS Departments',
    ceDepartments: 'C&E Departments',
    departmentGroups: 'Department groups',
    customers: 'Customers',
    customerGroups: 'Customer groups',
    customersCount: 'Customers',
    customerGroupsCount: 'Customer groups',
    showGroupMembers: 'Show group members',
    departmentsCount: 'Departments',
    departmentGroupsCount: 'Department groups',
    lockNotification: 'Lock notification',
    preadviceRule: 'Preadvice rule',
    locked: 'Preadvice locked',
    nameOfRule: 'Name of rule',
    updated: 'Preadvice updated',
    createNewPreadvice: 'Create new preadvice rule',
    searchPlaceholder: 'Type at least 3 characters to filter',
    nameDescription: 'Name and description',
    bizArea: 'Select business area',
    courierAndExpress: 'Courier and Express (C&E)',
    homeDelivery: 'Home Delivery (HD)',
    filterDepartmentAndGroups: 'Filter on departments or department groups',
    filterCustomersAndGroups: 'Filter on customers or customer groups',
    tabsWithErrors: 'Please address issues on the following tabs: {{tabs}}',
    selectedCustomers: 'Selected customers ({{count}})',
    noSelectedCustomers: 'No selected customers',
    customerSearch: 'Search field - Type at least 3 characters to search for customers',
    settingTargetDepartment:
      'This preadvice setting targets specific departments, remove all selected departments to be able to switch setting to department groups',
    settingTargetDepartmentGroups:
      'This preadvice setting targets specific department groups, remove all selected department groups to be able to switch setting to departments',
    settingTargetCustomers:
      'This preadvice setting targets specific customer, remove all selected customers to be able to switch setting to customer groups',
    settingTargetCustomerGroups:
      'This preadvice setting targets specific customer groups, remove all selected customer groups to be able to switch setting to customers',
    conflictHeading: 'There are some conflicts in your preadvice rules',
    conflictingRules: 'Conflicting rules',
    deletePreadviceDescription:
      'Deleting will remove all the notifications settings and the recipient or sender will no longer get any communication. You cannot undo this action.',
    rule: 'Rule',
    ruleTrigger: 'Preadvice on',
    type: 'Type',
    trigger: 'Trigger',
    action: 'Variant',
    result: {
      NO_RULE: 'No matching rule',
      NO_DELIVERY_TIME_WINDOW: 'No delivery time window found',
      SMS_SENT: 'Preadvice rule checked. Adding SMS to queue',
      EMAIL_SENT: 'Preadvice rule checked. Adding Email to queue',
      SMS_AND_EMAIL_SENT: 'Preadvice rule checked. Adding SMS and EMAIL to queue',
      NO_VALID_PHONE_OR_EMAIL: 'No valid phone number or email address',
      FEATURE_OFF: 'Preadvice is switched off',
      ALREADY_PRE_ADVICED: 'Delivery time window already set. No action taken',
      CANCELLED: 'Preadvice cancelled',
      WAITING_FOR_PACKAGES: 'All packages have not arrived at terminal',
      ALREADY_IN_PROGRESS: 'Waiting for recipient to select delivery time',
      ERROR: 'An error occured',
      WRONG_TRIGGER: 'Trigger not matching rule. Ignoring.',
      MANUAL_ATTEMPT: 'Preadvice attempts manually incremented',
      PRE_ADVICE_LIMIT_REACHED: 'Preadvice limit reached',
      PRE_ADVICE_LOCKED: 'Preadvice is locked',
      ORDER_DELIVERED: 'Order is already delivered',
      RETURN_LAST_LEG_CREATION_SKIPPED: 'Return leg not created'
    },
    error: {
      PRE_ADVICE_RULE_COLLISIONS: {
        label: 'Rule conflict!',
        detail: 'Rule for {{service}} will override rule in {{policySetNames}} through relation to {{relations}}.',
        department: 'department',
        department_group: 'department group',
        customer: 'customer',
        customer_group: 'customer group'
      }
    },
    noPoliciesFound: 'No Preadvice settings',
    policies: 'Preadvice settings',
    copyText: 'Copy text',
    customerInGroupTitle: 'Customers in {{groupName}}',
    policy: {
      exception: 'Exception',
      deleteConfirm: 'Are you sure you want to delete this set of preadvice rules?',
      name: 'Name',
      new: 'New preadvice setting',
      edit: 'Edit preadvice setting',
      description: 'Description',
      save: 'Save',
      saveAnyway: 'Save anyway',
      servicePolicies: 'Preadvice rules',
      targets: 'Customer-/department settings',
      servicePoliciesDescription:
        'Depending on which type of notification you select, different input fields will be displayed',
      servicePolicy: {
        edit: 'Edit settings',
        new: 'Add service preadvice settings',
        cutOff: 'Cut off',
        remove: 'Remove selected',
        serviceCode: 'Service',
        serviceCodeLegend: 'Add service code eg. 3123',
        vasCode: 'VAS',
        vasCodeLegend: 'Add optional value Adding service, e.g. SWAP',
        sameDay: 'SameDay',
        returnToCustomer: 'Return to customer',
        reminderToCustomer: 'Reminder to customer',
        redirectToPuP: 'Redirect to pickup point',
        sameDayTitle: 'Allow same day bookings before cutoff',
        yesRecipientShouldChange: 'Yes, recipient should be able to change',
        noRecipientShouldNotChange: 'No, recipient should not be able to change',
        recipientCanCancelBookedTimeSlot: 'Recipient will be able to cancel the booked time slot.',
        sameDayLegend: 'Tick in this box if you want the shipment to be delivered with Same Day Service.',
        triggerEvent: 'Preadvice on',
        triggerEventTitle: 'Trigger preadvice',
        triggerEventLegend:
          'What should trigger the preadvice send out. When we get the EDI to GLOW, when the packages are received at HUB or received at DIP or if it should not be triggered you select MANUAL.',
        cutoff: 'Cutoff',
        cutoffLegend:
          'What is the cutoff time for when we will no longer offer the receivers the first available time slot in the calendar and instead offer next day.',
        relativeCutoffMinutes: 'Cutoff minutes',
        relativeCutoffMinutesLegend:
          'Minimum number of minutes from time of preadvice to next available time window. Overrides cutoff time.',
        calendarDays: 'Calendar days',
        goodsRedirectToPickupPoint: 'Goods will be redirected to pickup point after 1 delivery attempt',
        dateAndTimeChangeBookingPageTitle: 'Date and time changes on booking page.',
        calenderDaysTitle: 'Specify the number of days to display to the recipient on the booking page',
        calendarDaysLegend: 'How many days should we display to the receiver in the calendar.',
        noServicePoliciesFound: 'No settings added yet',
        returnToSenderAfterDays: 'Return to sender',
        returnToSenderAfterDaysLegend:
          'After how many days should we send back the shipment in return to the sender. This is if we have not been able to reach the receiver.',
        scheme: 'Type',
        schemeLegend: 'What type of preadvice should we send. Push, Pull, Return or Pick up parcel.',
        searchCustomer: 'Search customer',
        remindAfterHours: 'Reminder to receiver',
        remindAfterHoursLegend:
          'This is used for Pull and PUP preadvice. After how many hours we should send a reminder to the recipient saying they have to book a delivery time.',
        preAdviceAttempts: 'Preadvice attempts',
        preAdviceAttemptsLegend:
          'How many reminders should be sent before the shipment will go in return to the sender.',
        reminderToSenderAfterHours: 'Reminder to sender',
        reminderToSenderAfterHoursLegend:
          'This is a reminder to the sender that we have not been able to reach the recipient. The shipment will be returned.',
        deliveryAttempts: 'Delivery attempts',
        deliveryAttemptsTitle: 'After maximum delivery attempts are reached - the package will be returned to customer',
        deliveryAttemptsChoiceTitle: 'What should happen after maximum delivery attempts reached',
        deliveryAttemptsLegend:
          'How many delivery attempts should be made before the shipment should go in return to sender.',
        pickupAttempts: 'Pickup attempts',
        pickupAttemptsTitle: 'Maximum pickup attempts',
        pickupAttemptsDescription:
          'When pickup attempts are reached we inform the customer that there’s nothing to return due to pickup deviation',
        label: {
          days: 'Days',
          hours: 'Hrs',
          smss: '#'
        },
        legend: {
          days: 'Days',
          hours: 'Hours',
          smss: 'Max number of SMSes'
        },
        returnToPup: 'Return to pickup point',
        addNewRule: 'Add new rule',
        enableCancelBookingTimes: 'Enable cancellation on booking page',
        typeOfOrders: 'Type of orders',
        ordersWithDate: 'Orders with date',
        ordersWithoutDate: 'Orders without date',
        ordersWithAndWithoutDate: 'Orders with and without date',
        emailToCustomer: 'Email to customer',
        triggerEventType: {
          EDI: 'EDI',
          HUB: 'HUB',
          DIP: 'DIP',
          MANUAL: 'MANUAL'
        }
      }
    },
    tooltip: 'Locking the order = no notification is sent to recipient',
    customerCode: 'Customer code'
  },
  formValidation: {
    mustProvideName: 'You must provide name',
    mustProvideDescription: 'You must provide description',
    mustProvideServiceCode: 'You must provide service code',
    mustProvideCalendarDays: 'You must provide calendar days',
    mustProvideCutOffTime: 'You must provide cutoff time',
    mustProvideCutOffMinutes: 'You must provide cutoff minutes',
    mustProvideDeliveryAttempts: 'You must provide delivery attempts',
    mustProvideCustomer: 'You must provide customer',
    mustProvideQuantity: 'You must provide quantity',
    mustProvideArticle: 'You must provide article',
    mustProvideDate: 'You must provide a date',
    mustProvideCustomerOrUnitAmount: 'You must provide customer or unit amount',
    allowedRangeIs: 'Allowed range is {{min}} - {{max}}',
    mustProvideTime: 'You must provide time',
    mustProvideDuration: 'You must provide duration'
  },
  holidays: {
    holidays: 'Holidays',
    holiday: 'Holiday',
    dayBeforeHoliday: 'Day before holiday',
    addHoliday: 'Add new holiday',
    country: 'Country',
    type: 'Type',
    date: 'Date',
    successfullyAdded: 'Holiday was successfully added to the list',
    successfullyDeleted: 'Holiday was successfully deleted',
    filterOnCountry: 'Filter on country',
    selectHolidayType: 'Select holiday type',
    addHolidayToList: 'Add holiday to list',
    selectCountry: 'Select country',
    addedHolidays: 'Added holidays',
    deleteModalTitle: 'Delete Holiday',
    deleteModalDescription: 'You will not be able to recover this action'
  },
  distributionMapping: {
    title: 'Distribution mapping',
    addDips: 'Add DIP',
    addedDips: 'Added DIP location ({{count}})',
    addedDips_other: 'Added DIP locations ({{count}})',
    connectedToPickupPoints: 'Connected to {{count}} Pickup Point',
    connectedToPickupPoints_other: 'Connected to {{count}} Pickup Points',
    emptyTitle: 'No connected Distribution Points (DIP)',
    emptyDescription:
      'You first need to select a DIP in order to add Pickup Points.\nClick on the button at the top right to get started.',
    addDipModalTitle: 'Add Distribution mapping',
    addDipModalDescription: 'Select the DIP you want to add Pickup Points to',
    selectDipLabel: 'Search for distribution point (DIP)',
    searchPlaceholder: 'PUP ID, name or address',
    selectButton: 'Select',
    editDip: 'Edit {{name}}',
    selectPickupPointHeading: 'Select the Pickup Point you want to add to DIP',
    selectPickupPointLabel: 'Search for Pickup point (PUP)',
    addedPickupPoints: 'Added Pickup Points to DIP',
    removePickupPoint: 'Remove {{name}}',
    editPickupPoint: 'Edit {{name}}',
    editPickupPointDescription: 'Select the days when the PUP can get deliveries',
    deliveryDays: 'Delivery days',
    deliveryDaysHint: 'Select the days the pickup points can get deliveries',
    addPickupPoint: 'Add Pickup Point',
    saveToast: 'Distribution mapping for {{name}} saved',
    addLocations: 'Add locations',
    removeDip: 'Remove {{name}}',
    removeDipQuestion: 'Remove {{name}} from the distribution mapping?',
    removeDipDescription: 'Its connected pickup points lose their DIP.',
    removeConnectionQuestion: 'Remove the connection to {{name}}?',
    removeConnectionDescription: 'The pickup point will have no DIP until it is connected again.',
    alreadyAdded: 'This pickup point is already on this DIP. Adding it again replaces its delivery days.',
    alreadyMappedToOtherDip:
      'This pickup point is already connected to {{dip}}. Remove it from that DIP before adding it here.',
    loadFailed: 'Could not load the distribution mapping. Try again, or reload the page.',
    errorSelectPickupPoint: 'You need to select a pickup point',
    errorSelectDeliveryDay: 'You need to select at least one delivery day',
    errorSelectDip: 'You need to select a DIP',
    deleteToast: '{{name}} was successfully deleted'
  },
  department: {
    region: 'Region',
    general: 'General',
    plannedStopLocations: 'Planned stop locations',
    plannedStopLocationsDescription: 'Here you can add all the planned stop locations for route planning optimization.',
    plannedStopLocationName: 'Planned stop location name',
    plannedStopLocationIsTerminal: 'Counts as a terminal address for this department',
    plannedStopLocationIsTerminalTooltip:
      "Only relevant for departments with more than one terminal address. This address is then used in addition to the department's default address.",
    addPlannedStopLocation: 'Add planned stop location',
    departmentTitle: 'Department',
    departmentsLabel: 'departments',
    labels: 'Labels',
    labelsDescription:
      'Create labels to build filtering rules for this department. Labels within the same category are matched using <bold>OR</bold> logic, while different categories are combined using <bold>AND</bold> logic. Remember to assign the labels to your routes for the filtering to take effect.\n' +
      '\n' +
      'If labels have been created for a department, users will be asked to select which labels they want to display the first time they open the <bold>Routes overview</bold> page. They can change their selection at any time using the regular filter panel on the <bold>Routes overview</bold> page. Their selection is saved in the browser. Read more here (or in the “What’s this”-modal): <supportLink>Labels (Only for Parcel Norway departments) – GLOW Support</supportLink>',
    labelsCategory: 'Category',
    labelsCategoryHint: 'Use an existing category name to add more labels to the same group.',
    labelName: 'Label name',
    existingLabels: 'Existing labels',
    labelsEmpty: 'No labels have been created yet.',
    labelsPreview: 'Preview',
    labelsPreviewEmpty: 'Select labels to preview how the filtering logic will be built.',
    labelsDuplicate: 'This label already exists in the selected category.',
    labelsNotAdded: 'Click Add to add the label before saving.',
    nameRequired: 'Name is required',
    addressRequired: 'Address is required',
    zipCodeRequired: 'Zip code is required',
    zipAreaRequired: 'Area is required',
    labelsCategoryRequired: 'Category is required',
    labelNameRequired: 'Label name is required',
    departmentTypeRequired: 'Department type is required',
    departmentIdRequired: 'Department ID is required',
    descriptionRequired: 'Description is required',
    regionRequired: 'Region is required',
    minutesAfterOrderArrivalRequired: 'Minutes after order arrival is required',
    createLabels: 'Create labels',
    departmentWithCount: '{{count}} department',
    departmentWithCount_other: '{{count}} departments',
    departmentGroups: 'Department groups',
    numberOfDepartmentGroups: 'Department groups',
    numberOfDepartments: 'Number of departments',
    search: 'Search for departments',
    searchGroups: 'Search for department groups',
    noDepartmentsFound: 'No departments found',
    noDepartmentGroupsFound: 'No department groups found',
    manageDepartment: 'Manage department',
    searchDepartmentByNameOrId: 'Filter by department name or department ID',
    searchDepartmentGroups: 'Search for group name or description',
    noDepartmentName: 'Name is missing',
    noDepartmentId: 'Id is missing',
    noCouriers: 'No couriers',
    courierCount_other: '{{count}} couriers',
    courierCount: '{{count}} courier',
    noCourier: 'No couriers',
    couriers: 'Number of couriers',
    plannerCount_other: '{{count}} planners',
    plannerCount: '{{count}} planner',
    noPlanner: 'No planners',
    planners: 'Number of planners',
    choose: 'Choose department',
    new: 'New department',
    description: 'Description',
    name: 'Name',
    created: 'Department created',
    updated: 'Department updated',
    departmentType: 'Department type',
    notSet: 'Not set',
    courier: 'Courier',
    express: 'Express',
    hd: 'Home Delivery',
    h2: 'H2',
    parcel: 'Parcel',
    posten: 'Posten',
    other: 'Other',
    all: 'All',
    deliveryDisplayType: 'Delivery time display',
    terminalName: 'Terminal name',
    terminalNameTooltip: 'If pickup and department name is different, fill in this information',
    selectArea: 'Select area...',
    address: 'Address',
    zipCode: 'Postal Code',
    zipArea: 'Area',
    autoRecurrentTime: 'Auto recurrent time',
    autoInvoiceTitle: 'Automatic invoicing',
    autoInvoiceEnable: 'Set automatic invoicing',
    autoInvoiceTime: 'Time',
    autoInvoiceOffset: {
      legend: 'What orders should be invoiced',
      oneDayEarlier: 'Delivered 1 day ago',
      twoDaysEarlier: 'Delivered 2 days ago',
      threeDaysEarlier: 'Delivered 3 days ago',
      fourDaysEarlier: 'Delivered 4 days ago',
      fiveDaysEarlier: 'Delivered 5 days ago'
    },
    autoDispatchSettings: {
      title: 'Automatic dispatching of pickup orders',
      enable: 'Set automatic dispatching of pickup orders',
      minutesAfterOrderArrival: 'Minutes after order arrival',
      startTime: 'Start time'
    },
    unitNumber: 'Unit number',
    emailAddress: 'Email Address',
    npsId: 'NPS ID',
    defaultAlystraUnitId: 'Selfbilling unit ID',
    timeWindow: 'Time window',
    pickupEarliest: 'Earliest pickup',
    pickupLatest: 'Latest pickup',
    deliveryEarliest: 'Earliest delivery',
    deliveryLatest: 'Latest delivery',
    listAllDepartments: 'List all departments',
    listAllGroups: 'List all department groups',
    successUpdate: '{{name}} was successfully updated',
    editDepartment: 'Edit {{name}}',
    createNewDepartment: 'Create new department',
    addressAndContact: 'Address and contact information',
    searchAddressError: 'Missing values for address. You must use the search field in order to get the correct address',
    addressContactIngress:
      'In order to get the correct address, use the search field. The address, postal code and city will be filled out automatically.',
    settingsInGlow: 'Settings on recipient tracking page',
    settingsBodyText:
      'Depending on your selection, different content and communication will be displayed/sent to the recipients.',
    tooltipNPSID:
      'NPS ID = Glow can send out NPS recipient satisfaction measuring. This is where the unique identifier for each department is filled out',
    tooltipTerminal: 'If pickup and department name is different, fill in this information',
    removeRow: 'Remove row',
    cutoff: 'Cutoff',
    regular: 'Regular',
    sameDay: 'Same day',
    weekdays: 'Weekdays',
    saturdays: 'Saturdays',
    sundays: 'Sundays',
    setTimeWindow: 'Set time window',
    setTimeWindowToDepartment: 'Set time window to department',
    updateTimeWindow: 'Update time window',
    timeWindowTitle: 'Day delivery logic',
    timeWindowIngress:
      'On which days should this department do deliveries? For each day, please fill in either all of the values, or none of the values.',
    orderBillingType: {
      title: 'Order billing type',
      selectBillingType: 'Select Billing Type',
      apollo: 'Apollo',
      h2: 'H2',
      pickup: 'Pickup',
      customerBillingNumber: 'Customer billing number',
      addMoreOrderBillingInfo: 'Add New Order Billing Type',
      internalTrade: 'Internal trade'
    },
    departmentId: 'Department ID',
    clearTime: 'Clear time',
    delegatedDepartment: 'Delegated department',
    disableSms: 'Disable Tracking and ETA SMS on Route',
    smsShouldNotBeSent: 'Tracking and ETA SMS should not be sent to recipients in routes produced on this department.',
    routePlanning: 'Route planning',
    autoRouteCreationTime: 'Auto route creation',
    autoRouteOptimizationTime: 'Auto route optimization'
  },
  departmentGroup: {
    departmentGroupDeleted: '{{name}} was deleted',
    departmentGroup: 'Department Group',
    name: 'Name',
    edit: 'Edit department group',
    manageDepartments: 'Manage departments in group',
    selectAllFor: 'Select all for {{name}}',
    selectedDepartments: 'Selected departments ({{count}})',
    deleteConfirm: 'Are you sure you want to delete this department group?',
    noSelectedDepartments: 'No selected departments',
    selectedCountries: '{{count}} selected country',
    selectedCountries_other: '{{count}} selected countries',
    countries: 'Countries',
    allDepartmentTypes: 'All department types',
    selectedDepartmentTypes: '{{count}} selected department type',
    selectedDepartmentTypes_other: '{{count}} selected department types',
    departmentTypes: 'Department types',
    youMustSelectDepartment: 'You must select department',
    createDepartmentGroup: 'Create new department group',
    type: 'Type',
    types: {
      DEFAULT: 'Default',
      FOLLOW_UP: 'Follow-up',
      INVOICING: 'Invoicing',
      PLANNING: 'Planning',
      PREADVICE: 'Preadvice',
      REGION: 'Region',
      SEARCH: 'Search'
    }
  },
  deliveryDisplayType: {
    instant: 'Instant',
    customized: 'Customized'
  },
  templateRouteRules: {
    title: 'Manage Route Rules',
    ruleName: 'Rule name',
    type: 'Type',
    POSTAL_CODE: 'Postal code',
    searchPlaceholder: 'Search by name or type',
    createNew: 'Create new rule',
    createNewRule: 'Create new route rule',
    edit: 'Edit',
    settings: 'Settings',
    assignToTemplateRoutes: 'Template routes',
    connectedToRule: 'connected to "{{name}}"',
    noTemplateRoutesInDepartment: 'No template routes available in this department',
    templateHasNoRoutes: 'The selected template has no routes',
    noRecurringRoutesInDepartment: 'No recurring routes available in this department',
    template: 'Template',
    selectTemplate: 'Select template',
    templateRoute: 'Template route',
    selectTemplateRoutes: 'Select template routes',
    assignedTemplateRoutes: 'Assigned template routes ({{count}})',
    noAssignedTemplateRoutes: 'No template routes assigned yet',
    assignToRecurringRoutes: 'Recurring routes',
    recurringRoute: 'Recurring route',
    selectRecurringRoutes: 'Select recurring routes',
    assignedRecurringRoutes: 'Assigned recurring routes ({{count}})',
    noAssignedRecurringRoutes: 'No recurring routes assigned yet',
    atLeastOneRule: 'Add at least one postal code rule',
    successfullyAdded: '{{name}} was successfully added',
    successfullyUpdated: '{{name}} was successfully updated',
    successfullyDeleted: 'Route rule was successfully deleted',
    deleteRule: 'Delete route rule',
    deleteRuleDescription: 'Are you sure you want to delete this route rule?',
    serviceExclusion: 'Service exclusion',
    serviceExclusionDescription: 'Orders with one of these service codes are never assigned to routes by this rule.',
    serviceCode: 'Service code',
    addServiceCode: 'Add service code',
    excludedServices: 'Excluded services',
    noExcludedServices: 'No services excluded',
    serviceCodeRequired: 'Enter a service code',
    serviceCodeAlreadyExcluded: '{{code}} is already excluded',
    removeServiceCode: 'Remove {{code}}'
  },
  menu: {
    distributionMapping: 'DIP mapping',
    defaultDisabled: 'Select one customer to enable this menu item',
    backToOldShipmentsPage: 'Back to old site',
    home: 'Home',
    manageRouteRules: 'Manage Route Rules',
    admin: 'Administration',
    planner: 'Planner',
    volumeReport: 'Volume Reports',
    openSearch: 'Open Search',
    report: 'Reports',
    customer: 'Customer',
    apiOrder: 'Find API order',
    support: 'Support',
    priceMotor: 'Pricing Engine',
    mainNavigation: 'Main navigation',
    closePanel: 'Close panel',
    expandPanel: 'Expand panel',
    goToHomepage: 'Go to homepage',
    departments: 'Departments',
    users: 'Users',
    customers: 'Customers',
    customerGroups: 'Customer Groups',
    numberSeries: 'Number Series',
    optimizing: 'Optimizing',
    services: 'Services',
    matrix: 'Matrix',
    jobsMonitoring: 'Jobs Monitoring',
    holidays: 'Holidays',
    shd: 'SHD',
    settings: 'Settings',
    preadvice: 'Preadvice',
    cms: 'CMS',
    userRoles: 'User Roles',
    integrations: 'Integrations',
    live: 'Live',
    routePlanning: 'Route Planning',
    dispatching: 'Dispatching',
    booking: 'Booking',
    h2Booking: 'H2 Booking',
    setCoordinates: 'Set coordinates',
    shipments: 'Shipments',
    corrections: 'Corrections',
    units: 'Units',
    couriers: 'Couriers',
    vehicles: 'Vehicles',
    recurring: 'Recurring',
    importExport: 'Import / Export',
    addresses: 'Addresses',
    invoicing: 'Invoicing',
    pickupOrders: 'Pickup Orders',
    billingOrder: 'Billing Order',
    manageReturns: 'Manage Returns',
    preAdviceFollowup: 'Preadvice followup',
    vendors: 'Vendors',
    productionTimeWindow: 'Production time window',
    routesOverview: 'Routes overview'
  },
  planner: {
    users: 'Users',
    colorPicker: 'Color picker',
    chooseYourDepartment: 'Choose your department',
    unassignedShipments: 'Unassigned shipments',
    filterCustomers: 'Filter customers',
    filterServices: 'Filter services',
    autoRoute: 'Auto route',
    saved: 'Saved',
    allUserRoles: 'All user roles',
    userRolesCount_other: '{{count}} user roles',
    createNewUser: 'Create new user',
    userRolesCount: '{{count}} user role',
    role: 'Role',
    searchForNameOrNumber: 'Search for name or phone number',
    noPlannersFound: 'No planners found',
    typeOfRole: 'Type of user role',
    selectUserRole: 'Select user role',
    secondTab: 'Second tab',
    removeDepartment: 'Remove department {{name}}',
    youMustProvideName: 'You must provide name of user',
    youMustProvidePhonenumber: 'You must provide phone number',
    showInGoogleMaps: 'Show route in Google Maps',
    detailedAccessRights: 'Detailed access rights for {{name}}',
    autoRouteModal: {
      selectRoutes: 'Select routes',
      selectRoutesText:
        'Select routes to include in automatic routing. Only routes with status Created or Assigned are available. For routes already in progress, use Add to route to dispatch shipments.',
      routesStartedRemoved: '{{routes}} has started and was removed from the selection',
      routesStartedRemoved_other: '{{routes}} have started and were removed from the selection',
      lockAllToSlot: 'Lock all assigned shipments to slot',
      useMapAreaRestrictions: 'Use map area restrictions',
      usePostalCodeRestrictions: 'Use postal code restrictions',
      useGraphHopper: 'Use GraphHopper',
      usePtv: 'Use PTV',
      usePtvPilot: 'Premium optimization',
      useKardinal: 'Use Kardinal',
      useHere: 'Use HERE',
      useHexaly: 'Use Hexaly',
      useHexalyCloud: 'Use Hexaly Cloud',
      timeLimitInSeconds: 'Time limit in seconds',
      timeLimitByStops: 'Empty: based on the size of the plan',
      timeLimitAsMinutes: '= {{minutes}} min {{seconds}} s',
      timeLimitOutOfRange: 'Enter whole seconds between 10 and 2700 (45 minutes)',
      timeLimitExample: 'e.g. 60',
      useNoEngine: 'Use no optimization engine for this specific route',
      optimizeOn: 'Optimize on',
      noRelevantRoutes: 'No relevant routes found',
      startAutomaticRouting: 'Start automatic routing',
      selectOptimizingEngine: 'Select optimizing engine',
      useFlexAndForceFromPrevious: 'Use flex and force from previous optimizations'
    },
    wait: 'Wait',
    trips: 'Trips',
    searchSlotCourierName: 'Search slot/courier name',
    createdBy: 'Created by',

    connectDepartment: 'Connect department to user',
    banner: {
      tryNewRoutePlanner:
        "1st of May, <0>route planner 2.0</0> will be the only available route planner. If you haven't used the route planner before, we encourage you to start using it from now. <1>Read more on Zendesk</1> and other related articles to get an overview of how it works."
    },
    totalTitle: 'Packages',
    pickList: 'Pick list',
    export: 'Export for invoicing',
    deleteSlot: 'Delete',
    editSlot: 'Edit',
    deleteSlotConfirmDialogText: 'Are you sure, you want to delete this slot?',
    created: 'Planner created',
    updated: 'Planner updated',
    deleted: 'Planner has been deleted',
    confirmDelete: 'Are you sure you want to delete this user?',
    live: 'Live',
    routePlanning: 'Route planning',
    vehicles: 'Vehicles',
    routePlanningConsignmentsAssigned: 'assigned',
    routePlanningRangeDescription: 'Filter shipments by delivery time',
    unresolvedConsignments: 'Unresolved',
    consignments: 'Shipments',
    couriers: 'Couriers',
    units: 'Units',
    invoicing: 'Invoicing',
    planner: 'Planner',
    planners: 'Planners',
    noPlanners: 'No planners',
    missingId: 'Id missing',
    missingName: 'Name missing',
    search: 'Search',
    searchForPlanner: 'Search for planners',
    name: 'Name',
    phoneNumber: 'Phone number',
    canLogIn: 'Can log in',
    selectDepartments: 'Select departments',
    createSlot: 'Create slot',
    editSlotForm: 'Edit slot',
    routeUpdated: 'Route details updated',
    createSlotFormName: 'Slot name',
    createSlotFormUnit: 'Unit',
    createSlotFormCourier: 'Courier',
    createSlotFormSlotMode: 'Slot mode',
    createSlotFormSlotModePickup: 'Draw pickup area on map',
    createSlotFormSlotModeDelivery: 'Draw delivery area on map',
    createSlotFormSlotModeManual: 'Manually select shipments',
    createSlotFormSlotModeSelected: 'Selected shipments',
    createSlotFormTimeRange: 'Time range',
    createSlotFormStartLocation: 'Start location',
    createSlotFormEndTime: 'End time',
    createSlotFormEndLocation: 'Stop location',
    createSlotFormSlotColor: 'Slot color',
    createSlotFormTimeRangeTooBig: 'Time range is too big. Max is {{hours}} hours.',
    createSlotFormFilterCustomers: 'Filter customers',
    createSlotFormFilterServices: 'Filter services (none checked means all)',
    slotFilterInfo:
      'This slot has been filtered, meaning that only shipments belonging to the chosen customer(s) and the chosen service(s) can be connected to the slot.',
    slotFilteredCustomer: 'The slot ONLY includes orders from the following customers',
    slotFilteredService: 'The slot ONLY includes orders with the following services',
    onlyShowApplicable: 'Only show orders applicable for this slot based on the customer/service filtering',
    optimizeButtonLabel: 'Optimize and assign routes',
    optimizeSlotButtonLabel: 'Re-optimize slot',
    reversedOptimizeSlotButtonLabel: 'Reverse delivery order',
    optimizingSince: 'Optimizing in progress, started at {{startTime}}',
    addToRoute: 'Add to route...',
    pickup: 'Pickup',
    delivery: 'Delivery',
    depot_call: 'Planned stop',
    slot: 'Slot',
    notAssigned: 'Not assigned',
    readOnly: 'Read only',
    normal: 'Normal',
    plus: 'Plus',
    partner: 'Partner',
    readOnlyAccessPlannersWithCount: '{{count}} planners with read only access',
    plusPlannersWithCount: '{{count}} plus Planners',
    normalPlannersWithCount: '{{count}} normal Planners',
    saveTemplate: 'Save as template',
    loadTemplate: 'Load from template',
    routeListForFilteredSlots: 'Receipt list (print all)',
    loadListForFilteredSlots: 'Load list (print all)',
    deleteFilteredSlots: 'Delete all slots',
    deleteAllSlotsConfirmDialogText: 'Are you sure you want to delete all slots?',
    sendPrePickupSmsesToAll: 'Pre send tracking sms',
    alertBeforeSendingPrePickupSms: 'Are you sure you want to pre-send tracking SMS for all slots for today?',
    newTemplate: 'Create a new template',
    selectTemplate: 'Select template',
    deleteTemplate: 'Delete',
    templateDeleteConfirm: 'Are you sure you want to delete this template?',
    missingDeliveryMarker: 'Not a valid delivery address or location',
    missingPickupMarker: 'Not a valid pickup address or location',
    assignConsignmentFromSlot: 'Assign shipment to {{routeName}}?',
    unassignConsignmentFromSlot: 'Unassign {{count}} shipment from route?',
    unassignConsignmentFromSlot_other: 'Unassign {{count}} shipments from route?',
    unassignBulkConsignmentsFromSlotsAlert: 'Remove shipments from their respective slots?',
    unassignedFromSlot: 'Shipment has now been unassigned from the route',
    unassignBulkConsignmentsFromSlots: 'Shipments have now been unassigned from their respective slots',
    unassignButton: 'Unassign from slot',
    forceUnassignButton: 'Force unassign from slot',
    driverName: 'Driver',
    deliveries: 'Deliveries',
    returns: 'Returns',
    installations: 'Installations',
    curbside: 'Curbside',
    label: 'Label',
    filters: {
      assigned: 'Assigned',
      unassigned: 'Unassigned',
      pickups: 'Pickups',
      deliveries: 'Deliveries'
    },
    saveSelected: 'Save selected ({{count}})',
    showSaved: 'Show saved ({{count}})',
    showAll: 'Show all',
    clearSaved: 'Clear saved',
    sendPrePickupSms: 'Pre-send tracking SMS to recipient',
    sendSms: 'Send SMS',
    sendingSmsText: 'Pre-sending {{count}} tracking SMS',
    prePickupSmsSent: '{{sentCount}} out of {{totalCount}} tracking SMS pre-sent',
    manualDelaySms: {
      smsSent: '{{count}} manual delay SMS sent',
      heading: 'Manual Delay SMS',
      sendingSmsText: 'Sending {{count}} manual delay SMS',
      selectSmsDescription:
        'The SMS will start with "Hi! Your delivery from Sender is unfortunately delayed.". Select the SMS ending below.',
      selectSmsEnding: 'Select how the SMS should end',
      selectSmsBeginning: 'Select how the SMS should begin',
      previewLabel: 'SMS preview',
      buttonTitle: 'Send',
      beginningType: {
        hi: '"Hi!"',
        none: 'None',
        fromSender: '"Your delivery from Sender is unfortunately delayed."',
        highDemand: '"Due to high demand, your goods cannot be delivered as planned."'
      },
      endingType: {
        none: 'None',
        soon: '"We\'ll try to deliver as fast as possible."',
        tomorrow: '"We\'ll try to deliver next working day."',
        whenShipmentHasArrived:
          '"A new delivery date and time will be provided once the shipment reaches the terminal."',
        newDeliveryTime: '"We will deliver this to you on the next available delivery day."',
        newDeliveryTimeFullEnding:
          '"A new delivery is scheduled for [DATE] [TIMESLOT]. You can change the delivery time via [TRACKINGLINK]. Regards Bring"'
      },
      disabledTooltip: 'Orders cannot be in state Delivered'
    },
    delayedShipmentNotification: {
      description:
        'The recipient will receive an SMS stating that the shipment is delayed and that a new delivery date and time will be sent once the shipment reaches the terminal.',
      resetDescription:
        'When you confirm, the selected shipments will be reset and removed from route if they are assigned.',
      gScanDescription:
        'After terminal arrival is registered, the recipient will be notified again according to the preadvice rules.',
      successMessage: 'Delayed shipment workflow started successfully'
    },
    rescheduledShipmentNotification: {
      description: 'The delivery will be moved to a new date and time.',
      autoUpdateDescription:
        'The recipient will get an SMS saying that the delivery will not arrive today as planned. The message also includes the new date and time, and a link where they can change the delivery if needed.'
    },
    h2: {
      booking: 'H2 Booking',
      vasHelperText: 'Use VAS 1158 for MBH'
    },
    loadList: {
      address: 'Address',
      customerRef: 'Customer reference',
      date: 'Date',
      deliveries: 'Deliveries',
      distance: 'Distance',
      estimatedLoadTime: 'ELT',
      estimatedTotalTime: 'Est. time',
      header: 'Route summary',
      instructions: 'Delivery instructions,\nphone,\nreceiver ref',
      instructionsPhone: 'Tel:',
      instructionsRef: 'Receiver ref:',
      listName: 'Load list',
      name: 'Name',
      qty: 'Qty',
      routeName: 'Route',
      service: 'Service\n(VAS)',
      stopOrder: 'Stp ord',
      summary: 'Summary',
      time: 'Time',
      timeWindow: 'Time window (ETA-ETD)',
      tripNumber: 'Trip',
      totalDistance: 'Total distance',
      totalTime: 'Total time',
      unit: 'Unit',
      volume: 'Vol\nm³',
      weight: 'Wt\nkg',
      zipArea: 'Area',
      zipCode: 'Postal code',
      unknownRouteName: 'Unknown route name',
      unknownUnitName: 'Unknown unit name',
      noDataText: 'Nothing to see here',
      utilization: 'Utilization'
    },
    locationList: {
      listName: 'Location list'
    },
    assignedUnits: 'Assigned units',
    unassignedUnits: 'Unassigned units',
    noUnitSelected: 'No unit selected',
    unitAssignmentCount: 'Unit assigned to {{count}} routes',
    breakDeletedFromRoute: 'Break time was successfully deleted from route',
    favouriteDepartments: 'Favourites',
    addFavouriteDepartment: 'Add favourite: {{department}}',
    removeFavouriteDepartment: 'Remove favourite: {{department}}',
    largeDepartmentGuard: {
      validationMessage:
        'The selected department group {{departmentGroup}} contains too many routes and cannot be used on {{page}}. Please select another department group or department.'
    }
  },
  updateServiceLevel: {
    menuItem: 'Change service level',
    selectOption: 'Select service level',
    heading: 'Change service level',
    confirmation: 'Service level updated',
    subtext: 'Change service level for {{count}} shipment',
    subtext_other: 'Change service level for {{count}} shipments',
    failed: {
      title: 'Failed to change service level',
      message: 'Failed to change service level for {{count}} shipment',
      message_other: 'Failed to change service level for {{count}} shipments'
    }
  },
  manualPreAdvice: {
    menuItem: 'Manual preadvice',
    selectOption: 'Select preadvice type',
    heading: 'Manual preadvice',
    confirmation: 'Preadvice request(s) saved',
    subtext: 'Request preadvice for {{count}} shipment',
    subtext_other: 'Request preadvice for {{count}} shipments',
    failed: {
      title: 'Failed to save preadvice requests',
      message: 'Failed to request preadvice for {{count}} shipment',
      message_other: 'Failed to request preadvice for {{count}} shipments'
    }
  },
  setPickupDeliveryDuration: {
    menuItem: 'Set pickup/delivery times',
    heading: 'Set pickup and delivery times',
    subtext: 'Set pickup and delivery times for {{count}} shipment',
    subtext_other: 'Set pickup and delivery times for {{count}} shipments',
    pickupPreparation: 'Pickup preparation',
    pickupDuration: 'Pickup duration',
    deliveryPreparation: 'Delivery preparation',
    deliveryDuration: 'Delivery duration',
    confirmation: 'Pickup and delivery times updated',
    validationError: 'Not a valid time. Maximum minutes and seconds should be 59',
    description:
      'Enter preparation and duration for pickup and delivery on the selected orders. The maximum amount of minutes and seconds are 59'
  },
  importExportOrders: {
    importOrdersHeading: 'Import orders',
    importStatus: 'There are currently {{imports}} imports in queue with a total number of {{orders}} orders',
    exportForInvoice: 'Export for invoicing',
    fileTemplateLink: 'Download Excel template',
    uploadFile: 'Import orders',
    uploadingMessage: 'Uploads the file and imports the orders...',
    testDataWarning: "Don't use personal data in test environment",
    testDataInfo:
      'This is a qa/test environment, and you are not allowed to use production data in test without affected users explicit consent.',
    fromDate: 'From date',
    toDate: 'To date',
    fromDateNotAfterToDate: "Can't be later than 'To date'",
    toDateNotBeforeFromDate: "Can't be earlier than 'From date'",
    removeControlColumns: 'Remove control columns',
    importResults: 'Import results',
    fileName: 'Imported file',
    processedAt: 'Processed at',
    createdShipmentId: 'Created shipment id',
    date: 'Date',
    exportShipments: 'Export shipments',
    createLabels: 'Create labels',
    selectSlot: 'Select route',
    selectExportLabel: 'Select what you want to export',
    allOrders: 'All Orders',
    deviatedOrders: 'Deviated Orders',
    all: 'All',
    selectFile: 'Select file',
    exportFailed: 'Failed to export data',
    jobList: {
      title: 'Previous exports',
      content: 'Content',
      created: 'Created',
      user: 'User',
      dates: 'Dates',
      download: 'Download',
      exporting: 'Exporting...',
      downloading: 'Downloading...',
      inQueue: 'In Export queue',
      exportFailed: 'Export failed',
      updated: 'Updated',
      previousImports: 'Previous imports',
      fileName: 'File name',
      numberOfOrders: 'Number of orders',
      imported: 'Imported',
      viewOrders: 'View orders',
      lastImports: 'Listing the {{count}} last imports'
    },
    exportStartedNotification: 'Export started',
    exportStartedNotificationMessage: 'Your report will be available as soon as its processed.',
    exportFailedNotification: 'Export failed, try again later',
    refreshData: 'Update data in existing report',
    refreshDataDescription: 'Choose this option if you already have created an existing report for the specific dates',
    types: {
      SHIPMENT_EXPORT: 'Shipments',
      COURIER_WORK_REPORT: 'Courier work report',
      COURIER_WORK_REPORT_EXTENDED: 'Extended courier work report',
      END_OF_DAY_REPORT: 'End of day report',
      SOCIAL_CONTROL: 'Social control',
      LOCATION_LIST: 'Location list',
      ORDER_EXPORT: 'Orders',
      ORDER_DEVIATION_EXPORT: 'Orders (Deviated)',
      ORDER_EXPORT_ANONYMOUS: 'Orders (Anonymized Data)',
      ORDER_PARTNER_EXPORT: 'Orders (For Partners)',
      DEVIATION_EVENTS: 'Deviation Events',
      OPTIMIZATION_RESULTS: 'Optimization results',
      FINANCIAL_REPORT: 'Financial report'
    },
    exportTitles: {
      SHIPMENT_EXPORT: 'Export Shipments',
      COURIER_WORK_REPORT: 'Courier work report',
      COURIER_WORK_REPORT_EXTENDED: 'Extended courier work report',
      END_OF_DAY_REPORT: 'End of day report',
      SOCIAL_CONTROL: 'Export Social Control Data',
      LOCATION_LIST: 'Export location list',
      ORDER_EXPORT: 'Export Orders',
      ORDER_DEVIATION_EXPORT: 'Export Orders',
      ORDER_EXPORT_ANONYMOUS: 'Export Orders',
      ORDER_PARTNER_EXPORT: 'Export Orders',
      DEVIATION_EVENTS: 'Export deviation events',
      OPTIMIZATION_RESULTS: 'Export optimization results',
      FINANCIAL_REPORT: 'Export financial report'
    },
    exportDescriptions: {
      SHIPMENT_EXPORT: '',
      COURIER_WORK_REPORT: '',
      COURIER_WORK_REPORT_EXTENDED: '',
      END_OF_DAY_REPORT: 'Use this report to view daily route statistics, including operational costs and earnings.',
      SOCIAL_CONTROL: '',
      LOCATION_LIST: '',
      ORDER_EXPORT:
        'If you want to use the data for test enviroments, we recommend to use the option “Orders (Anonymized Data)"',
      ORDER_DEVIATION_EXPORT:
        'If you want to use the data for test enviroments, we recommend to use the option “Orders (Anonymized Data)"',
      ORDER_EXPORT_ANONYMOUS: 'Can be used if data is to be imported into a test environment',
      ORDER_PARTNER_EXPORT: 'Customized excelfile that can be used for importing in Opter',
      DEVIATION_EVENTS: '',
      OPTIMIZATION_RESULTS: 'Customized excel file with optimization results',
      FINANCIAL_REPORT: 'Contains additional sheet with orders broken down by debit lines where applicable'
    }
  },
  unit: {
    clearSearch: 'Clear search',
    unitWithCount: '{{count}} unit',
    unitWithCount_other: '{{count}} units',
    new: 'New unit',
    edit: 'Edit unit',
    addCourier: 'Add courier',
    hideAddCourier: 'Hide add courier',
    requiresCourierUsers: 'Must have at least one courier',
    noCouriersFound: 'No couriers found',
    created: 'Unit has been created',
    updated: 'Unit has been updated',
    search: 'Search for units from other departments...',
    unitsInCurrentDepartment: 'Units in current department',
    unitsInOtherDepartments: 'Units in other departments',
    saveUnit: 'Save unit',
    addCourierToUnit: 'Add courier to unit',
    addCourierToUnitSearch: 'You can only search for couriers in departments you have access to',
    addedCouriers: 'Added couriers ({{count}})',
    newCourier: 'Create new courier',
    name: 'Name',
    unitId: 'Unit ID',
    couriers: 'Couriers',
    active: 'Active',
    vehicle: 'Vehicle',
    deleteQuestion: 'Remove unit from current department',
    deleteDescription: 'Unit can be reconnected later if the unit is still connected to other departments',
    unassigned: 'Unit successfully removed from department',
    setDefaultVehicle: {
      add: 'Add vehicle',
      change: 'Change vehicle',
      title: 'Add vehicle to {{unit}}',
      selectVehicle: 'Select vehicle',
      addSuccess: 'Vehicle was successfully added to {{unit}}',
      changeSuccess: 'Vehicle was successfully changed on {{unit}}'
    }
  },
  units: {
    title: 'Units',
    new: 'Create new unit',
    connectFromOtherDepartments: 'Connect from other departments',
    connect: {
      title: 'Connect units to current department',
      description: 'You can only search for units in departments you have access to',
      selected: 'Selected units',
      noneSelected: 'No units',
      submit: 'Connect'
    },
    assigned: 'Unit(s) was successfully connected'
  },
  courier: {
    isActive: 'Is active',
    canLogIn: 'Can log in',
    secureLoginEnabled: 'BankID Login',
    recipientName: 'Recipient name',
    created: 'Courier has been created',
    updated: 'Courier has been updated',
    courier: 'Courier',
    couriers: 'Couriers',
    noCouriers: 'No couriers',
    noCouriersExplain: "We couldn't find any results. Please try searching with another term",
    courierWithCount: '{{count}} courier',
    courierWithCount_other: '{{count}} couriers',
    numberOfCouriers: 'Found {{number}} couriers',
    multipleDrivers: 'Multiple drivers',
    missingId: 'Id missing',
    missingName: 'Name missing',
    search: 'Search for couriers',
    new: 'New courier',
    edit: 'Edit courier {{name}}',
    name: 'Name',
    unitId: 'Unit ID',
    phoneNumber: 'Phone number',
    driverId: 'Driver ID',
    capacity: 'Capacity',
    capacityLabel: 'Capacity (amount)',
    weightCapacity: 'Weight capacity (kg)',
    volumeCapacity: 'Volume capacity (m\u00B3)',
    maxRangeKm: 'Max range (km)',
    minShipmentWeightKg: 'Minimum shipment weight on this vehicle (kg)',
    maxShipmentWeightKg: 'Maximum shipment weight on this vehicle (kg)',
    canCarryPallets: 'Can carry pallets',
    color: 'Color',
    resetColor: 'reset color',
    speedFactor: 'Speed factor',
    speedFactorExplanation: 'lower = slower',
    serviceTimeFactor: 'Service time factor',
    serviceTimeFactorExplanation: 'lower = quicker',
    defaultStopLocation: 'Default stop location',
    defaultStartLocation: 'Default start location',
    slotNumDeliveries: '{{count}} delivery',
    slotNumDeliveries_other: '{{count}} deliveries',
    slotNumPickups: '{{count}} pickup',
    slotNumPickups_other: '{{count}} pickups',
    deliverPerformButtonLabel: 'Deliver',
    handoverPerformButtonLabel: 'Hand over',
    deviationPerformButtonLabel: 'Deviation',
    deliverWithoutSignatureButtonLabel: 'Without signature',
    deliverWithSignatureButtonLabel: 'Signature',
    deviateNotAtHomeButtonLabel: 'Not at home',
    deviateLocNotFoundButtonLabel: 'Could not find location',
    deviateRecipientDeclinedButtonLabel: 'Recipient did not want it',
    deviateTimeWindow: 'Could not deliver within timewindow',
    addressNotFound: 'Address not found',
    deliverySpotUnavailable: 'Agreed delivery location is not available',
    deliveryAttemptNotPickedUp: 'Delivery Attempt - Not Picked Up',
    noAvailableHatchInParcelBoxMachine: 'No available hatch',
    packageDoesNotFitInParcelBox: 'The package exceeding the permissible dimensions/weight',
    unknownErrorForParcelBoxDelivery: 'Other Unknown',
    errorInParcelBoxMachine: 'The machine is out of order',
    deviation: {
      'H-12': 'An attempt was made to deliver the shipment, but the recipient was not present',
      'H-11': 'An attempt has been made to deliver the package, but the recipient was not found at the address',
      'H-10': 'An attempt has been made to deliver the package, but the address was not found',
      'H-13': 'Delivery of the consignment has been attempted, but the consignment was refused',
      '7-10': 'Goods could not be picked up, due to incomplete address',
      '7-12': 'The sender was not available. Goods has not been picked up',
      '7-82': 'Goods was not ready for pickup',
      'OFU-10': 'Incomplete address',
      'OFU-12': 'Addressee not available',
      'OFU-82': 'Goods not ready for collection',
      'OFU-DI': 'No items for pickup',
      'OFU-87': 'Force majeure',
      'OFU-OCB': 'Vehicle breakdown',
      'OFU-OL2': 'Not enough space in the vehicle',
      'OFU-OS1': 'Goods damaged before collection',
      'V-41-K': 'The shipment is delayed, will be forwarded as soon as possible',
      'V-OL2': 'Not enough space in the vehicle',
      'V-OL4': 'Item not found',
      'V-OL5': 'Planned for later on the same route',
      '9-91': 'Cancelled by customer',
      'H-07-R': 'Failed social control',
      'H-07-Z': 'Failed social control',
      'H-08-Z': 'Failed age control',
      'H-09-Z': 'Failed ID control',
      'VI-16-X': 'Could not deliver within timewindow',
      'H-11-Z': 'Address not found',
      'H-BL-A': 'Agreed delivery location is not available',
      'A-10': '$t(courier.deviation.7-10)',
      'A-12': '$t(courier.deviation.7-12)',
      'A-82': '$t(courier.deviation.7-82)',
      'V-100-CA': 'No parcel box available. Parcel will be delivered as home delivery',
      'V-100-CI': 'No available hatch',
      'V-80-CI': 'The package exceeding the permissible dimensions/weight',
      'V-99-CI': 'Other Unknown',
      'V-AO-CI': 'The machine is out of order',
      'H-49-Q': '$t(courier.deliveryAttemptNotPickedUp)',
      'V-X-Y': 'Order collected by other driver'
    },
    completionProgressCounter: '{{numCompleted}}/{{numTotal}} completed',
    lockCode: 'Gate code',
    flexDelivery: 'Simplified delivery',
    fuelType: 'Fuel type',
    fuelTypes: {
      diesel: 'Diesel',
      gasoline: 'Gasoline',
      natural_gas: 'Natural gas',
      rme: 'RME',
      hvo: 'HVO',
      ethanol: 'Ethanol',
      bio_gas: 'Biogas',
      electric: 'Electricity',
      bicycle: 'Bicycle',
      hydrogen: 'Hydrogen'
    },
    fuelCategory: 'Fuel category',
    fuelCategories: {
      fossil: 'Fossil',
      fossil_free: 'Fossil free',
      zero_emissions: 'Zero emissions'
    },
    latestLogin: 'Latest login',
    latestVersion: 'Latest version',
    failedSocialControl: 'Failed social control',
    failedIdControl: 'Failed ID control',
    failedAgeControl: 'Failed age control',
    incompletePickupAddress: 'Incomplete pickup address',
    custNotAvailableAtPickupAddress: 'Customer not available at pickup address',
    goodsNotReadyAtPickupForCust: 'Goods not ready for pickup at customer',
    shipmentNotAvailableAtTerminal: 'Shipment not available at terminal',
    registrationNumber: 'Registration number',
    commercialTrafficEligibility: 'Commercial traffic eligibility',
    vehicleBrand: 'Vehicle brand',
    vehicleModel: 'Vehicle model',
    vehicleControl: 'Vehicle control',
    vehicleControlComment: 'Vehicle control comment',
    euroClass: 'Euro class',
    euroClassTypes: {
      euroEL: 'Euro EL',
      euro5: 'Euro 5',
      euro6: 'Euro 6'
    },
    co2: 'CO2',
    alcoholDeliveryEducation: 'Alcohol delivery education',
    alcoholDeliveryEducationDate: 'Completed education',
    alcoholDeliveryEducationDateMissing: 'Date missing',
    alcoholDeliveryEducationDateRequired: 'Enter the date the alcohol delivery education was completed',
    alcoholDeliveryEducationValidToDate: 'Valid to {{date}}',
    alcoholDeliveryEducationExpiresDate: 'Expires {{date}}',
    alcoholDeliveryEducationExpiredDate: 'Expired {{date}}',
    alcoholDeliveryEducationValidTo: 'Valid to',
    alcoholDeliveryEducationValidToRequired: 'Enter the date the education is valid to',
    alcoholDeliveryEducationValidToAfterEducationDate: 'Valid to must be after the completed education date',
    approved: 'Approved',
    notApproved: 'Not approved',
    couriersInCurrentDepartment: 'Couriers in current department',
    inCurrentDepartment: 'Current department',
    couriersInOtherDepartments: 'Couriers in other departments',
    inOtherDepartments: 'Different departments',
    confirmConnect: 'Connect courier to current department',
    confirmModalDescription: '',
    searchForCouriers: 'Search for couriers',
    editCourier: 'Edit Courier:',
    courierUserUpdated: 'Courier has been updated successfully.',
    dateOfBirth: 'Date of birth',
    dateNotValid: 'Date not valid',
    dateOfBirthWithFormat: 'Date of birth (yyyy-mm-dd)',
    occupationalInjuryInsurance: 'Occupational injury insurance',
    courierScanEnabled: 'Scan',
    breakTime: 'Break time',
    breakDuration: 'Break duration (min)',
    timeWindow: 'Start of break (earliest and latest)',
    breakTimeDescription:
      'In the input fields <i>Start of break (earliest and latest)</i> you set the earliest and latest time the break should start.' +
      ' For example setting 11:00 - 17:00 means that the latest time the driver can start the break is at 17:00.',
    breakOptimizingSupportDescription:
      'Please note that breaks are only supported when optimizing routes with GraphHopper. This functionality is not available when using PTV.',
    between: 'Between',
    editBreakTime: 'Edit break time',
    updateBreakTime: 'Update break time',
    latestBreakStart: 'Latest start of break',
    radioButtons: {
      noBreakTime: 'No break time',
      timeWindow: 'Time window',
      workingTime: 'Working time'
    },
    workingTimeDescription:
      'You set the maximum working time before the driver needs to take a break. For example, after 8 hours driver needs to take 30 minutes break.',
    maxWorkingTime: 'Max working time',
    selectMaxWorkingTime: 'Select max working time',
    hours: '{{hours}} hours',
    breakTooltip: 'You can only have one break type per unit'
  },
  slot: {
    minutesDelay: 'minutes delayed',
    minutesAhead: 'minutes ahead',
    minutes: 'minutes',
    time: 'Time',
    created: 'Created',
    assigned: 'Assigned',
    lock: 'Lock',
    lockDescription:
      'When the slot is locked, it will not be a part of future route optimizations, and cannot be edited.',
    toggleVisibleSlotDescription: 'Hide the slot.',
    inProgress: 'In progress',
    onHold: 'On hold',
    complete: 'Complete',
    unknownState: 'Unknown state',
    courierSelect: 'Select courier',
    unitSelect: 'Select unit',
    printableSlotList: 'Printable slot list',
    followsRoute: 'Follows',
    doesNotFollowRoute: 'Deviate',
    hasLocation: 'Visible',
    hasNoLocation: 'Not visible',
    showActiveSlots: 'In progress',
    showSlotNotStarted: 'Not started',
    showLoggedInRoutes: 'Logged in not started',
    showCompletedSlot: 'Completed',
    showPerfectSlot: 'Perfect',
    filterSlots: 'Filter slots',
    planningCompleted: 'Complete',
    completeWithLastSent: '{{label}} (last sent: {{time}})',
    addMapArea: 'Add map area',
    editMapArea: 'Edit map area'
  },
  login: {
    heading: 'Log in',
    phone: 'Enter your Glow registered phone number with country prefix (e.g. +47 ...), and we will send an SMS token',
    code: 'Token sent, if you have a registered user with that number. It is valid for 5 minutes. Enter token.',
    requestNewCode: 'Request another code',
    verifyFailed: 'Token or phone number is incorrect, or too many attempts used, try again or request another code',
    requestFailed: 'Could not send token, try again.',
    verifyTokenButton: 'Verify token',
    requestTokenButton: 'Request token',
    privacyLink: 'Privacy policy',
    passwordWrong: 'Incorrect password',
    customer: 'I am a customer',
    forgotPassword: 'Forgot your password?',
    tryApp: 'Try the new app!',
    appDownload: 'Download the drivers app here and get access to even more functions!',
    appInfo:
      'Are you a driver with an Android- phone? Download the drivers app <1>here</1> and get access to even more functions!',
    webApp: 'Web App',
    note: 'Note! Only use the web version of the courier app if you for some reason cant use the apps for iOS and Android',
    resendToken: 'Resend token',
    submitPassword: 'Submit password',
    loginAsCustomer: 'Log in as a customer',
    loginAsPlanner: 'Log in as a planner',
    loginAsPartnerOrPhoneNumber: 'Log in as a partner',
    loginWithPhoneNumber: 'Log in with phone number',
    loginUsingSSO: 'Log in with Posten account',
    partnerLoginTitle: 'Phone number sign-in is for partners',
    partnerLoginBody:
      'Only partner users can sign in using a phone number. As a Glow & Bring employee, please use <pageLink>this page</pageLink>.',
    ssoLoginFailed: 'Unable to sign in. Please contact the Posten and Bring service desk if the problem persists.',
    token: 'Token',
    password: 'Password',
    tokenRequired: 'Token is required',
    forgotPasswordDescription:
      "To continue, you need to set a password. We'll send you an email with a link for setting this. If your email has changed, you need to contact an admin to change it.",
    sendEmailDescription:
      "To continue, we need your email. We'll send you a confirmation link to the supplied address. With this link you can set your 2 factor password.",
    emailFormatValidation: 'Email needs to be in valid format',
    sendEmailSuccess: 'The email should arrive shortly',
    sendEmailFailed: 'Sending email failed, try again',
    setYourPassword: 'Set your password',
    sendEmail: 'Send email',
    passwordsDontMatch: "Passwords don't match",
    passwordNotMeetRequirements: 'Password doesn’t meet the requirements',
    passwordRequired: 'Password required',
    newPassword: 'New password',
    repeatPassword: 'Repeat your password',
    lowercaseLetter: 'A <strong>lowercase</strong> letter',
    uppercaseLetter: 'A <strong>capital (uppercase)</strong> letter',
    numberCharacter: 'A <strong>number</strong>',
    minimumCharacters: 'Minimum <strong>15 characters</strong>',
    passwordDescription: 'You may now set your password, it must contain the following'
  },
  error: {
    '404Title': 'Page not found',
    '404Message': 'We couldn’t find the page you’re looking for',
    '500Message': "{{error}} - Sorry, we cannot find your data... we'll try again in a minute...",
    title: 'Something went wrong!',
    dateRequiredWhenSecureLogin: '*Required field if BankID is activated',
    dateNotValid: 'Date is not valid',
    dateCannotBeInFuture: 'Date cannot be in the future',
    dateCannotBeInThePast: 'Date cannot be in the past',
    dateCannotBeOlderThanMonths: 'Date cannot be more than {{months}} months old',
    dateOutsideRange: 'Date outside valid range',
    errorMessage:
      'We are sorry! This did not work out as planned, but the developers have been notified about the error..',
    errorClickToReload: 'Click here to reload the page',
    phoneNumber: 'You must provide valid phone number, e.g. +47 12345678',
    phoneNumberPrefix: 'You must provide a country code, e.g. +47 ...',
    somethingWentWrong: 'Something went wrong.',
    andMoreErrors_one: 'and {{count}} more error',
    andMoreErrors_other: 'and {{count}} more errors',
    notAValidNumber: 'Not a valid number',
    notAValidAlphaNumeric: 'Must be numbers and/or letters',
    notAValidDate: 'Must be a valid date (yyyy-mm-dd)',
    notAValidTime: 'Must be a valid time (hh:mm)',
    notAValidDuration: 'Must be a valid duration (mm:ss)',
    notAValidZipCode: 'Must be a valid postal code',
    notAValidPostalCodeRange: "The 'From postal code' must be less than or equal to 'To postal code'",
    notAValidTimezone: 'Must be a valid timezone. Try "Europe/Oslo" or similar',
    somethingWentWrongOnTheServer: 'Something went wrong on the server...',
    somethingWentWrongWithTheRequest: 'Something was wrong with the request...',
    somethingWentWrongWithTheResponse: 'Something was wrong with the response...',
    selectAtLeastOne: 'You need to select at least one option',
    invalidEmail: 'You must provide valid email address, e.g. name@gmail.com',
    requiredBreakDuration: 'You must enter break duration',
    notAValidTimeWindow: 'The earliest break start must be before the latest',
    requiredEarliestStartBreak: 'You must enter earliest break start',
    requiredLatestStartBreak: 'You must enter latest break start',
    requiredIfWorkingTimeDuration: 'You must enter max working time',
    timeInWrongFormat: 'Time is not valid',
    invalidUrlParameterCombination: 'This combination of URL parameters is invalid and the page cannot be rendered',
    numberCannotContainDecimals: 'Number cannot contain decimals',
    selectAtLeastOneItem: 'At least one item needs to be selected',
    mustSelectDepartment: 'You must select a department',
    mustSelectRoute: 'You must select a route',
    mustProvideLabel: 'You must provide {{label}}',
    sizeMustBeAnIntegerGreaterThanZero: 'Size must be a number without decimals greater than or equal to 1'
  },
  loading: "We're currently fetching your data...",
  newAppVersion: 'Glow just got a little better, we are now fetching the new version.',
  loadingReceiptList: 'Receipt lists are being generated...',
  invoicing: {
    departmentInvoicingInProgress: 'Invoicing in progress...'
  },
  months: {
    january: 'January',
    february: 'February',
    march: 'March',
    april: 'April',
    may: 'May',
    june: 'June',
    july: 'July',
    august: 'August',
    september: 'September',
    october: 'October',
    november: 'November',
    december: 'December'
  },
  weekdays: {
    monday: 'Monday',
    tuesday: 'Tuesday',
    wednesday: 'Wednesday',
    thursday: 'Thursday',
    friday: 'Friday',
    saturday: 'Saturday',
    sunday: 'Sunday'
  },
  weekdaysShort: {
    sunday: 'Sun',
    monday: 'Mon',
    tuesday: 'Tue',
    wednesday: 'Wed',
    thursday: 'Thu',
    friday: 'Fri',
    saturday: 'Sat'
  },
  notifications: {
    dismiss: 'Dismiss',
    dismissAll: 'Dismiss all',
    dismissAllNotifications: 'Dismiss all notifications?',
    error: 'Error',
    reload: 'Refresh',
    reloadCourier: 'Press here to reload',
    navigate: 'Navigate to page',
    networkError:
      'Looks like there is some network issues, it may have been temporary. However the page should be reloaded.',
    networkErrorCourier: 'You have been offline, please reload.',
    liveUpdatesPaused: 'Live updates paused',
    liveUpdatesDescription:
      'Live updates were paused while the tab was inactive. Click to refresh and apply the latest updates.'
  },
  modals: {
    preplan: {
      create: 'Preplan shipment',
      change: 'Change preplanned driver',
      shipmentInfo: 'Preplan shipment {{shipmentId}} ({{pickupName}} to {{deliveryName}})',
      pickDriver: 'Choose a driver..',
      unpreplan: 'Unpreplan',
      preplan: 'Preplan',
      error: 'Could not preplan shipment',
      notification: {
        preplanned: 'Preplanned',
        unpreplanned: 'Unpreplanned',
        preplannedMessage: 'Shipment was preplanned to {{courierId}}',
        unpreplannedMessage: 'Shipment was unpreplanned'
      }
    },
    maps: {
      save: 'Save changes',
      cancel: 'Cancel',
      delete: 'Delete',
      editMode: 'Edit mode',
      mapArea: '{{routeName}} map area',
      saved: 'Saved',
      deleted: 'Deleted'
    }
  },
  grid: {
    columns: {
      addressWashRecipientId: 'Recipient ID',
      addressWashAddressId: 'Address ID',
      department: 'Department',
      deadline: 'Deadline',
      failedReason: 'Error message',
      exceptions: 'Exceptions',
      dispatchAsGroup: 'Dispatch as group',
      name: 'Name',
      senderName: 'Sender name',
      puearly: 'PU',
      pulate: 'PU',
      delearly: 'DEL',
      dellate: 'DEL',
      vas: 'VAS',
      zip: 'Postal code',
      type: 'Type',
      estimated: 'Estimated time',
      estimatedDepartureTime: 'ETD',
      adjusted: 'Adjusted',
      timeWindow: 'Time window',
      onCar: 'On car',
      frequency: 'Frequency',
      startDate: 'Start date',
      endDate: 'End date (optional)',
      from: 'From',
      to: 'To',
      days: 'Days',
      holidays: 'Holidays',
      startdate: 'Start date',
      enddate: 'End date',
      orders: 'Orders',
      id: 'Id',
      shipmentId: 'Shipment id',
      packageId: 'Package id',
      errorMessage: 'Error message',
      customer: 'Customer',
      pickup: 'Pickup',
      delivery: 'Delivery',
      service: 'Service',
      address: 'Address',
      zipcode: 'Postal Code',
      area: 'Area',
      weight: 'Weight',
      volume: 'Volume{{unit}}',
      bookedWeight: 'Booked weight{{unit}}',
      bookedVolume: 'Booked volume{{unit}}',
      qty: 'Qty',
      preplanned: 'Preplanned',
      preplannedRouteTemplate: 'Route',
      group: 'Group',
      totalOrders: 'Total orders',
      ordersFailed: 'Orders failed',
      date: 'Date',
      finished: 'Finished',
      failed: 'Failed',
      ordersInvoiced: 'Orders invoiced',
      start: 'Start',
      stop: 'Stop',
      pickupContactPerson: 'Pickup contact person',
      pickupPhone: 'Pickup phone',
      deliveryContactPerson: 'Delivery contact person',
      deliveryPhone: 'Delivery phone',
      deliveryAddress: 'Delivery Address',
      deliveryTime: 'Delivery Time',
      contactPerson: 'Contact person',
      phone: 'Phone',
      email: 'Email',
      deliveryReferencePlaceholder: 'Recipient reference',
      specificationDescriptionPlaceholder: 'Goods information',
      multileg: 'Multileg',
      groupName: 'Group name',
      customerNumber: 'Customer No',
      orderNote: 'Internal Note',
      returned: 'Returned',
      price: 'Price',
      slotName: 'Slot',
      estimatedArrivalTime: 'ETA',
      waitingTime: 'Waiting time',
      timeOfDelivery: 'ToD',
      timeOfPickup: 'ToP',
      deliveryEtaSmsSentAt: 'Del. ETA SMS sent',
      trip: 'Trip',
      addresses: {
        title: 'Addresses',
        search: 'Address search',
        searchAddresses: 'Search addresses',
        filterAddresses: 'Filter addresses',
        deleteConfirmation: 'Are you sure you want to delete this address?',
        deleteMultipleConfirmation: 'Are you sure you want to delete all selected addresses?',
        deleteSuccess: 'Address successfully deleted',
        deleteMultipleSuccess: 'Addresses successfully deleted',
        delete: 'Delete',
        name: 'Name',
        phone: 'Phone number',
        address: 'Address',
        zipArea: 'Area',
        zipCode: 'Postal code',
        country: 'Country',
        contactPerson: 'Contact person',
        instructions: 'Instructions',
        deleteAddress: 'Delete address',
        deleteMultipleAddresses: 'Delete addresses ({{count}})',
        loc: 'Loc',
        locTitle: 'Location'
      },
      orderGrid: {
        vehicleType: 'Vehicle',
        extraInfo: 'Extra info'
      },
      dispatch: {
        adjusted: 'Adjusted',
        customerName: 'Customer name',
        estimatedDepartureTime: 'ETD',
        service: 'Service'
      },
      goodsType: 'Goods type',
      orderSource: 'Order source',
      postalCodes: '# postal codes',
      displayEndCustomerPriceShd: 'Show customer price',
      courier: 'Courier',
      createdAt: 'Creation date',
      createdBy: 'Created by',
      plannedDeliveryDate: 'Planned date',
      orderedDeliveryDate: 'Ordered date',
      lastUpdatedAt: 'Last updated at',
      route: 'Route',
      instructions: 'Instructions',
      pickupDuration: 'PU duration',
      deliveryDuration: 'DEL duration',
      pickupPreparation: 'PU preparation',
      deliveryPreparation: 'DEL preparation',
      originalPickupAddress: 'Original Sender Address',
      originalPickupZipCode: 'Original Sender Postal Code',
      originalPickupZipArea: 'Original Sender City',
      originalPickupCountry: 'Original Sender Country',
      originalDeliveryAddress: 'Original Delivery Address',
      originalDeliveryZipCode: 'Original Delivery Postal Code',
      originalDeliveryZipArea: 'Original Delivery City',
      originalDeliveryCountry: 'Original Delivery Country',
      packagesArrivedAtDip: 'Arrived',
      packagesCollected: 'Collected',
      packagesDelivered: 'Delivered',
      originalDeliveryEarliest: 'Original DEL',
      originalDeliveryEarliest1: 'Original DEL 1',
      originalDeliveryLatest: 'Original DEL',
      originalDeliveryLatest2: 'Original DEL 2',
      preAdvices: 'Preadvice attempts',
      preAdviceScheduledDate: 'First preadvice date',
      hasPreAdviceSettings: 'Preadvice setting',
      arrivedAtHub: 'Arrived hub',
      returnToSender: 'Return to sender',
      preAdviceFailed: 'Preadvice failed',
      deliveryAttempts: 'Delivery attempts',
      shipmentCreationDate: 'Shipment creation date',
      preAdviceResult: 'Preadvice result',
      failedPreAdviceDate: 'Failed preadvice date',
      loadCarrierId: 'Load Carrier ID',
      deliveryPupUnitId: 'PUP ID',
      loadCarrier: 'Load carrier',
      pickupZipCode: 'Pickup Postal code',
      pickupArea: 'Pickup Area',
      deliveryZipCode: 'Delivery Postal code',
      deliveryArea: 'Delivery Area',
      plannedStops: 'Planned stops'
    },
    columnSettings: {
      header: 'Add columns in Data table',
      description: 'When selecting a label this information will be shown in the data table'
    }
  },
  openBooking: {
    error: {
      pickupTimeNotWithinServiceTimeWindow: 'Pickup time is not within service time window',
      pickupTimeBeforeEarliestServicePickupTime: "Pickup time can't be before earliest service pickup time",
      pickupNotAvailableForWeekend: 'Pickup service is not available for weekends',
      invalidOrganisationNumber: 'Invalid organisation number'
    }
  },
  instant: {
    title: 'Dispatching',
    openMap: 'Open map',
    group: 'Group selected',
    editGroup: 'Edit group',
    groupName: 'Group name',
    groupOrders: 'Group orders',
    viewGroup: 'View group',
    ordersToGroup: 'Orders to group',
    fixedOrder: 'Fixed delivery order',
    saveFixedOrder: 'Save order changes',
    paidTogether: 'Paid together',
    saveGroup: 'Save group',
    ungroup: 'Ungroup',
    removeSelected: 'Remove selected',
    split: 'Split selected',
    noCourierSelected: 'No courier selected',
    noOrderSelected: 'No order selected',
    workingHours: 'Working hours',
    chatButton: 'Chat with driver',
    offeredShipments: 'Offered shipments',
    rejectedShipments: 'Rejected shipments',
    rejectedShipmentsSnackbar: '{{count}} rejected shipment by "{{name}}"',
    rejectedShipmentsSnackbar_other: '{{count}} rejected shipments by "{{name}}"',
    toBeDone: 'Pickups and deliveries to be done',
    finishedRoutePoints: 'Finished pickups and deliveries',
    suggestedRouteApplied: 'The suggested route has been applied',
    suggestedRouteCancelled: 'The suggested route has been cancelled',
    reorderValidationError: 'The suggested route order is invalid',
    planSlot: 'Route plan',
    createRoute: {
      vehiclePlaceholder: 'No vehicle selected',
      title: 'Select vehicle to create new route',
      description:
        'This unit is not connected to a route yet. When adding the selected shipment(s) to this unit, a new route will be created. Please select a vehicle for the route.'
    },
    columnSettings: {
      reset: 'Reset',
      settings: 'Settings',
      hideColumns: 'Show columns',
      saveAndClose: 'Save and close'
    },
    routePoint: {
      pickup: 'P',
      delivery: 'D',
      depot_call: 'PS',
      start: 'S',
      end: 'E'
    },
    confirmation: {
      heading: 'Order confirmation',
      from: 'From',
      to: 'To',
      service: 'Service',
      pickup: 'Pickup',
      delivery: 'Delivery',
      shipmentNumber: 'Shipment number',
      printLabel: 'Print label',
      copyOrder: 'Copy order',
      editOrder: 'Edit order'
    },
    goods: {
      custom: 'Custom',
      letter: 'Letter',
      bag: 'Bag',
      smallbox: 'Small box',
      mediumbox: 'Medium box',
      largebox: 'Large box',
      tube: 'Tube',
      halfpallet: 'Half pallet',
      quarterpallet: 'Quarter pallet',
      fullpallet: 'Full pallet',
      suitcase: 'Suitcase',
      movingbox: 'Moving box',
      trolley: 'Trolley',
      parcel: 'Parcel',
      expressbox: 'Express box',
      '9A': 'Roll cage parcels, goods',
      '9C': 'Roll cage empty',
      '9F': 'Half pallet  letters',
      '9J': 'Pallet letters',
      PX: 'Pallet',
      PA: 'Packet',
      AF: 'Half pallet',
      SA: 'Sack',
      CS: 'Case',
      '9N': 'Monster cage, parcels',
      '9O': 'Monster cage, empty',
      '9B': 'Roll cage letters',
      '9D': 'Roll cage misc.',
      '9E': 'Half pallet  parcels, goods',
      '9G': 'Half pallet  empty',
      '9H': 'Half pallet  misc.',
      '9I': 'Pallet parcels, goods',
      '9K': 'Pallet empty',
      '9L': 'Pallet misc.',
      '9M': 'Letter piece',
      '9P': 'IKEA TU long',
      '9Q': 'IKEA TU short',
      '9Z': 'Unknown volume',
      BE: 'Bundle',
      BG: 'Bag',
      BX: 'Box',
      CD: 'Can, handle',
      CL: 'Coil',
      CN: 'Container',
      CR: 'Crate',
      CT: 'Carton',
      CW: 'Roll cage',
      DR: 'Drum',
      ED: 'Pallet case',
      LT: 'Lot',
      OA: 'Quarter pallet',
      OC: 'Sea pallet',
      OT: 'Octabin',
      PB: 'Pallet box',
      PC: 'Parcel',
      PE: 'Pallet modular',
      PI: 'Pipe',
      PK: 'Package',
      PP: 'Piece',
      PV: 'Pipes, bundle',
      RK: 'Rack',
      RO: 'Roll',
      RV: 'Rec Value',
      SE: 'Semi trailer',
      TY: 'Cyl tank',
      VB: 'Swap body',
      Z1: 'Bison pallet',
      Z2: 'Flower cage',
      Z3: 'Banana pallet',
      Z4: 'Fruit cage',
      Z5: 'Pallet low',
      Z6: 'Pallet Rema',
      Z8: 'Milk cage',
      ZZ: 'Mutual'
    },
    instantGrid: {
      editColumnTooltip: 'Click to edit',
      deleteColumnTooltip: 'Click to delete',
      unassignColumnTooltip: 'Click to unassign shipment',
      dragColumnTooltip: 'Click and drag to assign to courier',
      filtersActive: 'Filters are active',
      clearFilters: 'Clear all filters',
      filterPlaceholder: 'filter <enter>',
      assignColumnTooltip: 'Click to assign shipment'
    },
    booking: {
      numberOfCopies: 'Number of copies',
      numberOfCopiesPlaceholder: 'Fill a number between {{min}} and {{max}}',
      numberOfCopiesError: 'You must fill in a number between {{min}} and {{max}}',
      afterCutoffWarning:
        'Delivery unavailable - cutoff time {{cutoffTime}} today has passed. Please select another service or delivery day.',
      standaloneInvoiceCheckbox: 'Mark as standalone invoice',
      standaloneInvoiceDescription:
        'By selecting this option, this order will be processed individually and will not be grouped with other orders for invoicing.',
      addPackage: 'Add new package',
      removePackageRow: 'Remove package',
      cannotRemoveLastPackageRow: 'Cannot remove last package',
      copyPackageRow: 'Copy package',
      title: 'Booking',
      header: 'Booking',
      headerCreate: 'New booking',
      headerEdit: 'Edit booking',
      headerCopy: 'Copy booking',
      headerRestore: 'Restore booking',
      customer: 'Customer',
      customerPlaceholder: 'Customer id',
      subcustomerPlaceholder: 'Subcustomer',
      invoiceSplitPlaceholder: 'Invoice split',
      invoiceSplitPlaceholderLegend: 'Select invoice split',
      invalidSubcustomer: 'Subcustomer name is invalid',
      shipmentOrPackageId: 'Shipment ID or Package ID',
      creditBlockedCustomer: 'Credit blocked customer',
      sender: 'Sender',
      setAsDefaultAddress: 'Set as default address',
      setAsDefaultDisabledText: 'Missing coordinates. Set the address by using address search field',
      defaultAddressUpdated: 'Default address updated',
      recipient: 'Recipient',
      pickupNamePlaceholder: 'Name',
      pickupAddressPlaceholder: 'Address',
      pickupZipCodePlaceholder: 'Postal code',
      pickupZipAreaPlaceholder: 'City',
      pickupCountryPlaceholder: '-- Select country --',
      pickupPhoneNumberPlaceholder: 'Phone',
      pickupContactPerson: 'Contact person',
      customerReference: 'Customer reference',
      pickupReferencePlaceholder: 'Customer reference – This field is visible on the customer invoice',
      pickupInformationPlaceholder: 'Pickup information',
      pickupEmailPlaceHolder: 'E-mail',
      customerContact: 'Customer contact',
      customerContactPlaceholder: '$t(instant.booking.customerContact) – This field is visible on the customer invoice',
      customerInfoPlaceholder: 'General customer specific information',
      customerInfoHelper:
        'This information is connected to the customer. Changes made will be visible in all orders related to this customer.<br><br>To add order specific information, use the ‘Note’ input field below.',
      deliveryNamePlaceholder: 'Name',
      letterBoxPrefix: 'Letter box',
      letterBoxAlt: '{{operator}} letter box',
      deliveryAddressPlaceholder: 'Address',
      deliveryZipCodePlaceholder: 'Postal code',
      deliveryZipAreaPlaceholder: 'City',
      deliveryCountryPlaceholder: '-- Select country --',
      deliveryPhoneNumberPlaceholder: 'Phone',
      deliverySecondPhoneNumberPlaceholder: 'Second Phone Number',
      deliveryEmailPlaceHolderPlaceholder: 'E-mail',
      deliveryReferencePlaceholder: 'Recipient reference',
      deliveryInformationPlaceholder: 'Delivery information',
      orderNote: 'Internal Note',
      invalidInvoiceSplit: 'Invalid invoice split text',
      clearData: 'Clear data',
      dimensions: 'Goods',
      weightPlaceholder: 'Weight (kg)',
      lengthPlaceholder: 'Length (cm)',
      widthPlaceholder: 'Width (cm)',
      heightPlaceholder: 'Height (cm)',
      service: 'Service',
      serviceCode: 'Service code',
      servicePlaceholder: 'Service code',
      serviceSelect: 'Select service',
      serviceSelectDisabled: 'Changing services on HD orders must be done in HappyFlow',
      deliveryOrderService: {
        description: 'Delivery order'
      },
      goodsEditDisabled: 'Changes to goods on HD orders must be done in HappyFlow',
      standardServices: '-- STANDARD SERVICES --',
      customizedServices: '-- CUSTOMER UNIQUE SERVICES --',
      specificationDescription: 'Goods',
      specificationDescriptionPlaceholder: 'Goods information',
      invoiceInfo: 'Invoice information',
      invoiceInfoPlaceholder: 'Invoice information – This field is visible on the customer invoice',
      manualInvoiceInfo: 'Manual invoice handling',
      manualInvoiceInfoPlaceholder:
        'Manual invoice handling (If this field is filled in with invoicing instructions, the order will not be automatically invoiced)',
      pickup: 'Pickup',
      delivery: 'Delivery',
      pickupDatePlaceholder: 'Pickup date',
      pickupTimePlaceholder: 'Pickup Time',
      deliveryDatePlaceholder: 'Delivery date',
      deliveryTimePlaceholder: 'Delivery Time',
      deliveryContactPerson: 'Contact person',
      restoreButton: 'Restore',
      orderButton: 'Order',
      editButton: 'Update',
      copyButton: 'Order',
      created: 'Order has been registered',
      edited: 'Order has been updated',
      quickSelect: 'Quick select',
      volume: 'Volume',
      points: 'Points',
      totalVolume: 'Total volume {{volume}}',
      totalWeight: 'Total weight {{weight}}',
      removeItem: 'Remove',
      copyItem: 'Copy',
      addItem: 'Add',
      calculatePrice: 'Calculate price',
      priceExplanations: {
        header: 'Price explanations',
        article: 'Article: {{article}}',
        priceListName: 'Price list: {{pricelist}}',
        explanations: 'Explanations',
        noInfo: 'No price information available',
        details: 'Details',
        notFound: 'No price explanations available'
      },
      approveIncompletePrice: 'I approve all lines with zero price',
      muteBomArticles: 'Exclude {{bomArticle}} from invoicing',
      prePlan: 'Preplan',
      prePlannedToCourier: 'Select courier',
      prePlannedToRouteTemplate: 'Select route template',
      prePlannedToRouteText:
        'Available route depends on templates saved on the department. In order for the preplan to work properly you need to set up route settings on <0>department level</0> on the admin pages.',
      automaticDepartment: 'Automatic',
      departmentLabel: 'Department',
      notifications: 'Notifications',
      emailNotifications: 'E-mail notifications',
      eventRegistered: 'Registered',
      eventPickup: 'Pickup',
      eventDelivery: 'Delivery',
      emailAddress: 'E-mail Address',
      emailRecipientText: 'Following e-mail addresses will receive notifications:',
      invalidEmail: 'Invalid e-mail address',
      editIndicator: 'Edit',
      updateIndicator: 'Update',
      copyIndicator: 'Copy',
      quantity: 'Quantity',
      additionalServices: 'Additional services',
      paymentInformation: 'Payment information',
      paidTogetherLabel: 'Paid together?',
      groupingLabel: 'Shipment grouping',
      groupIdPlaceholder: 'Unique group id',
      groupOrderPlaceholder: 'Group shipment order',
      addRecipient: 'Add additional recipient',
      addPickup: 'Add additional sender',
      vehicleType: 'Vehicle type',
      vehicleTypeUpdated: 'Vehicle type updated',
      selectVehicleType: 'Select vehicle type',
      customerPrice: 'Customer price',
      resourcePrice: 'Unit price',
      priceDetails: 'Price details',
      priceList: 'Price list',
      manualPrice: 'Manual',
      total: 'Total',
      vehicleTypes: {
        car: 'Car',
        bicycle: 'Bicycle',
        truck: 'Truck',
        van: 'Van',
        motorcycle: 'Motorcycle',
        cargobike: 'Cargo bike'
      },
      date: 'Date',
      unNumber: 'UN Number',
      hazardous: 'Class',
      class: 'Class',
      group: 'Group',
      netWeight: 'Net weight',
      name: 'Name',
      restrictions: 'Restrictions',
      totalPoints: 'Total points',
      unacceptableMeasurementsError:
        'Measurements are not correct. Either enter all the dimensions properly or all packages should have volume.',
      serviceMessage: 'Remember to add a customer to see available services',
      pickupTimeEarliest: 'Pickup time earliest',
      pickupTimeLatest: 'Pickup time latest',
      deliveryTimeEarliest: 'Delivery time earliest',
      deliveryTimeLatest: 'Delivery time latest',
      henteordre: {
        availableTimeSlots: 'Available time slots',
        setCustomTimes: 'Set custom times',
        selectAvailableTimes: 'Select available times',
        enterPickupZipCode: 'Enter pickup postal code to see available time slots'
      },
      hazardousGoods: 'Hazardous goods'
    },
    courierSorting: {
      title: 'Sort by',
      alystraId: 'Driver number',
      empty: 'Empty',
      full: 'Full'
    },
    courierFilter: {
      title: 'Filter couriers by',
      all: 'Show all',
      inactive: 'Hide inactive',
      offline: 'Hide offline',
      both: 'Hide inactive and offline'
    },
    invoicingFilter: {
      ALL: 'Show all',
      INVOICED_OK: 'Already invoiced',
      TO_BE_INVOICED: 'To be invoiced',
      ORDER_CORRECTION: 'With order correction',
      INVOICED_FAILED: 'Invoicing failed'
    },
    shipmentFilter: {
      title: 'Filter shipments',
      showAll: 'Show all',
      notCollected: 'Not collected',
      hideAll: 'Hide all'
    },
    offer: {
      carEmpty: 'Car is currently empty',
      suggestedDelivery: 'Suggested delivery order',
      newShipments: 'New shipments',
      manualRoute: 'Manual route',
      confirmRoute: 'Confirm route',
      assigning: 'Assigning',
      replanning: 'Replanning route for',
      shipmentsTo: 'shipments to',
      shipmentTo: 'shipment to'
    },
    useFlexible: 'Use flexible times',
    forceOptimizing: 'Force optimizing order',
    replanRoute: 'Replan route',
    recurring: {
      recurringOrderSaved: 'Recurring order saved',
      executeDate: 'Execution date',
      confirmExecuteOrders: 'Are you sure you want to execute all recurring orders for {{date}}?',
      editRecurringOrder: 'Edit recurring order',
      createRecurringOrder: 'Create recurring order',
      successMessage: '{{number}} shipment(s) was added to selected recurring groups',
      title: 'Recurring',
      recurringOrders: 'Recurring orders',
      includedOrders: 'Orders included in schedule',
      details: 'Details',
      editOriginal: 'Edit original',
      copyOriginal: 'Copy original',
      notStarted: 'Not started',
      executing: 'Executing...',
      ended: 'Finished',
      status: 'Status',
      pending: 'Pending',
      ok: 'OK',
      total: 'Total',
      failedOrders: 'Failed orders',
      exceptionsHeading: 'Exceptions for orders',
      addExceptionHeading: 'New exception period',
      exceptionStart: 'Start',
      exceptionEnd: 'End',
      editExceptions: 'Edit exceptions',
      addRecurring: 'Recurring',
      addToGroup: 'Select recurring group',
      exceptions: 'Exceptions',
      recurringOrderAddedConfirmation: 'Order added to recurring group',
      exceptionsUpdated: 'Exceptions updated',
      dispatchAsGroup: 'Dispatch as group',
      name: 'Name',
      frequency: 'Frequency',
      frequencies: {
        weekly: 'Every week',
        second_week: 'Every second week',
        third_week: 'Every third week',
        monthly: 'Every month'
      },
      daysOfWeek: 'Days of week',
      includeHolidays: 'Include holidays',
      endsNextDay: 'Ends next day',
      endsNextDayExplanation:
        'Only for routes that run past midnight. The start time is on the first day and the end time on the day after.',
      endsNextDayRequiredByShipments: 'Uncheck next day pickup or delivery on the shipments before removing this',
      pickupNextDay: 'Pickup next day',
      deliveryNextDay: 'Delivery next day',
      nextDayExplanation:
        'The window starts on the first day of the route. Only the latest time moves to the next day.',
      createBillingOrder: 'Create billing order',
      customerForBillingOrder: 'Customer for billing order',
      errorBeforeToday: 'Cannot be before today',
      errorEndBeforeStart: 'Cannot be before start date',
      excludedDateRanges: {
        title: 'Excluded dates',
        add: 'Add to list',
        savedWithRoute: 'Excluded dates are stored when you save the route',
        ongoing: 'ongoing'
      },
      startDate: 'Start date',
      endDate: 'End date (optional)',
      save: 'Save',
      fromDate: 'From date',
      confirmDelete: 'Are you sure you want to delete the selected recurring order(s)?',
      numSelectedRoutes: '{{count}} selected',
      deleteTemplateRoute: {
        title: 'Delete template route',
        description: 'This action cannot be undone.'
      },
      deleteTemplateRoutes: {
        title: 'Are you sure you want to delete {{count}} routes?',
        description: 'This action cannot be undone.'
      },
      rolloutTemplateRoutes: {
        title: 'Are you sure you want to roll out {{count}} routes?',
        description: 'The routes will be rolled out for {{date}}.',
        alreadyRolledOut: '{{count}} of the routes are already rolled out for {{date}}:',
        replaceWarning:
          'Their routes and orders will be deleted and rolled out again. The orders get new shipment numbers.'
      },
      from: 'From',
      createOrders: 'Create orders',
      showResult: 'Show result',
      showRolloutResult: 'Show rollout result',
      rolloutProblems: 'Rollout problems',
      rolloutProblemsFrom: 'From the previous rollout, {{date}}',
      rolloutProblemsHandled: 'Rollout problems handled',
      noRolloutProblems: 'No rollout problems in this period',
      noOutstandingRolloutProblems: 'Every rollout problem has been dealt with',
      dealtWith: 'Dealt with',
      problems: 'Problems',
      problemType: 'Problem',
      severityCritical: 'Critical',
      severityWarning: 'Warning',
      rangeReversed: 'The from date must not be after the to date',
      rangeTooLong: 'The period cannot be longer than {{days}} days',
      rangeNeedsEnd: 'To look further back than {{days}} days, set an end date as well',
      problemRolloutFailed: 'Rollout failed',
      problemOrderNotCreated: 'Order not created',
      problemOrderNotOnRoute: 'Order not on route',
      problemStopNotOnRoute: 'Planned stop not on route',
      startdate: 'Start date',
      enddate: 'End date',
      orders: 'Orders',
      executionSummary: 'Execution summary',
      executions: 'Executions',
      executionStatus: 'Execution status',
      executionId: 'Execution',
      templateShipment: 'Template shipment',
      createdOrderId: 'Created order id',
      packageIds: 'Package ids',
      sentAt: 'Sent at',
      lastAttemptAt: 'Last attempt at',
      routeConnected: 'Route connected',
      optimizationRequestId: 'Optimization request id',
      failedOptimizationRequestIds: 'Failed optimization request ids',
      routeConnectedSummary: 'Connected to route',
      onlyWithErrors: 'Only with errors',
      rolloutResult: {
        newView: 'New view',
        oldViewNotice:
          'This view will be removed soon. The new view shows the problems from this date onwards, grouped by cause.',
        switchToNewView: 'Switch to the new view',
        earlierProblems_one: 'There is {{count}} unhandled problem from the rollout on {{date}}.',
        earlierProblems_other: 'There are {{count}} unhandled problems from the rollout on {{date}} onwards.',
        showEarlierProblems: 'Show them',
        crumb: 'Rollout result',
        title: 'Rollout result - {{date}}',
        nothingRolledOut: 'Nothing has been rolled out from this date',
        progress: 'Rollout progress',
        showProgress: 'Show rollout progress',
        processing: 'Rollout in progress',
        processingCount: 'Processing progress · {{processed}} of {{total}} routes',
        done: 'Rollout done',
        doneCount: '{{processed}} of {{total}} routes',
        routes: 'Created routes',
        createdOrders: 'Created orders',
        stops: 'Stops',
        failedStops: 'Failed stops',
        orderStatus: {
          PENDING: 'Pending',
          SENT: 'Sent',
          CREATED: 'Created',
          FAILED: 'Failed',
          MISSING: 'Missing'
        },
        plannedStopStatus: {
          PENDING: 'Pending',
          CONNECTED: 'Connected',
          FAILED: 'Failed'
        },
        unhandled: 'Unhandled',
        handled: 'Handled',
        handledToggle: 'Show unhandled or handled problems',
        unhandledCount: 'Unhandled problems ({{count}})',
        handledCount: 'Handled problems ({{count}})',
        unhandledDescription: 'Fix the errors so the next rollout does not run into the same ones.',
        handledDescription: 'Problems marked as handled. Mark one as not handled to bring it back.',
        unhandledEmpty: 'No problems need to be handled',
        handledEmpty: 'No problems have been marked as handled',
        groupDescription:
          'When you have corrected the information, mark the problem as handled and it disappears from the list.',
        cause: {
          MISSING_CUSTOMER: {
            title: 'Missing customer number',
            description: 'The customer was not found. It may have been deleted or changed.'
          },
          ORDER_NOT_CREATED: {
            description: 'The order could not be created. See the failure reason.'
          },
          TIME_WINDOW: {
            title: 'Time window',
            description: 'The order was not added to the route because of time window restrictions.'
          },
          MISSING_COORDINATES: {
            title: 'Missing coordinates',
            description: 'The address has no coordinates.'
          },
          CAPACITY: {
            title: 'Not enough capacity on vehicle',
            description: 'The order did not fit because of a capacity problem.'
          },
          OPTIMIZATION_FAILED: {
            title: 'Optimization failed',
            description: 'Route optimization failed after several attempts.'
          },
          ORDER_NOT_ON_ROUTE: {
            description: 'The order was created but not added to the route. The cause is not known yet.'
          },
          STOP_NOT_ON_ROUTE: {
            description:
              'The stop could not be added to the route, usually because of its time window or location. Fix it on the template route.'
          }
        },
        filterRoutes: 'Filter routes',
        allRoutes: 'All routes',
        routeName: 'Route name',
        templateRoute: 'Template route',
        rolledOutAt: 'Rolled out',
        handledBy: 'Marked as handled by',
        selectRow: 'Select {{route}} {{id}}',
        markAsHandled: 'Mark as handled',
        markAsHandledHint: 'It will disappear from the list',
        markAsUnhandled: 'Mark as not handled'
      },
      rolloutView: {
        label: 'Rollouts',
        current: 'Current',
        all: 'All, including replaced',
        replaced: 'Replaced only'
      },
      replaced: 'replaced',
      replacedAt: 'Replaced at',
      replacedBy: 'Replaced by',
      replacesExecution: 'Replaces execution',
      templateRouteId: 'Template route id',
      templateRouteName: 'Template route name',
      createdAt: 'Created at',
      updatedAt: 'Updated at',
      date: 'Date',
      createdSlotId: 'Created route id',
      createdBy: 'Created by',
      failed: 'Failed',
      by: 'By',
      on: 'on',
      reset: 'reset',
      confirmReset: 'Are you sure you want to reset recurring orders for {{date}}?',
      startDateExplanation: 'Orders will be created on the same day as the startDate',
      noOrderSelected: 'No order selected',
      noOrdersFound: 'No orders found',
      groups: 'Groups',
      routes: 'Routes',
      newRoute: 'Create new recurring route',
      recurringRoute: 'Recurring route',
      tabFrequency: 'Frequency',
      tabRoute: 'Route',
      tabTemplateShipments: 'Template shipments',
      timeQuestion: 'Which time should the route start and end?',
      frequencyQuestion: 'How often do you want the routes to roll out?',
      holidayRollout: 'Holiday rollout',
      holidayRolloutDescription:
        'Routes are excluded from holidays by default. Select this option to include holidays in the rollout schedule.',
      weekdaysQuestion: 'Which day of the week do you want the route to deliver on?',
      periodQuestion: 'When do you want the route to start and end?',
      routeDetails: 'Route details',
      searchShipments: 'Search shipments',
      editShipment: 'Edit template shipment',
      newTemplateShipment: 'New template shipment',
      addShipments: 'Add shipments',
      saveShipment: 'Save shipment',
      onRoute: 'On route',
      findYourShipmentsDescription: 'Type in what you are looking for in the search field above',
      saveFrequency: 'Save frequency settings',
      saveRoute: 'Save route settings',
      saveShipments: 'Save shipments to route',
      shipmentsAddedToRoute: 'Shipments added to route',
      shipmentCopied: 'Template shipment copied',
      routeCreated: 'Recurring route created',
      routeUpdated: 'Recurring route updated',
      editRoute: 'Edit {{route}}',
      recurringRoutes: 'Recurring routes',
      selectRouteWithId: 'Select route with id {{id}}',
      rolloutInfoConfigured:
        'Automatic rollout uses department auto recurrent time {{time}} and rolls out routes for the following date.',
      rolloutInfoMissing:
        'Automatic rollout is not configured for this department because auto recurrent time is empty. Ask an admin to set this up.',
      addStop: 'Add stop',
      days: 'Days',
      dates: 'Dates',
      addException: 'Add exception',
      addedExceptions: 'Added exceptions',
      selectedOrders: 'Selected orders',
      moveShipment: 'Move shipment',
      moveShipmentModal: {
        errorMessage: 'Shipments: {{shipmentIds}}, error message: {{error}}',
        shipmentsMovedText: 'Shipments {{shipmentIds}}, {{stopIds}} have been moved to route {{route}}',
        partialSuccessMessage: '{{count}} of {{fullCount}} shipments were moved',
        title: 'Move selected shipment(s) to another route'
      },
      changeRoute: 'Change route',
      viewRoute: 'To route',
      plannedStops: 'Planned stops',
      templatePlannedStopId: 'Template planned stop',
      createdPlannedStopId: 'Created planned stop',
      notRouteConnected: 'Not on route'
    },
    corrections: {
      title: 'Corrections',
      headline: 'Order corrections for {{date}}',
      accepted: 'Order correction accepted',
      rejected: 'Order correction rejected',
      approve: 'APPROVE',
      decline: 'DECLINE',
      shipmentId: 'Shipment Id',
      courier: 'Courier',
      from: 'From',
      to: 'To',
      details: 'Details',
      pickupWaitingTime: 'PU waiting time (min)',
      deliveryWaitingTime: 'DEL waiting time (min)',
      pickupLoadingTime: 'PU loading time (min)',
      deliveryLoadingTime: 'DEL loading time (min)',
      comment: 'Comment',
      weight: 'Weight',
      volume: 'Volume',
      packages: 'Packages',
      serviceCode: 'Service code',
      noOrderCorrections: 'No order corrections',
      minutesOutOfRangeError: 'You must fill in a number between {{min}} and {{max}}',
      timeInMinutesWarning: 'Invalid time value, verify if correct'
    },
    dispatch: {
      assigningMultilegDelivery: 'Assigning {{count}} multileg delivery',
      assigningMultilegDelivery_other: 'Assigning {{count}} multileg deliveries',
      turningThisOnExplanation: '(Turning this on lets you override the route plan)'
    },
    suggestedUnits: {
      unitName: 'Unit Name',
      driverName: 'Driver Name',
      slotName: 'Route',
      timeAtLocation: 'Time at Location',
      distanceFromLocation: 'Distance from location',
      shipmentInformation: 'Shipment Information',
      suggestedVehicles: 'Suggested vehicles',
      suggestedVehiclesOnPickup: 'Suggested vehicles on pickup',
      suggestedVehiclesOnDelivery: 'Suggested vehicles on delivery',
      suggestedUnits: 'Suggested Units',
      noSuggestionsAvailable: 'No suggestions available',
      pickupTime: 'Pickup Time',
      deliveryTime: 'Delivery Time',
      filterBy: 'Filter by'
    },
    shipmentSummary: {
      unPrePlan: 'Unpreplan',
      prePlanTo: 'Preplan to'
    }
  },
  errors: {
    DIP_DESTINATION_ALREADY_MAPPED:
      'This pickup point is already connected to another DIP. Reload the page to see the current mappings.',
    ALREADY_ENQUEUED_FOR_INVOICING: 'Already enqueued for invoicing',
    DUPLICATE: 'Duplicate data',
    MISSING_DEPARTMENT_DETAILS:
      'The department does not have area and postal code information. Please add that before proceeding.',
    DEPARTMENT_INVALID_ALYSTRA_ID: 'Invalid department ID',
    EXPORT_DEPARTMENT_GROUP_TOO_LARGE: 'Please select a smaller department group or a smaller export date window',
    ENTITY_DOES_NOT_EXIST: 'Entity does not exist',
    RECURRING_ROUTE_REROLL_OUT_DATE_NOT_IN_FUTURE:
      'Recurring routes can only be rolled out again for a date after today',
    RECURRING_ROUTE_NOT_ROLLED_OUT: 'A selected route is not rolled out for this date. Reload the page and try again',
    RECURRING_ROUTE_ROLLOUT_IN_PROGRESS: 'A selected route is still being rolled out. Wait a few minutes and try again',
    ROUTE_ALREADY_CONNECTED_TO_ANOTHER_RULE:
      'The route is already connected to another route rule, please refresh and try again',
    INVALID_DATE_RANGE: 'Invalid date range',
    INVALID_DELIVERY_LATITUDE: 'Invalid delivery latitude',
    INVALID_DELIVERY_LONGITUDE: 'Invalid delivery longitude',
    INVALID_LATITUDE: 'Invalid latitude',
    INVALID_LONGITUDE: 'Invalid longitude',
    INVALID_OR_MISSING_TIME: 'Invalid or missing time',
    INVALID_PHONE_NUMBER: 'Invalid phone number',
    INVALID_BANNER_NAME: 'Invalid banner name',
    INVALID_WHATS_THIS_NAME: "Invalid What's this modal name",
    INVALID_CREDIT_ORDER: 'Cannot credit an order which has not been invoiced or has already been credited',
    DUPLICATE_PHONE_NUMBER: 'Duplicate phone number!',
    DUPLICATE_PHONE_NUMBER_COURIER: 'A driver is already registered with this phone number',
    INVALID_PICKUP_LATITUDE: 'Invalid pickup latitude',
    INVALID_PICKUP_LONGITUDE: 'Invalid pickup longitude',
    INVALID_SLOT_TYPE: 'Invalid slot type',
    MISSING_ADDRESS: 'Missing address',
    MISSING_ALYSTRA_ID: 'Missing id',
    MISSING_AREA: 'Missing area',
    MISSING_CAPACITY: 'Missing capacity',
    MISSING_COLOR: 'Missing color',
    MISSING_CONSIGNMENT_INPUTS: 'Missing consignment inputs',
    MISSING_CONSIGNMENT: 'Missing consignment',
    MISSING_CONSIGNMENTS: 'Missing consignments',
    MISSING_COURIER_ID: 'Missing courier id',
    MISSING_COURIER: 'You must select a courier',
    MISSING_CREATED_AT: 'Missing created at',
    MISSING_CUSTOMER_ID: 'Missing customer id',
    MISSING_CUSTOMER_REF: 'Missing customer ref',
    MISSING_DATE: 'Missing date',
    MISSING_DAYS: 'Missing days',
    MISSING_DEPARTMENT: 'Missing department',
    MISSING_DESCRIPTION: 'Missing description',
    MISSING_DEVIATION_TEXT: 'Missing deviation text',
    MISSING_END_LOCATION_LATITUDE: 'Missing end location latitude',
    MISSING_END_LOCATION_LONGITUDE: 'Missing end location longitude',
    MISSING_EVENT_DATA: 'Missing event data',
    MISSING_EVENT_TYPE: 'Missing event type',
    MISSING_FILE_NAME: 'Missing file name',
    MISSING_FROM_DATE: 'Missing from date',
    MISSING_ID: 'Missing id',
    MISSING_LOCATION_LATITUDE: 'Missing location latitude',
    MISSING_LOCATION_LONGITUDE: 'Missing location longitude',
    MISSING_LOCATION_POSITION: 'Missing location position',
    MISSING_LOCATION_TIME: 'Missing location time',
    MISSING_NAME: 'Missing name',
    MISSING_GROUP: 'Missing grouping',
    MISSING_PACKAGE_ID: 'Missing package id',
    MISSING_PHONE: 'Missing phone',
    MISSING_PLANNER_ID: 'Missing planner id',
    MISSING_SERVICE_CODE: 'Missing service code',
    MISSING_SHIPMENT_ID: 'Missing shipment id',
    MISSING_SLOT_ID: 'Missing slot id',
    MISSING_SLOT_TYPE: 'Missing slot type',
    MISSING_SMS_TOKEN: 'Missing sms token',
    MISSING_START_LOCATION_LATITUDE: 'Missing start location latitude',
    MISSING_START_LOCATION_LONGITUDE: 'Missing start location longitude',
    MISSING_TO_DATE: 'Missing to date',
    MISSING_ZIP_AREA: 'Missing postal area',
    MISSING_ZIP_CODE: 'Missing postal code',
    MISSING_COUNTRY_CODE: 'Missing country code',
    NO_SUCH_USER: 'No such user',
    BILLING_ORDER_AMOUNT_OUT_OF_VALID_RANGE: 'Maximum allowed price totals ({{limit, number}}) are exceeded',
    PARAM_NOT_OF_EXPECTED_TYPE: 'Param not of expected type',
    PARAM_NULL_NOT_ALLOWED: 'Param null not allowed',
    PTW_ALREADY_EXISTS: 'A production time window already exists for recipient ID {{recipientId}}.',
    QUERY_NAME_MISSING: 'Query name missing',
    QUERY_PARAMS_MISSING: 'Query params missing',
    USER_NOT_EXIST_OR_INCORRECT_ROLE: 'User not exist or incorrect role',
    USER_EXIST_BUT_INCOMPATIBLE_ROLE: 'User already exists and has another role',
    SLOT_CANNOT_BE_STARTED: 'Slot cannot be started',
    SLOT_CANNOT_BE_DELETED: 'Slot cannot be deleted',
    COURIER_NOT_PART_OF_DEPARTMENT: 'Courier not part of department',
    CONSIGNMENT_IN_INCORRECT_STATE_CANNOT_UPDATE: 'Consignment in incorrect state cannot update',
    ORDER_DOES_NOT_EXISTS: 'Order does not exists',
    OPTIMIZE_ALREADY_RUNNING: 'Optimize already running',
    OVERLAPPING_BANNERS: 'Url is overlapping with a existing banner',
    OVERLAPPING_WHATS_THIS_MODALS: "Url is overlapping with a existing what's this modal",
    CANNOT_CHANGE_ORDER: 'Cannot change order',
    NO_ACCESS: 'No access',
    NO_RELEVANT_CONSIGNMENTS_OR_SLOTS: 'No relevant consignments for given slots',
    NO_RELEVANT_CONSIGNMENTS: 'No relevant consignments for given slots',
    NO_RELEVANT_SLOTS: 'Only routes not started or on hold can be optimized using this feature',
    NOT_EQUAL_PICKUP_ADDRESSES: 'All pickup addresses must be equal to restrict all shipments to one driver',
    NO_SUGGESTIONS_FOUND_FOR_ORDERS: 'No drivers eligible for the orders',
    NO_SUCH_QUERY: 'No such query',
    EXCEL_MISSING_SHIPMENT_ID: 'Missing shipment id in cell {{col}} on row {{row}}',
    EXCEL_MISSING_CUSTOMER_REF: 'Missing customer ref in cell {{col}} on row {{row}}',
    EXCEL_MISSING_CUSTOMER_ID: 'Missing customer id in cell {{col}} on row {{row}}',
    EXCEL_MISSING_DEPARTMENT: 'Missing department in cell {{col}} on row {{row}}',
    EXCEL_MISSING_PACKAGE_ID: 'Missing package id in cell {{col}} on row {{row}}',
    EXCEL_MISSING_NAME: 'Missing name in cell {{col}} on row {{row}}',
    EXCEL_INVALID_PHONE: 'Invalid phone number in cell{{col}} on row {{row}}',
    EXCEL_MISSING_ADDRESS: 'Missing address in cell {{col}} on row {{row}}',
    EXCEL_MISSING_ZIP_AREA: 'Missing postal code in cell {{col}} on row {{row}}',
    EXCEL_MISSING_ZIP_CODE: 'Missing city in cell {{col}} on row {{row}}',
    EXCEL_MISSING_FROM_DATE: 'Missing from date in cell {{col}} on row {{row}}',
    EXCEL_MISSING_TO_DATE: 'Missing to date in cell {{col}} on row {{row}}',
    EXCEL_INVALID_FROM_DATE: "From date can't be before today. Found in cell {{col}} on row {{row}}",
    EXCEL_INVALID_TO_DATE: "To date can't be before today. Found in cell {{col}} on row {{row}}",
    EXCEL_MISSING_NOTIFICATION_SMS: 'Missing notification SMS in cell {{col}} on row {{row}}',
    EXCEL_MISSING_SIZE: 'Missing size in cell {{col}} on row {{row}}',
    EXCEL_MISSING_ORDERS: 'No orders found in the spreadsheet.',
    EXCEL_MISSING_COUNTRY: 'Missing country code or name in cell {{col}} on row {{row}}',
    EXCEL_NO_ACCESS_DEPARTMENT: 'No access to department "{{dept_ref}}" as found in on row {{row}}',
    EXCEL_MISSING_DESCRIPTION: 'Missing description in "{{cell}}" on row {{row}}',
    EXCEL_MISSING_PICKUP_INSTRUCTIONS: 'Missing pickup description in "{{cell}}" on row {{row}}',
    EXCEL_MISSING_DELIVERY_INSTRUCTIONS: 'Missing delivery description in "{{cell}}" on row {{row}}',
    EXCEL_TOO_MUCH_DATA: 'Report is too large. Consider exporting for a narrower date range or fewer departments.',
    MISSING_PICKUP_LOCATION_AND_TIME: 'Missing pickup location and time',
    MISSING_EARLIEST_PICKUP_DATE: 'Missing earliest pickup date',
    MISSING_LATEST_PICKUP_DATE: 'Missing latest pickup date',
    MISSING_EARLIEST_DELIVERY_DATE: 'Missing earliest delivery date',
    MISSING_LATEST_DELIVERY_DATE: 'Missing latest delivery date',
    INVALID_EARLIEST_PICKUP_DATE: 'Invalid pickup date',
    INVALID_LATEST_PICKUP_DATE: 'Invalid pickup date',
    INVALID_EARLIEST_DELIVERY_DATE: 'Invalid delivery date',
    INVALID_LATEST_DELIVERY_DATE: 'Invalid delivery date',
    CANNOT_MODIFY_ORDERS_FROM_DIFFERENT_SOURCE: 'Cannot modify API orders from Excel',
    PICKUP_EARLIEST_SHOULD_BE_BEFORE_DELIVERY_LATEST: 'Pickup time should be before delivery time',
    DELIVERY_EARLIEST_SHOULD_BE_BEFORE_DELIVERY_LATEST: 'Delivery earliest must be before delivery latest',
    CANNOT_DELIVER_ON_A_HOLIDAY: 'Cannot deliver on a holiday',
    MISSING_TEMPLATE_ID: 'Missing template id',
    TEMPLATE_DOES_NOT_EXIST: 'The template does not exist',
    TEMPLATE_CANNOT_BE_DELETED: 'The template cannot be deleted',
    MISSING_TEMPLATE_SLOTS: 'The template is missing slots',
    TEMPLATE_NAME_ALREADY_EXISTS: 'Template with this name already existing',
    COURIER_ALREADY_EXISTS: 'There is already another courier with this phone number',
    ORDER_EXIST_FOR_SERVICE: 'Cannot delete service as orders exist for this service',
    NO_SERVICE_FOUND: 'Add a service before adding customer mapping',
    CANNOT_DELETE_AS_SERVICE_EXIST: 'Delete customer service mapping before deleting service',
    SLOT_IN_INCORRECT_STATE_CANNOT_UPDATE: 'Slot is not in a valid state for this update',
    GRAPHHOPPER_UNASSIGNED:
      'Could not assign all shipments (because of time, capacity or other factors), details: {{details}}',
    GRAPHHOPPER_REQUEST_FAILED: 'The request for optimizing the route failed',
    GRAPHHOPPER_LATEST_ARRIVAL_AT_DELIVERY_AFTER_EARLIEST_DEPARTURE:
      'Latest arrival at delivery cannot be after earliest departure - is pickup time window in the past?',
    GRAPHHOPPER_EARLIEST_GREATER_THAN_LATEST:
      'Earliest time cannot be greater than latest - is some of the times in the past?',
    GRAPHHOPPER_PICKUP_EARLIEST_AFTER_LATEST:
      'Pickup time window for shipment {{shipmentId}} cannot be in the past ({{pickupEarliest}} - {{pickupLatest}})',
    GRAPHHOPPER_DELIVERY_EARLIEST_AFTER_LATEST:
      'Delivery time window for shipment {{shipmentId}} cannot be in the past ({{deliveryEarliest}} - {{deliveryLatest}})',
    GRAPHHOPPER_INVALID_PICKUP_LOCATION:
      "Missing pickup coordinates for shipment {{shipmentId}}. Please resolve the address using the 'Set Coordinates' page.",
    GRAPHHOPPER_INVALID_DELIVERY_LOCATION:
      "Missing delivery coordinates for shipment {{shipmentId}}. Please resolve the address using the 'Set Coordinates' page.",
    GRAPHHOPPER_REQUEST_LIMIT_VIOLATED:
      'The limit for the number of requests to Graphhopper has been reached, please try again in a minute',
    SLOT_CANNOT_BE_EDITED: 'Slot is not in a valid state for this update',
    INVALID_POSTCODE_AND_COUNTRY_CODE_CANNOT_BE_HANDLED: 'Invalid postal code and country code',
    INVALID_BASIC_SERVICE_CODE: 'Invalid basic service code',
    INVALID_PICKUP_DATE_EARLIEST_FORMAT: 'Invalid pickup date earliest format',
    INVALID_PICKUP_DATE_LATEST_FORMAT: 'Invalid pickup date latest format',
    INVALID_DELIVERY_DATE_LATEST_FORMAT: 'Invalid delivery date latest format',
    INVALID_DELIVERY_DATE_EARLIEST_FORMAT: 'Invalid delivery date earliest format',
    INVALID_POSTAL_CODE: 'Invalid postal code',
    INVALID_MEASUREMENT_UNIT: 'Invalid measurement unit',
    MISSING_CONSIGNMENT_SET: 'Missing consignment set',
    MISSING_UPDATE_INDICATOR: 'Missing update indicator',
    MISSING_CONSIGNMENT_ID: 'Missing consignment id',
    MISSING_REFERENCE_NO: 'Missing reference id',
    MISSING_PACKAGE: 'Missing package',
    MISSING_DELIVERY_DATE_EARLIEST: 'Missing delivery date earliest',
    MISSING_DELIVERY_DATE_LATEST: 'Missint delivery date latest',
    MISSING_CONSIGNEE: 'Missing consignee',
    MISSING_CONSIGNOR: 'Missing consignor',
    MISSING_POSTAL_CODE: 'Missing postal code',
    MISSING_CITY: 'Missing postal area',
    MISSING_PICKUP_DATE_LATEST: 'Missing pickup date latest',
    MISSING_PICKUP_DATE_EARLIEST: 'Missing pickup date earliest',
    MISSING_CONSIGNOR_PARTY_ID: 'Missing consignor party id',
    INVALID_CUSTOMER_NO_MAPPING: 'Invalid customer number mapping',
    INVALID_ROUTING: 'Invalid routing',
    NO_SERVICE_MATCHING_SERVICE_CODE: 'No service matching service code',
    NO_SERVICE_MATCHING_DAY_OF_WEEK: 'No service matching day of week',
    NO_SERVICE_MATCHING_PICKUP_AND_DELIVERY_TIMES: 'No service matching pickup and delivery times',
    ORDER_WAS_AFTER_CUTOFF_TIME: 'Order was after cutoff time',
    OPTIMUS_SERVICE_MUST_HAVE_PICKUP_AND_DELIVERY_TIMES: 'Must have pickup and delivery times',
    ORDER_CANNOT_BE_MOVED: 'The shipment cannot be moved, it must not be assigned to a slot',
    MISSING_DESTINATION_DEPARTMENT_ID: 'Missing destination department',
    SHIPMENT_NOT_FOUND: 'Shipment not found',
    SHIPMENT_IN_INCORRECT_STATE: 'Shipment has already been assigned to a route',
    DUPLICATE_EXCEL_IMPORT:
      'The same filename has already been imported to this department today. You can see the results of that import <0>here</0>. Please change the filename if you wish to import it again.',
    noOrdersForDateAndCourier: 'No orders present for the selected date and unit',
    SHIPMENT_INVALID_QUERY:
      'During Peak search will be limited to ensure performance. You can search for all orders on one day or add a search parameter.',
    DURATION_IS_MORE: 'Please limit your search to a period of {{maxDuration}} days.',
    ADDRESS_CANNOT_BE_DELETED: 'Address is used as default address and cannot be deleted.',
    INVALID_ORDER_BILLING_CUSTOMER_NUMBER:
      '{{locale}}Order billing customer number for type - {{orderBillingType}} is either null or invalid',
    MISSING_ORDER_BILLING_TYPE: 'Missing order billing type',
    INVALID_ORDER_BILLING_TYPE:
      'Order billing type must be one of {{orderBillingTypes}}, but was - {{orderBillingType}}',
    INVALID_ORDER_BILLING_INFO: 'Invalid order billing info',
    UNKOWN_ERROR: 'Changes could not be saved',
    INCORRECT_STATES_OR_ASSIGNED_TO_SLOT: 'Incorrect state or assigned to route',
    CANNOT_MOVE_ORDERS: 'Cannot move orders',
    DESTINATION_DEPARTMENT_INELIGIBLE: 'Destination department ineligable',
    DEPARTMENT_MISSING_ADDRESS_DETAILS: 'Department is missing address details',
    MISSING_DELIVERY_PHONE_NUMBER: 'Phone number is missing for',
    INVALID_DELIVERY_PHONE_NUMBER: 'Phone number is not valid for',
    SMS_SERVICE_NOT_ORDERED: 'SMS service is not ordered for',
    CANNOT_SEND_SMS_FOR_MESTER_GRONN_FUNERAL: 'Mester Grønn funeral is ordered for',
    SLOT_ROUTED_IN_HAPPY_FLOW: 'Slot is routed in Happy Flow for',
    SERVICE_LEVEL_SHOULD_NOT_BE_NONE: 'Service level is "none" for',
    SLOT_NAME_ALREADY_CREATED: 'Route name already exists',
    ORDER_IN_INCORRECT_STATE: 'Order is in incorrect state',
    ORDER_IN_INCORRECT_STATE_other: 'Order is in incorrect state',
    INVALID_PARAMETERS: 'Invalid parameters, {{description}}',
    ROLE_IN_USE: 'The role cannot be removed since the role is in use.',
    INVALID_NAME: 'Role name must be unique. A role with this name already exist.',
    BANNER_ALREADY_EXISTS: 'Banner name must be unique. A banner with this name already exist.',
    BANNER_NAME_TOO_BIG: 'Banner name is too long. Should be max 200 characters',
    CMS_NEWS_ALREADY_EXISTS: 'Update name must be unique. An update with this name already exist.',
    CMS_NEWS_NAME_TOO_BIG: 'Update name is too long. Should be max 200 characters',
    INVALID_CMS_NEWS_NAME: 'Invalid update name',
    TEXT_CANNOT_BE_DELETED:
      'Text is used on a service and cannot be deleted. Disconnect text from service in order to delete.',
    FAILED_DELETING_WEBHOOK_SUBSCRIPTION: 'Webhook subscription could not be deleted. Try again later.',
    DEFAULT_ROLE_ALREADY_EXISTS: 'A different role {{name}} is already default for the same user type',
    INVALID_INVOICING_STATUS: 'Order is not in correct state for invoicing',
    ORDER_NOT_READY_FOR_INVOICING: 'Order is not ready for invoicing',
    ORDER_IS_PAUSED_FROM_INVOICING: 'Orders is paused from invoicing',
    ORDER_IS_EXCLUDED_FROM_INVOICING: 'Order is excluded from invoicing',
    MISSING_ORDER_CORRECTION: 'Order is missing an order correction',
    INVALID_MULTILEG_STATE_FOR_INVOICING: 'Some orders in the multileg group are not ready for invoicing',
    VEHICLE_IN_USE:
      "The vehicle is connected to unit {{units}} and can't be deleted. Remove the vehicle from the unit and try again.",
    DEPARTMENT_MATRIX_ALREADY_EXISTS: 'Only one department matrix is supported',
    CUTOFF_MATRIX_ALREADY_EXISTS: 'Only one cutoff matrix is supported',
    MISSING_ACCESS_TO_DEPARTMENTS: 'Missing access to departments {{missingDepartments}}',
    DUPLICATE_PLANNED_STOP_LOCATION_NAME:
      'We cannot have multiple planned stop locations with the same name on a department. Please keep unique names for each planned stop location.',
    AREA_PINS_TOO_CLOSE:
      'The map points on the route must be at least {{minDistanceInMeters}} meters apart. Move them farther from each other.',
    DUPLICATE_TEMPLATE_ROUTE_NAME:
      'Another recurring route in this department has the same name. Routes with the same name are merged into one route when rolled out, so choose a different name.',
    PLANNED_STOP_LOCATION_IN_USE:
      'Cannot edit or delete planned stop locations - [{{locations}}] that are already in use.',
    TEMPLATE_IS_DEFAULT_FOR_DEPARTMENT:
      'The template cannot be deleted as it is set as default for a department. Please change the default template for the department before deleting this template.'
  },
  customer: {
    customer: 'Customer',
    groups: {
      titleSingular: 'Customer group',
      titleWithCount: '{{count}} customer groups',
      name: 'Group name',
      description: 'Description',
      numberOfCustomers: 'Number of customers',
      none: 'No customer groups',
      new: 'New customer group',
      edit: 'Edit customer group',
      searchCustomer: 'Search customer',
      members: 'Customers in group',
      save: 'Save',
      deleteConfirm: 'Delete {{name}}?',
      deleteDescription: 'You will not be able to recover this action',
      deleted: 'Customer group was successfully deleted',
      mustProvideName: 'You must provide group name',
      cannotDelete: "Customer group can't be deleted because it is used in a preadvice rule."
    },
    customerTitle: 'Customers',
    customerNo: 'Customer No',
    name: 'Name',
    emailToSender: 'Email to sender',
    emailSubscriptions: 'Email subscriptions',
    emailToSenderDescription:
      'Set default notifications for all orders from this customer number, for example order registration and deliveries.',
    deviations: 'Deviations',
    deviationsDescription: 'Set up customer specific deviations in the courier app.',
    settings: {
      webhook: {
        overviewTitle: 'Webhook Configuration',
        create: 'Click on the button to create a Webhook configuration',
        delete: {
          title: 'Delete subscription',
          description: 'You will not be able to recover this action',
          successfullyDeleted: 'Webhook subscription was successfully deleted'
        },
        newOrEdit: {
          createTitle: 'Create new webhook configuration',
          editTitle: 'Edit webhook configuration',
          created: 'New webhook configuration was successfully created',
          updated: 'Webhook configuration was successfully updated',
          endpoint: 'Endpoint',
          endpointDescription: 'Enter the URL where the event data should be sent',
          httpAuthentication: 'HTTP Basic Authentication',
          username: 'Username',
          password: 'Password',
          retryPolicy: 'Retry policy',
          retryPolicyDescription: 'If the webhook fails, configure the times and delays between retries.',
          retry: '{{count}} retry',
          retry_other: '{{count}} retries',
          retryDescription: 'Number of retries',
          delay: {
            description: 'Delay before retrying',
            value: 'Delay {{seconds}} seconds'
          },
          pause: 'Pause this subscription for now',
          pauseTooltip:
            'Pause will queue events send out until it is released again. Upon release queued events will be resent.',
          validation: {
            endpointError: 'You must provide a valid URL',
            endpointRequired: 'URL is required',
            usernameRequired: 'Username is required',
            passwordRequired: 'Password is required',
            passwordNotLongEnoughError: 'Password must be at least 8 characters',
            noEventSelectedError: 'You must select at least one event',
            retryDelayRequired: 'Retry delay is required'
          }
        },
        count: '{{count}} subscription',
        count_other: '{{count}} subscriptions',
        noSubscriptions: 'You have no subscriptions at the moment',
        events: {
          prefix: 'Subscribed to ',
          all: 'all',
          suffix: ' events'
        },
        state: {
          running: 'Running',
          paused: 'Paused'
        },
        event: {
          CREATED: 'order is registered',
          ROUTE_PLANNING_COMPLETE: 'delivery route has been finalized',
          COLLECTED: 'driver collected the goods',
          DELIVERED: 'driver delivered the goods',
          DEVIATED: 'driver has added deviation to the order',
          SCANNED: 'order has passed transit terminal',
          ARRIVED_AT_TERMINAL: 'order has arrived to distributing terminal',
          DAMAGED: 'order has been damaged',
          RETURNED: 'driver handed over goods back to terminal',
          PICKUP_ETA_SMS_SENT: 'sms with estimated time of arrival for collection has been sent',
          ETA_SMS_SENT: 'sms with estimated time of arrival for delivery has been sent',
          PRE_ADVICE_PULL_SMS_SENT: 'sms with possible delivery windows has been sent',
          DELIVERY_TIME_ORDERED: 'recipient has chosen delivery time',
          PRE_ADVICE_PUSH_SMS_SENT: 'sms with ordered delivery window has been sent to recipient',
          PICKUP_SMS_SENT: 'sms about coming delivery has been sent to recipient',
          APARTMENT_INFORMATION_UPDATED: 'recipient has update delivery details'
        }
      }
    },
    add: 'Add',
    noOrders: 'No orders in Glow',
    noOrdersDescription: 'The customers you have access to do not have any orders in Glow',
    choose: 'Please select a customer',
    findCustomer: 'Find a customer',
    manageCustomers: 'Manage customers',
    searchAndSelect: 'Search and select customer',
    changeCustomer: 'Change customer',
    customerPlaceHolder: 'Search for customers',
    emailRecipients: 'Email recipients',
    smsRecipients: 'Sms recipients',
    addEditEmails: 'Add/edit emails',
    addEditSms: 'Add/edit sms',
    addEditDeviations: 'Add/edit deviations',
    live: 'Live',
    search: 'Search',
    startTypingPlaceHolder: 'Start typing',
    AddEdit: 'Add/Edit',
    searchHint: 'Search for shipments based on shipment id, customer ref, package id, delivery name or address',
    customerNumber: 'Customer number',
    customerNumberAlreadyExists: 'Customer number already exists',
    accountingType: 'Accounting type',
    accountingTags: 'Accounting tags',
    senderName: 'Sender name',
    senderNameIngress: 'Override the customer name set in Glow when sending sms notifications.',
    addSenderName: 'Add a sender name',
    senderNameAdded: 'Sender name added',
    addInvoiceHDOrdersFromDate: 'Add start date for HD order invoicing through Glow',
    invoiceHDOrdersFromDate: 'Invoice HD orders in Glow from date',
    invoiceHDOrdersFromDateDescription: 'Set a date for when Glow Pricing Engine is activated for HD customers.',
    invoiceHDOrdersFromDateAdded: 'Start date for HD order invoicing in Glow has been changed',
    addNPSFromDate: 'Add start date for NPS',
    activateNPSFromDate: 'Activate NPS from date',
    activateNPSFromDateIngress:
      'Set a start date for activating NPS (Net Promoter Score) from Medallia. This function requires the customer to also be set up in Medallia.',
    npsFromDateUpdated: 'Start date for NPS has been changed',
    isDeleted: 'Is deleted',
    deletedCannotBeUsed: 'The customer is deleted and cannot be used. Select another customer.',
    scanOnPickup: {
      title: 'Scan packages on pickup',
      ingress: 'Turn on if the courier should be forced to scan packages on pickup.'
    },
    scanToCreatePackages: {
      title: 'Scan to create packages',
      label: 'Use scan to create packages',
      details:
        'When enabling scan to create packages the courier is forced to scan packages on pickup. The scanned packages will automatically be updated on the shipment',
      success: 'Scan to create packages updated',
      enabled: 'Enabled',
      disabled: 'Disabled'
    },
    billingCustomerNumber: 'Billing customer number',
    billingCustomerNumberIngress:
      'Override the invoice number if the invoicing should happen on a different customer number.',
    invoiceSplit: {
      title: 'Invoice split',
      legend: 'Explanation',
      label: 'Set invoice split',
      NotSet: 'Not set',
      Department: 'Department',
      Service: 'Service',
      Custom: 'Custom',
      columLabel: 'Name',
      addedItems: 'Added invoice rules ({{count}})',
      newItemLabel: 'Type in invoice split',
      existingItem: 'Text already exists. Try searching for the text below.',
      existingItemShort: 'Text already exists.',
      emptyItem: "Text can't be empty.",
      updated: 'Invoice split was successfully added'
    },
    addBillingCustomerNumber: 'Add billing customer number',
    billingCustomerNumberAdded: 'Billing customer number added',
    searchPage: {
      fromDate: 'From date',
      toDate: 'To date',
      today: 'Today',
      tomorrow: 'Tomorrow',
      yesterday: 'Yesterday',
      last30days: 'Last 30 days',
      plusMinus15Days: '+/- 15 days',
      plusMinus30Days: '+/- 30 days'
    },
    smsText: {
      title: 'Override notification texts',
      ingress: 'Set up customer unique texts in the SMS to recipients.',
      addEditSmsText: 'Add/edit texts',
      smsTextUpdated: 'SMS Text added/ updated',
      en: 'ENG',
      se: 'SWE',
      no: 'NOR',
      fi: 'FIN',
      dk: 'DEN',
      fr: 'FRA',
      description: 'Description',
      smsType: 'Notification type',
      smsTypeTexts: {
        common: 'SMS',
        preadvice: 'Preadvice',
        pickup: 'Tracking SMS',
        pre_pickup: 'Pre-tracking SMS',
        manual_delay: 'Manual Delay SMS',
        eta_pickup: 'ETA Pickup SMS',
        eta_delivery: 'ETA Delivery SMS',
        flex_delivery_confirmation: 'Flex Delivery Confirmation SMS',
        advise: 'Advise SMS',
        delivery_confirmation: 'Delivery Confirmation SMS',
        pre_advice_push: 'Push SMS',
        pre_advice_push_for_prebooked: 'Push for prebooked customers SMS',
        pre_advice_push_return: 'Push Return SMS',
        pre_advice_push_email: 'Push email',
        pre_advice_push_2nd: 'Push 2nd preadvice SMS',
        pre_advice_push_2nd_email: 'Push 2nd preadvice email',
        pre_advice_push_return_to_sender_email: 'Push return to sender email',
        pre_advice_pull: 'Pull SMS',
        pre_advice_pull_email: 'Pull email',
        pre_advice_pull_reminder: 'Pull reminder SMS',
        pre_advice_pull_reminder_email: 'Pull reminder email',
        pre_advice_pull_reminder_to_sender_email: 'Pull reminder to sender email',
        pre_advice_pull_return_to_sender_email: 'Pull return to sender email',
        pre_advice_return: 'Return delivery SMS',
        pre_advice_return_email: 'Return delivery email',
        pre_advice_return_reminder: 'Return delivery reminder SMS',
        pre_advice_return_reminder_email: 'Return delivery reminder email',
        pre_advice_return_2nd: 'Return delivery 2nd preadvice SMS',
        pre_advice_return_2nd_email: 'Return delivery 2nd preadvice email',
        pre_advice_return_return_to_sender_email: 'Return delivery return to sender email',
        pre_advice_pup: 'PUP SMS',
        pre_advice_pup_email: 'PUP email',
        pre_advice_pup_reminder: 'PUP reminder SMS',
        pre_advice_pup_reminder_email: 'PUP reminder email',
        pre_advice_pup_reminder_to_sender_email: 'PUP reminder to sender email',
        pre_advice_pup_return_to_sender_email: 'PUP return to sender email',
        delivery: 'Delivery SMS',
        deviated: 'Delivery deviation SMS',
        pre_advice_push_prebooked_recycle_sms: 'Push prebooked recycle SMS'
      }
    },
    showNotCollected: 'Not collected',
    booking: {
      pickupReady: 'Pickup ready',
      pickup: 'Pickup',
      delivery: 'Delivery',
      deliveryAvailable: 'Delivery available',
      serviceMessage: 'Remember to add both pickup and delivery information to see available services',
      priceComment:
        'You will be billed according to your customer agreement with Bring. Fees are not included in this price.',
      serviceUnavailable: 'The seleced service is not available for postal code {{postalCode}}',
      recipientPrice: 'Recipient price:',
      customerContactPlaceholder: 'Ordered by – This field is visible on the customer invoice'
    },
    email: {
      addToList: 'Add email to list',
      addChangesToList: 'Add email changes to list',
      emailTitle: 'E-mail to customer',
      getNotificationsFor: 'Get notifications for',
      emailAddress: 'Email address',
      emailAddressError: 'You must enter an email address',
      createdEvent: 'Registered',
      collectedEvent: 'Pickup',
      deliveredEvent: 'Delivery',
      returnToSender: 'Return to sender',
      reminderToSender: 'Reminder to sender',
      save: 'Save',
      email: 'E-mail',
      edit: 'Edit',
      delete: 'Delete',
      emailExists: 'E-mail already exists',
      invalidEmail: 'Invalid e-mail',
      true: 'Yes',
      false: 'No',
      claimsReported: 'Claims reported by recipient',
      claims: 'Claims',
      notificationType: {
        standard: 'Standard information',
        hdPreAdvice: 'HD preadvice',
        reportsFromRecipients: 'Reports from recipients',
        error: 'You must enter type of notifications'
      },
      customizedNotifications: 'Customized notifications ({{count}})',
      mustAddEmailToList:
        'In order for the email addresses to be saved when pressing add setting, you must add them to the list',
      informationToCustomer: 'Information to customer',
      returnToCustomer: 'Return to customer',
      addEmailToList: 'Add email to list',
      registeredEmailSubscription: 'Registered email subscription',
      updateEmail: 'Update email',
      noRegisteredEmails: 'No registered emails',
      detailsSavedSuccessfully: 'Email to sender was successfully saved'
    },
    customerDeviations: {
      new: 'Add new Deviation',
      deviationTitle: 'Deviations for customer',
      addDeviation: 'Add new deviation',
      editDeviation: 'Edit deviation',
      en: 'ENG',
      sv: 'SWE',
      nb: 'NOR',
      fi: 'FIN',
      dk: 'DEN',
      event: 'Event',
      reason: 'Reason',
      action: 'Action',
      submit: 'Submit',
      deviationCode: 'Deviation code',
      deviationCodesLabel: 'Deviation codes',
      deviation: 'Deviation',
      deviationType: 'Deviation type',
      description: 'Description',
      code: 'Code',
      edit: 'Edit',
      delete: 'Delete',
      deviationAdded: 'Deviation added',
      deviationEdited: 'Deviation edited',
      deviationExists: 'Deviation already exists',
      deviationDeleted: 'Deviation deleted'
    },
    customerInfo: 'Customer Info',
    customerInformation: 'Customer information',
    customerName: 'Customer Name',
    invoicingAddress: 'Invoicing Address',
    organisationNumber: 'Organisation Number',
    visitingAddress: 'Visiting Address',
    creditBlocked: 'Credit Blocked',
    creditBlockedFrom: 'Credit Blocked from date',
    creditBlockedFromInfo: 'Block credit for this customer from a select date',
    creditBlockedIngress: 'Set the last date to create orders in Glow for this customer.',
    from: 'From',
    address: 'Address',
    zipCode: 'Postal Code',
    zipArea: 'Postal Area',
    country: 'Country',
    edit: 'Edit {{name}}',
    selectCountry: 'Select country',
    settingsInGlow: 'Settings in Glow',
    addSetting: 'Add setting',
    editSetting: 'Edit setting',
    addNewCustomer: 'Add new customer',
    bookingPage: 'Booking page',
    bookingPageCustomerPortal: 'Booking page on Customer Portal',
    bookingPageIngress:
      'Turn off booking if the customer should not be able to book shipments on this customer number in the Glow customer portal.',
    bookingPageModalHeading: 'Booking in Customer portal',
    bookingPageModalDescription:
      'The customer should be able to book shipments on this customer number in the Glow customer portal',
    brandedTrackingModalHeading: 'Branded Tracking Invoicing',
    brandedTrackingModalDescription: 'Turn on to activate invoicing for Branded Tracking.',
    returnLastLegModalHeading: 'Return last leg',
    returnLastLegModalDescription:
      'Selecting "yes" splits the order and adds return delivery leg. "No" indicates no delivery leg needs to be created. "Not set" indicates that return handling rule is not defined for a specific customer.',
    returnAddressModalHeading: 'Goods return address',
    removeReturnAddressModalHeading: 'Remove current goods return address',
    removeReturnAddressConfirm: 'Are you sure you want to remove the current goods return address?',
    returnAddressModalDescription:
      'Enter the goods return address to use when goods are being returned from the terminal',
    bookingActive: 'On',
    bookingInactive: 'Off',
    brandedTrackingActive: 'On',
    brandedTrackingInactive: 'Off',
    bookingPageAvailable: 'Yes',
    bookingPageHidden: 'No',
    customerBookingPageAccessUpdated: 'Booking page access updated',
    brandedTrackingAccessUpdated: 'Branded Tracking Invoicing status updated',
    returnLastLegUpdated: 'Return last leg status updated',
    returnAddressUpdated: 'Return address updated',
    returnAddressRemoved: 'Return address removed',
    connectMatrices: 'Connect matrices',
    customerMatrices: 'Customer matrices',
    customerMatricesIngress: 'Connect customer number to existing matrices.',
    useTerminalAddressUpdated: 'Use terminal address status updated',
    useTerminalAddressModalHeading: 'Use terminal address',
    useTerminalAddressModalDescription:
      'Selecting "Yes" indicates using the department\'s terminal address while creating orders. "No" indicates skipping the logic of using terminal address.',
    token: {
      warningDark: "This customer is blocked and can't create any bookings. Unblock to activate the customer.",
      warningLight: "Make sure to copy the API key now. You won't be able to see it again!",
      success: 'You have already generated an API key for this customer',
      allowApiKey: 'Allow API key for customer',
      allowApiKeyDescription: 'Before generating an API key, you first need to allow this action to be done.',
      allowApiKeyButtonText: 'Allow API key',
      apiKeyCopied: 'API key has been copied',
      generateApiKeyDescription:
        'The API key is a unique key per customer. The key is used when your customer is creating a booking in\n' +
        '              customer portal. Read more about our API <0>here</0>.',
      generateApiKey: 'Generate API key'
    },
    nonInvoiceable: 'Non-invoiceable',
    internalNonInvoiceable: 'Internal / Non-invoiceable customer'
  },
  serviceMapping: {
    title: 'Services',
    serviceName: 'Service Name',
    pickupTime: 'Pickup Time',
    pickupDuration: 'Pickup duration',
    pickupPreparation: 'Pickup preparation',
    deliveryTime: 'Delivery Time',
    deliveryDuration: 'Delivery duration',
    deliveryPreparation: 'Delivery preparation',
    internalName: 'Internal name',
    internalDescription: 'Internal description',
    externalName: 'External name',
    externalDescription: 'External description',
    allowFlexDelivery: 'Allow Flex Delivery',
    timeWindow: 'Time window',
    serviceMappingType: 'Type',
    serviceLevel: 'Service level',
    service: 'Service',
    vas: 'VAS',
    stopsBeforeShowEta: 'ETA Stops',
    minutesUntilDelivery: 'ETA Min',
    sendAutomaticEtaSmsHeading: 'ETA SMS',
    createNew: 'Create new',
    serviceAndVasCodes: 'Services and VAS Codes',
    successfullyAdded: 'Service mapping was successfully added to the list',
    successfullyUpdated: 'Service mapping was successfully updated',
    successfullyDeleted: 'Service mapping has been successfully deleted',
    editService: 'Edit service',
    createNewService: 'Create new service',
    settingsHeading: 'Settings for service or VAS',
    selectLevel: 'Select level',
    standardLevel: 'Standard',
    customerLevel: 'Customer',
    customerSpecific: 'Customer specific',
    selectServiceType: 'Select type of service',
    vasToolTip: 'Value Added Service ex. ID Control',
    customerNumber: 'Customer Number',
    pickupTimeInSeconds: 'Pickup Service time (seconds)',
    pickupPreparationTime: 'Pickup preparation time (seconds)',
    deliveryTimeInSeconds: 'Delivery Service time (seconds)',
    deliveryPreparationTime: 'Delivery preparation time (seconds)',
    pickupDurationSecondsApartment: 'Pickup Time for Apartments (seconds)',
    deliveryDurationSecondsApartment: 'Delivery Time for Apartments (seconds)',
    deliveryDurationApartmentHeading: 'Delivery duration for Apartments (currently only for H2)',
    timeWindowInMinutes: 'Time Window (minutes)',
    stopsLeftHeading: 'When do you want the exact ETA to be shown to the customer?',
    stopsLeftDescription: 'If you leave this field empty, time window will be displayed',
    amountOfStops: 'Amount of stops',
    flexibleDelivery: 'Flexible Delivery',
    flexibleDeliveryDescription: 'Allow recipient to have the option for the packge to be placed outside the door',
    flexibleDeliveryCheckboxText: 'Yes, recipient should be allowed',
    flexOptions: 'Flex Options',
    flexOptionsDescription:
      'We offer customers two different Flex delivery options. The first option, Extended Flex, allows the driver to leave the goods in various agreed locations at the delivery address. The second option, Flex, is a simpler alternative where the goods are placed only at the property boundary. Extended Flex is the default option, but customers can choose to switch to the simpler Flex option if preferred.',
    unattendedFlex: 'Flex (Unattended)',
    extendedFlex: 'Extended Flex (Flex)',
    linkTextToService: 'Link text to Service',
    linkTextToServiceDescription: 'If no text is selected, default text will be used',
    defaultText: 'Default Text',
    listOfServicesAndVases: 'List of services and VAS codes',
    searchService: 'Search for service, VAS or customer number',
    customizedText: 'Customized text',
    deleteModalTitle: 'Delete Service Mapping',
    deleteModalDescription: 'You will not be able to recover this action',
    infoModal: {
      title: 'What is shown where in Glow',
      subHeading1: 'Planners and Drivers',
      description1: 'Internal name : The name of the service, example "Home Delivery"',
      description2:
        'Internal description: Extended information about the service, example "This should be carried to the recipients chosen room."',
      subHeading2: 'Customers and recipients',
      description3: 'External name: The name of the service, example "Home Delivery"',
      description4:
        'External description: Extended information about the service, example "Your goods will be carried to a room of your choice".'
    },
    routeOptimizing: 'Route planning',
    routeOptimizingDescription:
      'The information you provide here will override the default time and will affect the route optimization. Preparation time can be used for services where many shipments are delivered to the same recipient. The first shipment will then have a delivery duration of the preparation time plus delivery time combined while additional shipments to the same recipient will have a delivery duration that equals the delivery time. <br><br>Default set up for pickups is 15 seconds preparation time and 1 second per shipment.<br>Default setup for deliveries is 180 seconds preparation time and 10 seconds per shipment.<br><strong>Please note that it may take up to 10 minutes before any changes are reflected in the system.</strong>',
    settingsRecipientTrackingPage: 'Recipient tracking page',
    etaComponentHeading: 'Display exact ETA on recipient page',
    etaComponentDescription:
      'Enabling this will give you the option to decide when the exact ETA should be shown to the recipient instead of the ETA time window.',
    displayExactEta: 'Yes, display exact ETA',
    stopsLeftSelected: 'Amount of stops left until delivery',
    minutesLeftSelected: 'Amount of minutes left until delivery',
    numberOfMinutes: 'Amount of minutes',
    numberOfStops: 'Amount of stops',
    sendAutomaticEtaSmsTitle: 'Send automatic SMS to the recipient',
    sendAutomaticEtaSmsDescription:
      'Enabling this will also disable the function for the driver to send SMS from the driver app.',
    sendAutomaticEtaSms: 'Send SMS automatic',
    missingNumberOfStops: 'Please enter a valid amount of stops when "Send SMS automatic" is checked',
    missingNumberOfMinutes: 'Please enter a valid amount of minutes when "Send SMS automatic" is checked',
    minutesNotInRange: 'Please set amount of minutes in between {{from}} and {{to}}',
    serviceDeliveryType: 'Service delivery type',
    noServiceDeliveryTypeSelected: 'Not set',
    serviceDeliveryTypes: {
      Delivery: 'Delivery',
      Return: 'Return',
      PickupPoint: 'Pickup Point'
    },
    Delivery: 'Delivery',
    Return: 'Return',
    Pickup: 'Pickup',
    PickupPoint: 'Pickup Point',
    courierApp: 'Courier app',
    allowCourierDescription: 'Allow courier to accept or reject shipments with this service code',
    allowCourierCheckbox: 'Yes, courier should be allowed',
    none: 'None'
  },
  matrix: {
    title: 'Matrix',
    id: 'Id',
    pageTitle: 'Matrix Admin',
    name: 'Name',
    filename: 'File name',
    uploaded: 'Uploaded',
    uploadedBy: 'Uploaded by',
    downloadTemplate: 'Download template',
    byUser: 'By user',
    country: 'Country',
    ROUTING: 'Routing',
    LINEHAUL: 'Linehaul',
    HUB: 'Hub',
    DELIVERY: 'Delivery',
    VAS: 'VAS',
    DEPARTMENT: 'Department',
    CUTOFF: 'Cutoff',
    PARCEL_DELIVERY: 'Parcel Delivery',
    parcelDelivery: {
      searchLabel: 'Search for postal code, department or hub',
      noRouting: 'No routing rows in this matrix yet'
    },
    terminals: 'Terminals',
    searchLabel: 'Search for name or customer number',
    bookingLimitsSearchLabel: 'Search for terminal name',
    'baggage-delivery': 'Baggage',
    baggage: {
      title: 'Baggage matrices',
      name: 'Baggage {{country}}',
      legend: 'If you want to update existing baggage matrices, you do this by selecting “upload matrix data”.',
      uploadTitle: 'for {{country}}',
      custom: 'Custom DS code matrix',
      uploadCustomTitle: 'for custom DS codes',
      status: 'Status',
      uploadFail:
        '{{label}} was not accepted due to incorrect information. Change information and upload matrix again. ',
      statuses: {
        accepted: 'Accepted',
        pending: 'Pending',
        rejected: 'Rejected'
      }
    },
    cutoff: {
      departments: 'Parcel departments ({{count}})',
      searchDepartment: 'Search for department or hub',
      hubCount: '{{count}} hub',
      hubCount_other: '{{count}} hubs',
      department: 'Parcel department',
      selectDepartment: 'Select a parcel department',
      noDepartments: 'No parcel departments found',
      hubName: 'Hub name',
      hubId: 'Hub ID',
      addHub: 'Add hub',
      sameDay: 'Same day delivery',
      noHubs: 'No hubs registered for this department yet',
      saved: 'Cut off times were saved',
      deleted: 'The hub was deleted',
      delete: {
        question: 'Delete {{hubName}}?',
        description: 'The hub and its cut off time are removed from this department.'
      },
      unsaved: {
        question: 'Discard unsaved cut off times?',
        description: 'Your changes to this department have not been saved. Switching department discards them.',
        discard: 'Discard changes'
      }
    },
    terminalDetails: {
      details: 'Details',
      alystraDepartmentId: 'Alystra department ID',
      matrices: 'Matrices',
      type: 'Type',
      noMatrices: 'This terminal is not referenced in any matrices',
      aliases: 'Aliases',
      departmentId: 'Department id',
      createdAt: 'Created',
      noAliases: 'This terminal has no aliases'
    },
    bookingLimits: {
      title: 'Booking limits',
      header: '{{name}} - Edit Booking limits',
      rules: '#Rules',
      total: 'Total',
      rank: 'Priority',
      customer: 'Customer',
      customerNo: 'Customer No',
      serviceCode: 'Service',
      timeWindow: 'Time Window',
      selectTimeWindow: 'Select Time Window',
      noTimeWindow: 'No time window',
      noCustomer: 'No customer',
      bookingLimit: 'Booking Limit',
      removeLimit: 'Remove Limit',
      addMoreLimits: 'Add more limits',
      delete: 'Delete booking limits',
      deleteModalDescription: 'You will not be able to recover this action',
      deleted: 'Booking limits was successfully deleted',
      updated: 'Booking limits successfully changed'
    },
    master: 'Master',
    select: 'Select {{matrix}} matrix...',
    overflow: '+{{overflow}} more..',
    vasCodes: 'VAS Codes',
    connectedCustomers: {
      title: 'Connected Customers',
      button: 'See {{connectedCustomers}} Connected Customers',
      search: 'Search for customer name or number',
      subcustomer: 'Subcustomer'
    },
    upload: {
      success: 'Matrix data was successfully uploaded',
      question: 'Upload matrix data',
      text: 'Upload Excel',
      description: 'Upload excel spreadsheet with data for this matrix',
      error: 'Error uploading data to {{name}}. {{error}}',
      invalidformat: 'Invalid file format'
    },
    delete: {
      question: 'Delete matrix {{name}}',
      description: 'This cannot be undone',
      success: 'Matrix {{name}} was successfully deleted',
      error: 'Error deleting {{name}}. {{error}}'
    },
    new: {
      question: 'Create new matrix',
      description: 'Creates a new matrix',
      success: 'Matrix {{name}} was successfully created',
      error: 'Error creating matrix. {{error}}'
    },
    edit: {
      question: 'Edit matrix {{name}}',
      error: 'Error updating {{name}}. {{error}}',
      success: 'Matrix {{name}} successfully saved'
    },
    type: 'Select type',
    day: {
      monday: 'Mon',
      tuesday: 'Tue',
      wednesday: 'Wed',
      thursday: 'Thu',
      friday: 'Fri',
      saturday: 'Sat',
      sunday: 'Sun'
    },
    leadTime: 'Lead time',
    terminal: 'Terminal',
    terminalFrom: 'Terminal from',
    terminalTo: 'Terminal to',
    postalCode: 'Postal code',
    postalCodeFrom: 'From Postal code',
    postalCodeTo: 'To Postal code',
    offsetDays: 'Offset days',
    cutoffTime: 'Cutoff time',
    city: 'City',
    error: {
      duplicateName: 'Duplicate name',
      duplicateServiceCode: 'Booking limits already defined for this combination of customer and service code',
      duplicateTimeWindow: 'Duplicate time window'
    }
  },
  texts: {
    title: 'Texts',
    update: 'Update text',
    name: 'Name of text',
    group: 'Grouping',
    edit: 'Edit',
    delete: 'Delete',
    add: 'Add text',
    reset: 'Reset',
    confirmDelete: 'Are you sure you want to delete the text?',
    added: 'Text added',
    deleted: 'Text deleted',
    updated: 'Text updated',
    tabTitle: 'Texts and translations',
    successfullyAdded: 'Text was successfully added to the list',
    successfullyUpdated: 'Text was successfully updated',
    successfullyDeleted: 'Text was successfully deleted',
    allTextsAndVases: 'List of all texts and translations',
    searchText: 'Search for text',
    deleteModalTitle: 'Delete Text',
    deleteModalDescription: 'You will not be able to recover this action',
    createNewText: 'Create new text',
    nameToolTip: 'Name is displayed when linking text to service'
  },

  billingType: {
    day: 'day',
    evening: 'evening',
    weekend: 'weekend',
    weekendEvening: 'evening in the weekend'
  },
  /* These must be unique because of how ExcelJS works */
  importExport: {
    dropText: 'Drop file here to upload',
    export: 'Export',
    exportAddresses: 'Export customer addresses to Excel',
    importExcel: 'Import from Excel',
    imported: 'addresses imported successfully',
    or: 'or',
    selectFile: 'Select file',
    uploadingFile: 'Uploading...'
  },
  customMeasurements: {
    name: 'Name',
    weight: 'Weight',
    height: 'Height',
    length: 'Length',
    width: 'Width',
    heading: 'Custom goods types',
    error: 'Error saving goods type: ',
    confirmDelete: 'Are you sure you want to delete this goods type?',
    new: 'Create new',
    customGoodsTypes: 'Custom goods types',
    defaultGoodsTypes: 'Default goods types',
    invalidName: 'Name must include at least one letter'
  },
  shdAdmin: {
    successfullyDeleted: 'Time matrix was successfully deleted',
    successfullyUploaded: 'Time matrix was successfully uploaded',
    timeWindowForHomeDelivery: 'Time window for home delivery',
    filterByCustomerData: 'Search for customer name, subcustomer or customer number',
    uploadTimeMatrixFile: 'Upload time matrix file',
    downloadExcelTemplate: 'Download excel template',
    clickHereOrDragAndDrop: 'Click here or drag and drop',
    allowedFormats: 'Allowed formats are XLS and XLSX',
    existingCustomers: 'Existing customers with SHD',
    customerPriceTooltip: "If end-customer's price should be displayed, set the toggle to on",
    deleteModalTitle: 'Delete time windows',
    deleteModalDescription:
      'If you delete this time window it will remove all SHD time windows for this customer. You will not be able to recover this action.',
    exportToExcel: 'Export to Excel',
    toggleLabel: "Toggle customer's price",
    customerNumber: 'Customer No',
    subCustomer: 'Subcustomer',
    customerName: 'Customer',
    amountOfPostalCodes: 'Amount of postals codes',
    lastUpdatedAt: 'Last updated at',
    showCustomerPrice: 'Show customer price',
    uploadMaximumFileSizeLimit: 'File size cannot be greater than {{size}} KB'
  },
  unresolved: {
    unresolvedAddresses: 'Unresolved addresses',
    allResolved: 'All addresses are resolved!',
    address: 'Address',
    noOfShipments: 'No. of shipments',
    shipment: 'shipment',
    shipment_other: 'shipments',
    shipmentNumber: 'Shipment number',
    customerRef: 'Customer ref',
    senderName: 'Sender name',
    senderPhone: 'Sender phone number',
    recipientName: 'Recipient name',
    recipientPhone: 'Recipient phone',
    searchAndSetLocation: 'Search and set location',
    setALocationToContinue: 'Set a location to continue',
    resolveAddress: 'Resolve address',
    suggestedAddressFound: 'Suggested address found',
    thereIsOneUnresolvedAddress: 'There is {{count}} unresolved address',
    thereIsOneUnresolvedAddress_other: 'There are {{count}} unresolved addresses'
  },
  optimizing: {
    title: 'Optimizing',
    optimizingId: 'Optimizing ID',
    reqTime: 'Request Time',
    respTime: 'Response Time',
    showOnlyErrors: 'Show only errors',
    department: 'Department',
    userName: 'User',
    graphID: 'Id',
    request: 'Request',
    response: 'Response',
    error: 'Error',
    viewReqResp: 'View',
    status: 'Status',
    totalTime: 'Time',
    selectOptimizingObjective: 'Please select optimizing objective',
    cancelRequest: 'Cancel request',
    noOptimizations: 'No optimizations for selected query',
    viewRaw: 'View raw',
    quality: {
      STANDARD: 'Standard',
      HIGH: 'High',
      PREMIUM: 'Premium'
    },
    objectives: {
      completion_time: 'Minimum total time of delivery (default)',
      min_vehicles: 'Minimum total number of vehicles',
      work_time: 'Even delivery time',
      number_of_deliveries: 'Even number of deliveries',
      deliveries_and_work_time: 'Even work time and even number of deliveries'
    },
    kbSize: 'KB request',
    showAll: 'Show all',
    numberOfShipments: 'Number of shipments',
    numberOfVehicles: 'Number of vehicles',
    processingTime: 'Processing time',
    stats: 'Stats',
    addToCompare: 'Add run to compare',
    noRunsToCompare: 'No other finished runs on this day',
    removeFromCompare: 'Remove from comparison',
    noStats: 'No stats',
    routesUsed: 'Routes used',
    leftOut: 'Left out',
    stops: 'Stops',
    distanceKm: 'Distance (km)',
    drivingTime: 'Driving time',
    waitingTime: 'Waiting time',
    routeTime: 'Total route time',
    longestRoute: 'Longest route',
    type: 'Type'
  },
  date: {
    date: 'Date',
    today: 'Today',
    tomorrow: 'Tomorrow',
    yesterday: 'Yesterday',
    from: 'From',
    fromDate: 'From date',
    rangeOptions: {
      '15d': '+/- 15 days',
      '30d': '+/- 30 days',
      custom: 'Custom dates',
      last30d: 'Last 30 days',
      last7d: 'Last 7 days',
      month: 'Month',
      months: 'Months',
      today: 'Today',
      tomorrow: 'Tomorrow',
      yesterday: 'Yesterday',
      thisMonth: 'This month',
      lastMonth: 'Last month'
    },
    to: 'To',
    toDate: 'To date',
    dateAndTime: 'Date and time'
  },
  areaSequence: {
    title: 'Sequence area',
    description:
      'Add up to {{max}} map points to guide the delivery order. The delivery closest to each point is prioritised in the selected order, while deliveries between the points are optimised for the most efficient route. This guides the sequence, but does not force entire areas.',
    order: 'Order of areas',
    orderWhileEditing: 'Order of areas - drag cards to change order',
    added: '{{count}} of {{max}} areas added',
    save: 'Save area',
    unsaved: 'Save or cancel the changes to the map areas before saving the route.',
    pin: 'Area {{number}}',
    overlap: 'Area {{number}} overlaps area {{other}}. Move one of them farther away.',
    maxReached: 'You can add up to {{max}} map points.',
    tool: {
      add: 'Add area',
      move: 'Move areas',
      delete: 'Delete areas'
    },
    hint: {
      add: 'Click the map to add an area',
      move: 'Drag the marker to move the area. Save to keep changes, or Cancel to discard them.',
      delete: 'Click a marker to delete the area'
    }
  },
  routeReceipt: {
    printRouteReceiptList: 'Print receipt list',
    noRoutesInfoAvailable: 'No route information available yet'
  },
  homeDeliveryRouteList: {
    receiptList: 'Receipt List',
    shipments: 'Shipments',
    weight: 'Weight',
    volume: 'Volume',
    bookedWeight: 'Booked weight{{unit}}',
    bookedVolume: 'Booked volume{{unit}}',
    sender: 'Sender',
    package: 'Package',
    shipmentNo: 'Shipment no',
    ref: 'Ref',
    recipient: 'Recipient',
    time: 'Time',
    mobile: 'Mobile',
    other: 'Other',
    attemptedDelivery: 'Attempted delivery',
    receipt: 'Receipt',
    dateOfBirth: 'Date of birth',
    signature: 'Signature',
    nameClarification: 'Name clarification',
    goodsLine1: 'Remember to check the goods for visible damage before signing.',
    goodsLine2:
      'If there is visible damage, the driver should register it before you as a recipient signs the shipment.',
    damage: 'Damage',
    missing: 'Missing',
    packageNumber: 'Package number',
    comments: 'Comments'
  },
  invoicingStatus: {
    TO_BE_INVOICED: 'Not invoiced',
    INVOICING_FAILED: 'Invoicing failed',
    CORRECTION_PENDING: 'Correction pending',
    INVOICING_PAUSED: 'Invoicing paused',
    EXCLUDED_FROM_INVOICING: 'Excluded',
    NOT_READY_FOR_INVOICING: 'Not ready',
    INVOICED_OK: 'Invoiced OK',
    ZERO_PRICE: 'Incomplete price',
    AWAITING_ACKNOWLEDGEMENT: 'Awaiting acknowledgement',
    disallowedStatusLegend:
      'Orders in statuses "Invoiced OK" and "Awaiting acknowledgement" cannot be set to "Not Invoiced" or "Excluded".'
  },
  invoice: {
    articleCode: 'Article',
    allOrdersInvoice: 'All orders are invoiced',
    allOrdersInvoiceDescription: 'We couldn’t find any uninvoiced orders.',
    handledBy: 'Handled by',
    invoicing: 'Invoicing',
    credit: 'Credit',
    invoiceVerb: 'Invoice',
    searchShipmentIdOrCustomerRef: 'Search by shipment ID or customer reference',
    state: '{{count}} state',
    state_other: '{{count}} states',
    invoiceOrderAction: 'Invoice order',
    invoiceOrderAction_other: 'Invoice orders',
    quantity: 'Quantity',
    perUnitCustomer: 'Customer price per quantity',
    carrierPerUnitPrice: 'Unit price per quantity',
    enableCalculator: 'Enable multiplication of price and quantity',
    mustBeNegative: 'Must be < 0',
    mustBePositive: 'Must be > 0',
    description: 'Description',
    customerAmount: 'Customer amount',
    carrierAmount: 'Unit amount',
    failedPriceListLink: 'Failed price list in Pricing Engine',
    failedPriceList: 'Failed price list',
    priceFailureDetail: 'Price failure details',
    priceFailureReason: 'Price failure reason',
    priceFailureReasons: {
      missingAttributeValue: 'Missing attribute',
      matrixLookupMiss: 'Matrix error',
      invalidExpression: 'Invalid expression',
      scriptError: 'Script error'
    },
    invoiceFailureDetail: 'Invoice failure details',
    invoiceDepartment: 'Invoice department',
    invoiceDepartment_other: 'Invoice departments',
    invoiceDepartments: 'Invoice department(s)',
    dashboard: 'Dashboard',
    invoicingJobsSummary: 'Invoicing jobs summary',
    invoicingStatus: 'Invoicing status',
    invoicingStatusDescription: 'Showing orders from the past {{months}} months.',
    ordersOnPage: '{{count}} orders on page',
    ordersFoundCount: '{{count}} order found',
    ordersFoundCount_other: '{{count}} orders found',
    ordersNotInvoiced: 'Orders that are not invoiced yet',
    invoicingFailedDescription: 'Orders processed unsuccessfully',
    text: 'Invoice text',
    correctionPendingDescription: 'Orders with pending corrections',
    ordersPausedFromInvoiced: 'Orders that are paused from being invoiced',
    invoicingZeroPriceDescription: 'Orders with non-approved zero-lines',
    sendInvoices: 'Send invoices',
    sendInvoicesDescription:
      'You are about to invoice {{departments}}. Please select the date or date range for the invoicing period.',
    sendInvoiceDateValidationErrorOneMonth: 'Max date span is 1 month',
    invoicingInProgress: 'Invoicing for {{departmentName}} is in progress, {{count}} invoicing jobs are remaining',
    invoicingInFinished: 'Invoicing for {{departmentName}} is finished',
    orderEnqueuedForInvoicing: 'Order is enqueued for invoicing',
    orderEnqueuedForInvoicing_other: 'Orders are enqueued for invoicing',
    orderSuccessNotInvoiced: 'Order was successfully changed to not invoiced',
    orderSuccessNotInvoiced_other: 'Orders were successfully changed to not invoiced',
    orderSuccessInvoicedOk: 'Order was successfully changed to invoiced OK',
    orderSuccessInvoicedOk_other: 'Orders were successfully changed to invoiced OK',
    orderSuccessExcluded: 'Order was successfully excluded from invoicing',
    orderSuccessExcluded_other: 'Orders were successfully excluded from invoicing',
    howManyInvoices: 'How many invoices will be sent',
    fetchAmount: 'Fetch amount',
    wantToResend: 'This order has been invoiced already. Are you sure you wan to resend it?',
    adHocInvoiceOrder: 'You are about to invoice this order. Do you want to continue?',
    adHocInvoiceOrder_other: 'You are about to invoice these orders. Do you want to continue?',
    pauseOrders: 'Pause orders',
    datePeriod: 'Date period',
    ordersWereSuccessfullyPaused: '{{count}} order was successfully paused from invoicing',
    ordersWereSuccessfullyPaused_other: '{{count}} orders were successfully paused from invoicing',
    releaseOrders: 'Release orders',
    recalculatePrices: 'Recalculate prices',
    ordersSentForPriceRecalculation: '{{count}} order was successfully placed in queue for recalculation',
    ordersSentForPriceRecalculation_other: '{{count}} orders were successfully placed in queue for recalculation',
    ordersWereSuccessfullyReleased: '{{count}} order was successfully placed in queue for recalculation',
    ordersWereSuccessfullyReleased_other: '{{count}} orders were successfully placed in queue for recalculation',
    addUnit: 'Add unit',
    overrideUnit: 'Override unit',
    addUnitDescription: 'Add a unit to your selected orders. This unit is the one that will be self-billed.',
    addUnitToOrders: 'Add unit to orders',
    addUnitToOrder: '{{unit}} was successfully added to {{count}} order',
    addUnitToOrder_other: '{{unit}} was successfully added to {{count}} orders',
    addUnitBulkDisabled: 'Unit can only be added to orders without unit',
    approveIncompletePrices: 'Approve with incomplete prices',
    manualOverrideTitle: 'Manual override invoicing status',
    selectStatus: 'Select new invoicing status',
    status: 'The current status is',
    status_other: 'The current statuses are',
    manualOverrideLegend:
      'You are about to overwrite the invoicing status for one selected order. The current status is: {{statuses}}.',
    manualOverrideLegend_other:
      'You are about to overwrite the invoicing status for {{count}} selected orders. $t(invoice.status, {"count": {{statusCount}} }): {{statuses}}.',
    manualOverrideLegend2: 'Please choose the desired invoicing status for this order below.',
    manualOverrideLegend2_other: 'Please choose the desired invoicing status for these orders below.',
    unitId: 'Unit ID',
    bannerOldInvoicePage:
      'On the 26th of August <0>the new invoicing page</0> will be opening by default. We encourage you to start working with the new page. More info on the new page <1>here</1>.',
    acceptIncompletePricesTitle: 'Approve incomplete prices',
    acceptIncompletePricesModalQuestion:
      'You are about to approve {{count}} order with incomplete price. Are you sure you want to continue?',
    acceptIncompletePricesModalQuestion_other:
      'You are about to approve {{count}} orders with incomplete prices. Are you sure you want to continue?',
    confirmCancelDialog: {
      title: 'You have unsaved changes',
      question: 'You have unsaved changes. Do you wish to continue?',
      abort: 'Stay on page',
      confirm: 'Continue without saving'
    },
    download: 'Download invoice',
    downloadVendor: 'Download vendor invoice',
    downloadInvoiceTooltip: 'Invoice can only be displayed once issued by external system',
    multilegFilter: {
      label: 'Filter partial multileg',
      ALL: 'Show all',
      ONLY_PARTIALLY_READY_MULTILEG: 'Show only partially ready',
      EXCLUDE_PARTIALLY_READY_MULTILEG: 'Exclude partially ready'
    },
    invoicingAwaitingAcknowledgementDescription:
      'Invoiced orders awaiting registration confirmation from external system',
    invoicedOn: 'Invoiced on',
    filterStates: 'Filter states',
    filterDeliveryDate: 'Delivery date',
    clearFilters: 'Clear filters'
  },
  billingOrder: {
    create: 'Create billing order',
    copyTo: 'Copy to billing order',
    copyToBillingOrder: 'Copy to billing order',
    keepConnection: 'Keep connection',
    disconnect: 'Disconnect',
    creditMode: 'Credit',
    debitMode: 'Debit',
    expensive: 'The entered prices appear to be unusually high',
    createCredit: 'Create credit note',
    credit: 'Credit note',
    done: 'Billing order was successfully created. Shipment ID: {{shipmentId}}',
    invalidOrderForEdit:
      'This order cannot be edited. Only billing or credit orders that have not been invoiced can be edited.',
    cannotBeCredited: 'You cannot credit an order that is invoiced in {{systemId}}.',
    invalidOrderForCopy: 'Cannot copy credit note.',
    standaloneInvoice: 'Standalone invoice',
    standaloneInvoiceLabel:
      'I want this order to be processed individually and not to be grouped with other orders for invoicing.',
    noUnitNotSelfBilled: 'Orders without unit will not be self billed',
    manualInvoiceInformation: {
      label: 'Manual invoice handling',
      descriptionText:
        'If this field is filled in with invoicing instructions, the order will not be automatically invoiced'
    },
    creditInvoiceText: 'Credit of shipment {{shipmentId}}',
    creditInvoiceLegText: {
      CUSTOMER_ORDER: 'Customer credit of shipment {{shipmentId}}',
      PICKUP_LEG: 'Credit of shipment pickup {{shipmentId}}',
      DELIVERY_LEG: 'Credit of shipment delivery {{shipmentId}}'
    },
    legSelectionLabel: 'Select transport leg',
    legSelectionError: 'Please select a transport leg to be credited',
    legSelection: {
      NONE: 'None',
      CUSTOMER_ORDER: 'Customer Order',
      PICKUP_LEG: 'Pickup',
      DELIVERY_LEG: 'Delivery'
    },
    wrongPageWarning: 'Billing orders cannot be accessed from this page',
    wrongPageLink: 'Go to billing order details page',
    type: {
      Invoice: 'Invoice order',
      Invoice_other: 'Invoice orders',
      Credit: 'Credit note',
      Credit_other: 'Credit notes',
      InternalTrade: 'Internal trade order',
      InternalTrade_other: 'Internal trade orders'
    }
  },
  columnCategories: {
    aboutTheShipment: 'About the shipment',
    goods: 'Goods',
    timeAndDate: 'Time and date',
    planning: 'Planning',
    pickupInformation: 'Pickup information',
    customer: 'Customer',
    deliveryInformation: 'Delivery information',
    originalSender: 'Original sender',
    originalDelivery: 'Original delivery',
    service: 'Service',
    preAdvice: 'Preadvice',
    invoicingInformation: 'Invoicing information'
  },
  shipment: {
    offeredOrdersPending: 'Offered orders pending',
    shipment: 'Shipment',
    multileg: 'multileg',
    pickupLeg: 'Pickup leg',
    deliveryLeg: 'Delivery leg',
    customer: 'Customer',
    customerContact: 'Customer contact',
    customerReference: 'Customer reference',
    customerNumber: 'Customer number',
    route: 'Route',
    service: 'Service',
    additionalServices: 'Additional services',
    quantity: 'Quantity',
    totalWeight: 'Total weight',
    totalVolume: 'Total volume',
    totalLoadingMeters: 'Total loading meter',
    totalPalletFootPrints: 'Total pallet space',
    goodsInfo: 'Goods information',
    packages: 'Packages',
    pickupInfo: 'Pickup information',
    pickupDate: 'Pickup date',
    pickupTime: 'Pickup time',
    pickupInstructions: 'Pickup instructions',
    deliveryInfo: 'Delivery information',
    deliveryDate: 'Delivery date',
    deliveryTime: 'Delivery time',
    eta: 'ETA',
    ata: 'ATA',
    receiverReference: 'Receiver reference',
    deliveryInstructions: 'Delivery instructions',
    trackingPage: 'Recipient tracking page',
    internalNote: 'Internal note',
    name: 'Name',
    address: 'Address',
    zipCode: 'Postal code',
    zipArea: 'City',
    phone: 'Phone',
    secondPhone: '2nd phone',
    email: 'Email'
  },
  bookingTimeWindow: {
    week: 'Week',
    bookButton: 'Book',
    customButton: 'Custom time window',
    removeBookingButton: 'Remove booking',
    noBookingYet: 'No booking yet',
    serverError: 'An error occurred on the server. Please try again later.',
    previousButton: 'Previous',
    nextButton: 'Next',
    noAvailableDeliveryTimes: 'No available delivery times this month',
    customTimeTitle: 'Set custom time window for shipment',
    customDateLabel: 'Date',
    errorEarliestNotBeforeLatest: 'Delivery time earliest must be before latest',
    arrivedAtTerminal: 'Arrived at terminal',
    bookCustomTimeSlot: 'Book Time Slot',
    shipmentBooked: 'Shipment booked',
    shipmentBookedWithCustomTimeWindow: 'Shipment booked with custom time window',
    updateBooking: 'Update Booking',
    bookingChanged: 'Booking has changed successfully',
    bookingSuccessful: 'Booking was done successfully',
    customTimeWindowAdded: 'Custom time window for shipment was successfully added',
    timeFrom: 'Time from',
    timeTo: 'Time to',
    timeFieldError: 'The earliest delivery time must be before the latest',
    availableTimeSlot: 'Available time slots',
    submitNotSelectedError: 'You need to select a time window'
  },
  manualOverride: {
    manuallyAddEvents: 'Manually add events',
    selectEvent: 'Select event',
    shipmentEvent: 'Shipment event',
    terminalEvent: 'Terminal event',
    scannedFormDescription: 'Depending on which department you select, different type of arrival scan is triggered.',
    suggestPageReload: 'Something went wrong, please reload the page and try again.',
    eventType: {
      delivered: 'Delivered',
      collected: 'Collected',
      returned: 'Returned',
      deviated: 'Deviated',
      scanned: 'Scanned',
      preadvised: 'Preadvice attempt',
      'order-sorted': 'Sorted',
      'not-arrived-at-distributing-terminal': 'Not arrived',
      'ready-for-pickup': 'Ready for pickup (PUP at terminal)'
    },
    selectEventType: 'Select one type of event',
    noEventSelected: 'No event selected',
    selectManifest: 'Select flight',
    noManifestSelected: 'No flight selected',
    disabledEventReason: {
      returned: ' - Deviation required',
      collected: ' - Dispatching required',
      default: ' - Not allowed',
      'order-sorted': 'For H2 orders only',
      'not-arrived-at-distributing-terminal': 'For HD orders only'
    },
    fillDeliverOrReturnEventInfo: 'Fill in name, date and time',
    fillDeviationEventInfo: 'Select deviation and fill in date and time',
    fillGeneralEventInfo: 'Fill in date and time',
    eventMessage: 'Event created',
    allPackagesSelected: 'All packages selected',
    selectPackages: 'Select packages',
    noActiveDriverError: 'No active drivers on unit',
    selectDriver: 'Select driver',
    selectUnit: 'Select unit',
    selectDepartment: 'Override scan department'
  },
  live: {
    late: 'late',
    early: 'early',
    stops: 'Stops: {{stops}}',
    deviatedFromRoute: 'Deviated from route',
    totalTimeMajorDeviations: 'Total time of major deviations (≥5min)',
    totalTimeMinorDeviations: 'Total time of minor deviations (<5min)',
    lateOrEarlyFirstStop: 'Late or early to first delivery',
    onlyDeviated: 'Show only deviated routes',
    bannerOldLivePage:
      '<0>Try out the new Live page</0>, with improved functionalities and new design. We encourage you to use the new live page to get used to it before we fully removing the page.',
    shipment: 'Shipment',
    shipmentFrom: 'From',
    shipmentTo: 'To',
    showAdjusted: 'Show adjusted time',
    showAdjustedTooltip: 'Adjusted time shown on recipient tracking page',
    showDiff: 'Show stop difference',
    diff: 'Stop diff',
    showDiffTooltip: 'Difference between planned (ETD) and actual time between stops',
    confirm: 'Confirm',
    unconfirm: 'Unconfirm',
    confirmedBy: 'Confirmed by {{name}} at {{time}}',
    modalTableSummary: 'Total route time',
    liveModalActualTooltip1: 'In comparison to the ETD:',
    liveModalActualTooltip2: 'Green: Up to 15 min',
    liveModalActualTooltip3: 'Orange: 15-30 min',
    liveModalActualTooltip4: 'Red: more than 30 min',
    theCourier: 'The courier',
    activeRoutes: 'Active routes',
    routeDeviation: 'Route deviation',
    routeDeviations: 'Route deviations',
    multipleDeviations: 'Multiple deviations',
    recentDeviations: 'Recent deviations',
    noRoutesFound: 'No routes found',
    noDeviationsFound: 'No deviations found',
    consignmentDamage: 'Consignment damage',
    shipmentDeviation: 'Shipment deviation',
    outsideServiceTime: 'Outside service time',
    outsideEstimatedTime: 'Outside estimated time',
    deliveryLocationDeviation: 'Unexpected location',
    eventTextDeviationOne: '{{name}} has a shipment deviation.',
    eventTextDeviationMany: '{{name}} has {{count}} shipment deviations.',
    eventTextDamageOne: '{{name}} has damage on {{count}} shipments.',
    eventTextDamageMany: '{{name}} has damage on a shipment.',
    eventTextServiceTimeWindow: '{{name}} delivered outside the service time window.',
    eventTextEstimatedTimeWindow: '{{name}} delivered outside the estimated time window.',
    eventTextDeviated: '{{name}} has deviated from their route.',
    eventTextDeliveryLocationDeviation:
      '{{name}} delivered/deviated {{distance}} meters away from the expected location.',
    eventHelpDeviation: '{{name}} has a deviation on shipment number {{shipmentId}}.',
    eventHelpDamage: '{{name}} has a damage on shipment number {{shipmentId}}.',
    eventHelpServiceTimeWindow:
      '{{name}} has delivered shipment number {{shipmentId}} at {{actual}}, which is outside of the service time window {{earliest}}-{{latest}}.',
    eventHelpEstimatedTimeWindow:
      '{{name}} has delivered shipment number {{shipmentId}} at {{actual}}, which is outside of the estimated time window {{earliest}}-{{latest}}.',
    eventHelpDriverDeviated: '{{name}} has delivered shipment number {{shipmentId}} in the wrong order.',
    eventHelpDriverDeviatedAtPickup: '{{name}} has picked up shipment number {{shipmentId}} in the wrong order.',
    eventHelpDriverDeviatedAtPickupBefore:
      '{{name}} has picked up shipment number {{shipmentId}} in the wrong order, stopping at pickup #{{actual}} before pickup #{{expected}}.',
    eventHelpDriverDeviatedAtPickupAfter:
      '{{name}} has picked up shipment number {{shipmentId}} in the wrong order, stopping at pickup #{{actual}} after pickup #{{expected}}.',
    eventHelpDriverDeviatedBefore:
      '{{name}} has delivered shipment number {{shipmentId}} in the wrong order, stopping at delivery #{{actual}} before delivery #{{expected}}.',
    eventHelpDriverDeviatedAfter:
      '{{name}} has delivered shipment number {{shipmentId}} in the wrong order, stopping at delivery #{{actual}} after delivery #{{expected}}.',
    eventHelpDeliveryLocationDeviation: {
      withShipmentId:
        '{{name}} has delivered or deviated shipment number {{shipmentId}} <4>here</4>, {{distance}} meters away from the <9>expected location</9>.',
      withoutShipmentId:
        '{{name}} has delivered or deviated <4>here</4>, {{distance}} meters away from the <9>expected location</9>.'
    },
    filterOngoing: 'Ongoing',
    filterNotStarted: 'Not started',
    filterFinished: 'Finished',
    filterOnlyDeviated: 'Only deviated',
    filterShipmentDeviations: 'Shipment deviations',
    filterShipmentDamage: 'Shipment damage',
    filterEstimatedTime: 'Estimated time',
    filterServiceTime: 'Service time',
    filterRouteDeviations: 'Route deviations',
    filterDeliveryLocationDeviation: 'Unexpected location',
    filterConfirmed: 'Confirmed',
    routeProgress: 'Completed {{complete}} of {{total}}',
    routeDuration: 'From {{from}} to {{to}}',
    routeDelayed: 'Delayed',
    routeAhead: 'Ahead',
    routeOnTime: 'On time',
    routeUnknown: 'Unknown',
    routeDeviationsNone: 'No deviations',
    routeDeviationCount: '{{unhandledDeviations}} of {{totalDeviations}}',
    routeHasHandleDeviations: 'Route has {{count}} handled deviation',
    routeHasHandleDeviations_other: 'Route has {{count}} handled deviations',
    showHandledDeviations: 'Show handled deviations ({{count}})',
    openRoute: 'See route',
    openShipment: 'See shipment',
    viewRoute: 'View route',
    deviated: 'Deviated',
    offRoute: 'Off route',
    onRoute: 'On route',
    routeStateFilter: 'Route state',
    allRoutesStates: 'All route states',
    selectedRouteStates: '{{count}} route state',
    selectedRouteStates_other: '{{count}} route states',
    noSelectedStates: 'No selected states',
    allDeviationTypes: 'All deviation types',
    selectedDeviationTypes: '{{count}} deviation type',
    selectedDeviationTypes_other: '{{count}} deviation types',
    noSelectedTypes: 'No selected types',
    viewShipment: 'View shipment',
    selectAllRouteStates: 'Select all route states',
    noRoutesWithDeviations: 'No routes available',
    selectAllDeviationTypes: 'Select all deviation types',
    noDeviationOnRoute: 'No deviations on route',
    noDeviationAvailable: 'No deviations available',
    noDeviationsOnFilter: 'There’s no deviations available for the selected filter. Try a different filter',
    noRoutesOnFilter: 'There’s no routes available for the selected filter. Try a different filter',
    search: 'Search for route name, unit name or driver name',
    departmentFilter: 'Department filter',
    allDepartments: 'All departments',
    deviationTypeFilter: 'Deviation type filter',
    mostDeviations: 'Most deviations',
    latestInTime: 'Latest in time',
    earliestInTime: 'Earliest in time',
    sortOn: 'Sort on',
    unhandled: 'unhandled',
    deviations: 'deviations',
    showSummary: 'Show summary'
  },
  zendesk: {
    email: 'Your email:',
    confirmEmail: 'Repeat your email:',
    send: 'Save',
    missingEmail:
      'To use the new support portal, you need to register your Posten or Bring email. You only have to do this once.'
  },
  shipmentFormPage: {
    advancedFilter: 'Extended filter',
    advancedSearch: 'Advanced search',
    closeAdvancedSearch: 'Close advanced search',
    selectTable: 'Select table',
    selectCondition: 'Select condition',
    searchPhraseError: 'You must provide at least 3 characters',
    selectStateLabel: 'Select state',
    selectDateLabel: 'Select date dropdown',
    submit: 'Show results',
    inputPlaceholder: 'Search Shipment ID, Phone Number, Address, Area, Postal Code ...',
    clearButtonLabel: 'clear search phrase button',
    allStates: 'All states',
    customDate: 'Custom',
    noDate: 'No date restriction',
    withoutDeliveryDate: 'Without delivery date',
    selectFromDate: 'Select from date',
    selectToDate: 'Select to date',
    include: 'Include',
    exclude: 'Exclude',
    tableColumn: 'Table column',
    condition: 'Condition',
    searchTerm: 'Search term',
    allAnd: 'All (and)',
    anyOr: 'Any (or)',
    activeOrders: 'Active orders',
    deletedOrders: 'Deleted orders',
    deletedOrdersDescription:
      'Deleted orders are searched separately and may contain different information than active orders.',
    tableDropdown: 'Select table dropdown',
    conditionDropdown: 'Select condition dropdown',
    typeSearch: 'Type in search term',
    typeSearchCommaSeparated: 'Type in search terms, separated by comma',
    addNewRow: 'Add new row',
    deleteRow: 'Delete current row',
    service: 'Service',
    goodsDescription: 'Goods description',
    unit: 'Unit',
    deliveryArea: 'Delivery area',
    deliveryZipcode: 'Delivery postal code',
    state: '{{count}} State',
    state_other: '{{count}} States',
    today: 'Today',
    tomorrow: 'Tomorrow',
    yesterday: 'Yesterday',
    last30Days: 'Last 30 days',
    plusMinus15Days: '+/- 15 days',
    plusMinus30Days: '+/- 30 days',
    shipmentIds: 'Multiple shipments',
    orderId: 'Internal order number',
    customers: {
      placeholder: 'All customers',
      label: 'Select customers'
    },
    allOrderSources: 'All internal order sources',
    orderSource: '{{count}} internal order source',
    orderSource_other: '{{count}} internal order sources',
    vasCodes: '{{count}} VAS code',
    vasCodes_other: '{{count}} VAS codes',
    vasCodesPlaceholder: 'Search by VAS code or name',
    orderSourceOption: {
      GLOW: 'GLOW',
      GLOW_CUSTOMER_BOOKING: 'GLOW Customer booking',
      GLOW_EXCEL: 'GLOW Excel'
    }
  },
  shipmentResultPage: {
    deletedOrdersLimitReached: 'Showing the {{limit}} most recently deleted orders. Consider narrowing your search.',
    noResultTitle: 'No results found',
    findYourShipments: 'Find your shipments',
    findYourShipmentsDescription:
      'Type in what you are looking for in the search field above. More options can be found under advanced search',
    batchLimitReached: 'Showing a maximum of 2000 shipments, consider narrowing your search',
    withoutDateLimitReached:
      'When searching with no date, we will display a maximum of {{limit}} shipments. Considering narrowing your search.',
    withoutDeliveryDateLimitReached:
      'When searching for shipments without a delivery date, we will display a maximum of {{limit}} shipments. Consider narrowing your search.',
    searchByShipmentIdsLimitReached:
      'When searching by shipment Ids, we will display a maximum of {{limit}} shipments. Considering narrowing your search.',
    searchError: 'Search failed. Try reloading the page or alter your search parameters'
  },
  shipmentTable: {
    quantity: 'Quantity',
    delEta: 'DEL ETA',
    delDuration: 'DEL D',
    delDurationTitle: 'Time of Delivery Duration',
    delPreparation: 'DEL P',
    delPreparationTitle: 'Time of Delivery Preparation',
    delDeliveryFrom: 'DEL F',
    delDeliveryFromTitle: 'Time of Delivery From',
    delDeliveryTo: 'DEL T',
    delDeliveryToTitle: 'Time of Delivery To',
    timeOfDelivery: 'Time of delivery',
    puDuration: 'PU D',
    puDurationTitle: 'Pickup Duration',
    puPreparation: 'PU P',
    puPreparationTitle: 'Pickup Preparation',
    puPickupFrom: 'PU F',
    puPickupFromTitle: 'Pickup From',
    puPickupTo: 'PU T',
    puPickupToTitle: 'Pickup To',
    timeOfPickup: 'Time of Pickup',
    timeFrom: 'Time F',
    timeFromTitle: 'Time of stop From',
    timeTo: 'Time T',
    timeToTitle: 'Time of stop To',
    delEtaTitle: 'Estimated Time of Delivery',
    recipientRef: 'Recipient ref',
    loading: 'Loading...',
    pickupName: 'Pickup name',
    deliveryName: 'Delivery name',
    pickupColumn: 'Pickup {{column}}',
    deliveryColumn: 'Delivery {{column}}',
    selectAllOnPage: 'Select all on page ({{count}})',
    selectAll: 'Select all ({{count}})',
    deselectAll: 'Deselect all',
    numSelectedShipments: '{{numSelected}} selected',
    createLabels: 'Create labels',
    yourSearchResult: 'Your search result',
    numberOfShipmentsFound: '{{count}} shipments found',
    orderedDeliveryDate: 'Ordered delivery date',
    vendorInvoice: 'Vendor invoice',
    customerInvoice: 'Customer invoice'
  },
  shipmentResultActions: {
    confirmDeleteTitle: 'Delete selected shipment?',
    confirmDeleteTitle_other: 'Delete selected shipments?',
    confirmDuplicateTitle: 'Duplicate shipment?',
    confirmDuplicateButton: 'Duplicate',
    deleteSuccess: 'Shipment was deleted successfully',
    deleteSuccess_other: 'Shipments were deleted successfully',
    invoiceActions: 'Invoice actions',
    shipmentActions: 'Shipment actions',
    showInvoicePayloadDisableTooltip: 'Shipments needs to be in invoicing status failed or OK',
    manuallyPreAdviceSuccess: 'Preadvice request saved for shipment',
    manuallyPreAdviceSuccess_other: 'Preadvice request saved for shipments'
  },
  moveDepartmentModal: {
    errorMessage: 'Order: {{orderIds}}, error: {{error}}',
    ordersMovedText: 'Order has been moved to department {{department}}',
    errorMessage_other: 'Orders: {{orderIds}}, error: {{error}}',
    ordersMovedText_other: 'Orders have been moved to department {{department}}',
    partialSuccessMessage: '{{count}} of {{fullCount}} shipment was moved',
    title: 'Move selected shipment to another department'
  },
  updateDeliveryTimeBulk: {
    menuItem: 'Change delivery date and time',
    heading: 'Change delivery date and time',
    buttonTitle: 'Change and notify',
    smsDescription:
      'The recipients receive an SMS with the new delivery date and time window, and a link where they can change it.',
    successMessage: '{{count}} shipment was updated',
    successMessage_other: '{{count}} shipments were updated',
    notNotified: 'No SMS was sent for {{shipmentIds}} - the recipient has no valid phone number or email address',
    notNotified_other:
      'No SMS was sent for {{shipmentIds}} - the recipients have no valid phone number or email address',
    disabledTooltip: 'Delivery time can only be changed before the shipment is assigned to a route',
    dateInPast: 'The delivery date cannot be in the past',
    invalidDate: 'Date not valid'
  },
  sendManualDelaySmsModal: {
    errorMessage: '{{error}} {{shipmentIds}}',
    partialSuccessMessage: '{{count}} of {{fullCount}} SMS were sent',
    successMessage: 'Manual delay SMS was sent successfully'
  },
  sendPrePickupSmsModal: {
    successMessage: 'Pre-send tracking SMS was sent successfully',
    'return-order': 'Orders cannot be return orders',
    'invalid-state': 'Orders need to be in state Assigned to route'
  },
  multistopModal: {
    title: 'Group information',
    description: 'Group view for orders that are paid together.',
    debitLines: 'Debit lines',
    notFound: 'No group info found',
    shipmentId: 'Shipment ID',
    deliveryDate: 'DEL date',
    stopAddress: 'Stop address',
    postalCode: 'Postal code',
    noPrice: 'No price information available for group',
    priceUpdated: 'Article prices updated for group'
  },
  shipmentDetails: {
    notFoundTitle: 'Shipment not found',
    notFoundDescription: 'It may have been deleted.',
    overview: 'Overview',
    details: 'Details',
    orderInformation: 'Order information',
    volumeAndWeight: 'Volume and weight',
    references: 'References',
    goods: 'Goods',
    contactInformation: 'Contact information',
    pickupContactInformation: 'Pickup contact information',
    deliveryContactInformation: 'Delivery contact information',
    eventWasAdded: 'Event was added',
    issueSaving: 'There was an issue with saving',
    noSelectedPackages: 'No packages was selected',
    pickupAndDelivery: 'Pickup and delivery',
    whereIsTheOrder: 'Where is the order',
    communicationToRecipient: 'Communication to recipient',
    yesPremium: 'Yes, premium',
    alerts: 'Alerts',
    pickupDeliveryInfo: 'Pickup and delivery information',
    quickEdit: 'Quick edit',
    quickEditTitle: 'Edit Pickup and Delivery Details',
    aboutShipment: 'About the shipment',
    mapLinkText: 'View map coordinates',
    copyShipment: 'Copy shipment',
    editShipment: 'Edit shipment details',
    location: 'Location',
    time: 'Time',
    selectDate: 'Select date',
    manualChangeEvent: 'Manually change event',
    disabledEventReason: {
      returned: 'Deviation required',
      collected: 'Dispatching required',
      default: 'Not allowed'
    },
    selectDeviation: 'Select deviation',
    required: 'Required',
    allPackages: 'All packages',
    packages: 'Packages',
    package: 'Package',
    changeDepartment: 'Change department',
    moveDepartment: 'Move department',
    shipmentMoved: 'Shipment moved',
    shipmentMovedText: 'Shipment {{shipmentId}} has been moved to department {{department}}',
    shipmentMovedGoBack: 'Go back to search page',
    shipmentCouldNotBeMoved: 'Shipment could not be moved',
    moveShipmentDescription:
      "If you don't have access to the department you will not be able to find the shipment after moving",
    moveShipmentConfirmText: 'Move shipment to another department?',
    addShipmentToSlot: 'Add shipment to {{slot}}?',
    changeSlotConfirm: 'Change route for shipment to {{slot}}?',
    changeSlot: 'Change route',
    selectSlot: 'Select route',
    AddToSlot: 'Add to route',
    optimisationInProgress: 'Optimizing in progress. You can’t change the route while the route is optimizing.',
    removeFromSlot: 'Remove from route',
    removeShipmentFromSlot: 'Remove shipment from route',
    removeShipmentFromSlotHeading: 'Remove the shipment from this route?',
    successRemoveFromSlot: 'Shipment was removed from route',
    successChangeSlot: 'Shipment changed route',
    successAddToSlot: 'Shipment was added to route',
    changeSlotDescription: 'Changing route is done without route optimizing.',
    addToSlotDescription: 'The selected route will be optimized with the exisitng shipment staying the same order',
    pickupOrDeliveryChange: 'The pickup or delivery has been changed',
    pickupOrDeliveryChangeDescription:
      'The pickup or delivery address have been changed. If you want to change the address back, press either of the button bellow.',
    addressWasUnresolved: 'Address was unresolved',
    eventTimeCannotBeInFuture: 'Event time cannot be in future.',
    shipmentSuccessfullyUpdated: 'Shipment was updated successfully',
    connectedShipments: 'Connected shipments',
    goToShipment: 'Go to shipment',
    currentShipment: 'Current shipment',
    duplicate: 'Duplicate'
  },
  terminal: 'Terminal',
  location: 'Location',
  scannedAtDelegatedDepartment: 'Scanned from the delegated department.',
  pickupOrders: {
    acceptOrders: 'Accept orders',
    selected: 'selected',
    handleOrders: 'Handle pickup orders',
    found: 'found',
    accept: 'Accept',
    reject: 'Reject',
    noResultText: 'We could not find any results. Please try searching with another date.',
    last7d: 'Today + past 7 days',
    rejectOptions: {
      notFound: 'Sender not found on pickup address. No more attempts. Pickup closed.',
      terminatesPickupOrder: 'Sender terminates pickup order. No more attempts. Pickup closes.',
      handedOver: 'Sender has handed over pickup to other transporter. No more attempts. Pickup closed.',
      noMoreAttempts: 'Sender has moved. No more attempts. Pickup closed.',
      pickupCorrected: 'Sender has moved. Pickup corrected and sent back to subcontractor.',
      goodsNotReady: 'Goods not ready for pickup. No more attempts. Pickup closed.',
      incorrectBooking: 'Incorrect booking. Pickup terminated.',
      senderRefuses: 'Sender refuses to hand over goods. No more attempts. Pickup closed.',
      addressCorrected: 'Incorrect pickup address. Address corrected.',
      incorrectAddressNoMoreAttempts: 'Incorrect pickup address. No more attempts. Pickup closed.',
      senderNotified: 'Incorrect pickup address. Sender notified.',
      forbiddenGoods: 'Forbidden goods. No more attempts. Pickup closed.',
      timeFrame: "Pickup can't be done within time frame. Pickup order sent back to booking office."
    },
    mustSelectReason: 'You must select a reason for the rejection',
    selectRejectReason: 'Select reason for the rejection*',
    selectReason: 'Select reason',
    commentPlaceholder: 'Optional - provide extra information for the rejection',
    acceptedSuccessToast: 'was successfully accepted',
    rejectedSuccessToast: 'was successfully rejected',
    errorToast: 'Something went wrong',
    rejectOrders: 'Reject orders',
    shipment: '{{count}} shipment',
    shipment_other: '{{count}} shipments'
  },
  editShipments: {
    pickupShouldBeBeforeDeliveryForAllShipments:
      'Shipment [{{shipmentIds}}] was not eligible because the combination of new and existing times is not valid. Please deselect the failing shipment and try again.',
    pickupShouldBeBeforeDeliveryForAllShipments_other:
      '{{count}} shipments were not eligible because the combination of new and existing times is not valid. Please deselect the failing shipments and try again. Failed Shipment IDs - {{shipmentIds}}',
    useExistingTimes: 'Use existing times',
    pickupShouldBeBeforeDelivery: 'Pickup time window must be before the delivery time window',
    pickupEarliestShouldBeBeforeLatest: 'The earliest pickup time must be before the latest',
    deliveryEarliestShouldBeBeforeLatest: 'The earliest delivery time must be before the latest',
    success: 'Shipments information was updated successfully',
    pickupDateTime: 'Pickup date and time',
    deliveryDateTime: 'Delivery date and time',
    earliestPickupTime: 'Earliest pickup time',
    latestPickupTime: 'Latest pickup time',
    earliestDeliveryTime: 'Earliest delivery time',
    latestDeliveryTime: 'Latest delivery time',
    pickupName: 'Pickup name',
    pickupPhoneNumber: 'Pickup phone number',
    deliveryName: 'Delivery name',
    deliveryPhoneNumber: 'Delivery phone number',
    pickupInstructions: 'Pickup instructions',
    deliveryInstructions: 'Delivery instructions',
    mixedShipmentsSelected:
      'You have selected shipments with and without a date. Pickup and delivery information is required.',
    fieldNotEditable: 'This information cannot be edited for orders in state Assigned to route or Collected',
    bulkActionDisabledReason: 'Orders in state Deviated, Delivered, Rejected or Returned cannot be edited',
    withoutDateDisabledReason:
      'The combinations of orders in state Assigned to route or Collected and without date cannot be edited'
  },
  shipmentSelectColumn: {
    title: 'Customize column headers',
    titleDeletedOrders: 'Customize your data table for deleted orders',
    addColumnHeader: 'Add column headers',
    addColumnBody: `Select the headings you want to be displayed in the data table. Our tip is to use 10-15 different
    heading in order for the information not to be cut off. The exact amount depends on the size of the
    device you are working on.`,
    orderOfTable: 'Order of column headings'
  },
  bulkActions: {
    routeReceiptList: {
      disabledTooltip: 'Orders cannot be in state Resolved or Unresolved'
    },
    unassignShipmentFromSlot: 'Unassign shipments from slots',
    unassignShipmentFromSlotDisabledReason: 'Orders need to be in state Assigned to route or Offered',
    forceUnassignShipmentFromSlot: 'Force unassign shipments from slots',
    disabledMoveDepartmentTooltip:
      'Shipments need to be in state Created, Resolved, Unresolved or Rejected to be moved',
    deleteDisableTooltip: 'Shipment can only be deleted if in state Created, Unresolved, Resolved, Offered or Assigned',
    duplicateDisableTooltip:
      'Shipments needs to be in state Deviated or Returned and department type needs to be Courier',
    onlyReleasePausedOrders: 'You can only release paused orders.',
    onlyOverrideTheseInvoicingStatuses: 'You can only override orders with these invoicing statuses: {{statuses}}',
    shipmentForPauseDisableText:
      'Shipments need to be in state with order correction, to be invoiced or invoicing failed',
    creditDisableTooltip: 'You can only credit orders that are in status Invoiced OK',
    copyDisableTooltip: 'Copy to billing order is only allowed for orders with invoicing status Invoiced OK',
    createWaybills: 'Create waybills',
    createWaybillsTooltip: 'Waybills can only be created for IKEA shipments',
    createDeliveryNotes: 'Create delivery notes',
    createDeliveryNotesTooltip: 'Delivery Notes can only be created for IKEA shipments',
    viewGroupDisabledTooltip: 'Order must be assigned before you can view and edit its group'
  },
  dispatchModal: {
    title: 'Pickup and deliveries on route {{name}}',
    overridePalletRule: {
      question: 'Override the pallet rule?',
      description:
        'The shipment contains pallets, but the vehicle on this route is not marked as able to carry pallets. Do you want to assign it to this route anyway?',
      confirm: 'Assign anyway'
    },
    palletRule: 'Pallet rule',
    ignorePalletRule: 'Allow pallets on vehicles that cannot carry pallets',
    partialForcedOrder: 'Selected sequence',
    partialForcedOrderLabel: 'Forced sequence for selected area/orders',
    partialForcedOrderInfo:
      'You have chosen to define the order of selected stops/areas. Other stops are optimized around these.',
    flex: 'Flex',
    force: 'Force',
    openRowMenu: 'Open row menu',
    optimizingEngine: 'Optimizing engine',
    openPlannedStopMenu: 'Open planned stop menu',
    newPositionForStop: 'Choose new position for stop',
    invalidRouteOrder: 'Deliveries cannot be before pickups. Change the route order',
    submitDisabled: 'Re-plan route to activate button',
    replanDisabled: 'Route order needs to be vaild to Re-plan',
    replan: 'Replan route',
    noShipments: 'No shipments on route',
    noShipmentsDescription:
      ' You have unassigned all shipments on the route, press <i>Confirm route</i> to save changes',
    unassignBreakFromRoute: 'Click to unassign break from route',
    editBreakOnRoute: 'Click to edit break on route',
    routeEnd: 'Route end',
    routeStart: 'Route start',
    earliestStartOfBreak: 'Earliest start of break',
    latestStartOfBreak: 'Latest start of break',
    overrideOptimizingEngine: 'Override default optimizing engine',
    showStops: 'Show stops',
    viewStopsOnSameAddress: 'View stops on the same address grouped together',
    addPlannedStopLocations: 'Add planned stop locations',
    selectPlannedStopLocation: 'Select planned stop location',
    plannedStop: 'Planned stop',
    visitEarliest: 'Visit earliest',
    visitLatest: 'Visit latest',
    serviceTime: 'Duration',
    addPlannedStop: 'Add stop and replan',
    updatePlannedStop: 'Update stop and replan',
    editPlannedStopOnRoute: 'Edit planned stop on route',
    unassignPlannedStopFromRoute: 'Unassign planned stop from route',
    warning:
      'You have selected to not use an optimizing engine for this route. This will effect the recipient experience.',
    flexDisabled: 'You are not allowed to <strong>flex</strong> individual shipments in a group',
    forceDisabled: 'You are not allowed to <strong>force</strong> individual shipments in a group',
    removeDisabled: 'You are not allowed to <strong>remove</strong> individual shipments in a group',
    orderDisabled: 'You are not allowed to <strong>change the order</strong> of individual shipments in a group',
    plannedStopRowDisabled: 'You are not allowed to <strong>change the order</strong> of a planned stop while editing',
    settings: 'Settings',
    multipleRecipients: 'Multiple recipients ({{number}})',
    multiplePickups: 'Multiple pickups ({{number}})',
    mustProvideStopLocation: 'You must provide a stop location',
    editingLockBanner: 'Route is being edited by {{name}} since {{time}}.',
    editingLockBannerBody: 'You need to take over routing in order to replan the route.',
    takeOver: 'Take over',
    routeChangedByOtherUser: '{{name}} finished editing. Reload to continue.',
    reloadRoute: 'Reload route',
    noShipmentsRouteUpdated: 'Reload route to see shipments',
    duplicateTabBanner: 'This route is open in another tab (since {{time}}).',
    duplicateTabBannerBody: 'Take over here to edit in this tab.'
  },
  vehicle: {
    createNewVehicle: 'Create new vehicle',
    vehiclesInDepartment: 'Vehicles in {{departmentName}}',
    listAllVehicle: 'List all vehicles in this department',
    weightCapacity: 'Weight capacity',
    volumeCapacity: 'Volume capacity',
    maxRangeKm: 'Max range',
    deleteSuccessMessage: 'Vehicle was successfully deleted',
    createdSuccessMessage: 'Vehicle was successfully created',
    updatedSuccessMessage: 'Vehicle was successfully updated',
    deleteVehicle: 'Delete vehicle',
    notRecover: 'You will not be able to recover this action',
    createVehicle: 'Create vehicle',
    editVehicle: 'Edit {{name}}',
    vehicleInformation: 'Vehicle information',
    selectFuelType: 'Select fuel type',
    selectEuroClass: 'Select euro class',
    settings: 'Settings',
    activeDriver: 'Active driver',
    noVehicleControl: 'No vehicle control',
    slower: 'Slower',
    slow: 'Slow',
    normal: 'Normal',
    faster: 'Faster',
    speedFactorVehicle: 'Speed factor of the vehicle',
    driverSpeed: 'Driver speed',
    serviceSpeed: 'Service speed',
    defaultStartLocation: 'Default start location is the department address',
    specifyEndLocation: 'Specify end location',
    earliest: 'Earliest',
    latest: 'Latest'
  },
  lmEvents: {
    heading: 'LM Events',
    event: 'Event',
    lmEventReasonAction: 'LM Event-Reason-Action',
    eventTime: 'Event Time',
    eventSentAt: 'Event Sent At',
    lmPayload: 'LM Payload',
    view: 'View',
    enterShipmentId: 'You must enter a shipment ID',
    searchForShipmentId: 'Search for shipment ID'
  },
  cms: {
    scheduleBanner: 'Schedule banner',
    cms: 'CMS',
    publicationDate: 'Publication date',
    lastEdited: 'Last edited',
    dateForUnpublish: 'Date for unpublish',
    createNewBanner: 'Create new banner',
    createNewWhatsThisModal: "Create new What's this modal",
    publish: 'Publish',
    schedule: 'Schedule',
    unpublish: 'Unpublish',
    savePublish: 'Save and publish',
    saveAsDraft: 'Save as draft',
    saveAsDraftUnpublish: 'Save as draft and unpublish',
    noBannersFound: 'No banners found',
    noModalsFound: 'No modals found',
    DRAFT: 'Draft',
    PUBLISHED: 'Published',
    SCHEDULED: 'Scheduled',
    content: 'Content',
    nameOfBanner: 'Name of banner',
    placementOfBanner: 'Placement of banner',
    placementOfBannerDescription:
      'Paste the Glow-URL you want to add a banner to. If you want to publish a banner for all departments or specific ones, you can either press the "Add URL" button or modify the link itself.',
    urlToPageInGlow: 'URL to page in Glow',
    addUrl: 'Add URL',
    typeOfBanner: 'Type of banner',
    typeOfBannerDescription: 'Select between Warning (orange), Neutral (grey) or Error (danger).',
    bannerNeutral: 'Neutral (grey)',
    bannerWarning: 'Warning (orange)',
    bannerError: 'Error (danger)',
    links: 'Links',
    linksDescription:
      'The article link will be placed directly after the body text. If you add a "Go back to old page" link it will be place before the body text.',
    goBackToOldPageLink: 'Go back to old page link',
    messageInBanner: 'Message in banner',
    messageInBannerDescription:
      'English is required. If no other languages is selected, English will be fallback used on all the pages.',
    addAdditionalLanguages: 'Add additional languages',
    bannerText: 'Text',
    nameOfLink: 'Name of link',
    englishText: 'English text',
    englishLinkText: 'English: name of link',
    selectLanguage: 'Select language',
    addNewLanguage: 'Add new language',
    deleteBanner: 'Delete {{name}}',
    bannerWasSaved: '{{name}} was successfully saved',
    bannerWasPublished: '{{name}} was successfully published',
    bannerWasScheduled: '{{name}} was successfully scheduled',
    articleLink: 'Article link',
    goBackToOldPage: 'Go back to old page',
    previousPageNote: 'Note: use *department-id* and *date* wildcards in this field',
    selectTime: 'Select time',
    setStartDate: 'Set start date for banner',
    setEndDate: 'Set end date for banner',
    endTimeIsBeforeStartTime: "End time can't be earlier than the start time",
    endDateIsBeforeStartDate: "End date can't be earlier than the start date",
    oneBannerPerPageError: 'Only one banner per page is allowed. Url overlaps with existing banners: {{banners}}',
    mustProvideUrl: 'You must provide an url',
    mustProvideNameOfBanner: 'You must provide name of banner',
    mustProvideNameOfModal: 'You must provide name of modal',
    mustProvideEnglishText: 'You must provide English text',
    mustProvideArticleLink: 'You must provide article link',
    mustProvideNameOfArticleLink: 'You must provide name of the article link',
    mustProvideDate: 'You must provide a date',
    invalidArticleLink: 'You must provide a valid article link, e.g. https://example.com',
    errorDuplicateBanner: 'Banner name must be unique. A banner with this name already exist.',
    draftScheduleTooltip: 'Clear your scheduling to save as draft',
    banner: 'Banner',
    listOfBanners: 'List of banners',
    whatsThisModal: "What's this modal",
    whatsThis: "What's this",
    listOfWhatsThisModals: "List of what's this modals",
    nameOfWhatsThisModal: "Name of what's this modal",
    descriptionWhatsThisModal:
      "The name must be unique. A tip is to name the what's this modal depending on its placement, for example Admin Pre-advice or Planner Live.",
    nameOfModal: 'Name of modal',
    pageLinkOfModal: 'Page the modal should be displayed on',
    pageLinkOfModalDescription:
      'Paste the Glow-url you want to add the modal to. Remember to change the department id to a * in order for the modal to be published on all departments.',
    linkToPageGlow: 'Link to page in Glow',
    modalPreviewEmptyTitle: 'No information yet',
    modalPreviewEmptyDescription: 'You need to add information in order to get a preview of the modal',
    addTextForModal: 'Add text for modal',
    addTextForModalDescription:
      "English is required and will be fallback used on all the modals if you don't write any information for the other languages. Click on the what's this link to get tips on how you style the link.",
    searchBannerPlaceholder: 'Search for banner name',
    searchModalPlaceholder: 'Search for modal name',
    cmsNews: 'Update',
    cmsNewsLabel: 'Updates',
    listOfCMSNews: 'List of updates',
    noCMSNewsFound: 'No updates found',
    searchCMSNewsPlaceholder: 'Search for update name',
    cMSNewsSettingsTitle: 'Placement of update',
    cMSNewsSettingsDescription:
      'Your update appears on the homepage and is visible to all users when they log in to Glow.',
    nameOfCMSNews: 'Name of update',
    descriptionOfCMSNewsName: 'Name your update so you can easily find it. The name must be unique.',
    typeOfCMSNews: 'Type of update',
    typeOfCMSNewsDescription: 'Select between Service status, New feature or Information. ',
    selectTypeOfCMSNews: 'Select type of update',
    newFeatureCMSNews: 'New feature',
    serviceStatusCMSNews: 'Service status',
    informationCMSNews: 'Information',
    NEW_FEATURE: 'New feature',
    SERVICE_STATUS: 'Service status',
    INFORMATION: 'Information',
    scheduleCMSNews: 'Schedule update',
    scheduleCMSNewsDescription: 'When scheduling an update you will not be able to save it as a draft.',
    setStartDateForCMSNews: 'Set start date for update',
    setEndDateForCMSNews: 'Set end date for update',
    cMSNewsPreviewEmptyTitle: 'No information yet',
    cMSNewsPreviewEmptyDescription: 'You need to add information in order to get a preview of the update',
    addTextForCMSNews: 'Add text for update',
    addTextForCMSNewsDescription:
      "English is required and will be fallback used on all the updates if you don't write any information for the other languages. Click on the what's this link to get tips on how you style the update.",
    mustProvideNameOfCMSNews: 'You must provide name of update',
    createNewCMSNews: 'Create new update',
    continueToYourPage: 'Skip and continue',
    clearSelection: 'Clear selection'
  },
  validationError: {
    provideEmail: 'You must provide an email',
    provideValidEmail: 'You must provide a valid email',
    youMustSelectCustomer: 'You must select a customer'
  },
  manageReturns: {
    title: 'Manage returns',
    typesOfReturns: 'Types of returns',
    ordersOverAPeriod: 'Showing orders from the past month.',
    ordersOverAPeriod_other: 'Showing orders from the past {{count}} months.',
    pickedUpByCustomer: 'Picked up by customer',
    pickedUpByCustomerDescription: 'Returns to be picked up by the customer',
    transferToDifferentTerminal: 'Transfer to different terminal',
    transferToDifferentTerminalDescription: 'Returns to be send to a different terminal',
    environmentalReturns: 'Environmental returns',
    environmentalReturnsDescription: 'Returns for recycling, gathered in a container',
    returnForDelivery: 'Return for delivery',
    returnForDeliveryDescription: 'Returns to be routed and delivered',
    MANUAL_RETURNS: 'Manual returns',
    manualReturnsDescription: 'Order where the return leg is not created yet',
    returnToSenderTitle: 'Do you want to return the shipments to the sender',
    manuallyMarkAsHandled: 'Manually mark as handled',
    manuallyMarkAsHandledTooltip: 'When marking a shipment as handled the shipment disappear from the list',
    ordersFoundCount: '{{count}} order found',
    ordersFoundCount_other: '{{count}} orders found',
    PICKED_UP_BY_CUSTOMER: 'Picked up by customer',
    TRANSFER_TO_DIFFERENT_TERMINAL: 'Transfer to different terminal',
    ENVIRONMENTAL_RETURNS: 'Environmental returns',
    RETURN_FOR_DELIVERY: 'Return for delivery',
    ordersAlreadyHandled: 'All orders are handled',
    ordersAlreadyHandledDescription: "We couldn't find any unhandled orders.",
    manuallyMarkAsHandledModal: {
      title: 'Manually mark as handled',
      shipmentsCount: '{{count}} shipment',
      shipmentsCount_other: '{{count}} shipments',
      description:
        'When marking the shipment(s) as handled they will disappear from the list. You fill not be able to undo this action. Shipment(s) can be found on the search page.',
      confirm: 'Mark as handled'
    },
    manuallyMarkAsHandledSuccess: '{{count}} shipment was marked as handled',
    manuallyMarkAsHandledSuccess_other: '{{count}} shipments was marked as handled',
    returnToSenderSuccess: '{{count}} shipment was return to sender',
    returnToSenderSuccess_other: '{{count}} shipments was returned to sender',
    selectCustomer: 'Select customer',
    customer: 'Customer',
    customer_other: 'Customers',
    allCustomers: 'All Customers',
    selectDestination: 'Select destination',
    destination: 'End destination',
    destinationDIP: 'Destination DIP',
    returnShipmentColumns: 'Return information',
    allDestinations: 'All Destinations',
    noDate: 'All',
    zeroDays: '0 days',
    oneTo6Days: '1–6 days',
    moreThan7Days: '> 7 days',
    moreThan15Days: '> 15 days',
    moreThan30Days: '> 30 days',
    customerDate: 'Custom',
    daysOnTerminal: 'Days on terminal',
    months: 'Months',
    lastMonths: 'Last {{count}} month',
    lastMonths_other: 'Last {{count}} months',
    printList: 'Print list',
    returnToSender: 'Return to sender',
    returnToSenderQueued: 'Return to sender job is enqueued',
    returnToSenderConfirmation: 'Do you want to return this shipment to the sender?',
    returnToSenderFailed: 'Could not return shipment to sender',
    returnToSenderDisabledTooltip:
      'You cannot return shipments that are deviated, delivered or are already flagged for return',
    senderDIP: 'Sender DIP',
    createReturnLabel: 'Create return label'
  },
  parcelHubAdmin: {
    title: 'ParcelHub',
    startTitle: 'Search for a shipment',
    startDescription: 'Enter a shipment number and press search.',
    noResultsTitle: 'No messages found',
    loadFailedTitle: 'Could not fetch messages',
    loadFailedDescription: 'The ParcelHub consumer did not answer. Try again, or check that the service is running.',
    payloadLoadFailed: 'Could not fetch the payload for this message.',
    shipment: 'Shipment',
    topic: 'Topic',
    partition: 'Partition',
    offset: 'Offset',
    operation: 'Operation',
    packageId: 'Package ID',
    timestamp: 'Timestamp',
    payload: 'Payload',
    viewPayload: 'View payload',
    consignmentEvents: 'Consignment event',
    consignmentItemEvents: 'Consignment item event',
    eventCode: 'Event code',
    event: 'Event',
    receivedAt: 'Received at',
    queuedAt: 'Queued at',
    processed: 'Processed',
    processedAt: 'Processed at',
    processingLag: 'Processing lag',
    eventsNoResultsTitle: 'No events found',
    eventsLoadFailedTitle: 'Could not fetch events',
    eventsLoadFailedDescription: 'The request for events failed. Try again.',
    eventPayloadLoadFailed: 'Could not fetch the payload for this event.'
  },
  apolloAdmin: {
    title: 'Integrations',
    emptyTitle: 'No request displayed',
    emptyDescription: 'Select which date you want to view and press search.',
    reqType: 'Request type',
    routeId: 'Route ID',
    routeName: 'Route name'
  },
  preAdviceFollowup: {
    title: 'Manage preadvice',
    toBeHandled: 'To be handled',
    failedOrders: 'Failed orders',
    failedOrdersDescription: 'Recipient haven’t got any notification',
    manualPreAdvice: 'Manual preadvice',
    manualPreAdviceDescription: 'Orders with a manual trigger on the admin page',
    preAdviceLocked: 'Preadvice Locked',
    preAdviceLockedDescription: 'Orders that’s on hold and are awaiting action',
    missingRules: 'Missing rules',
    missingRulesDescription: 'Orders are missing a preadvice rule.',
    inProgress: 'In progress',
    inProgressDescription: 'Orders with preadvicing in progress',
    notStarted: 'Not started',
    notStartedDescription: 'Orders with a rule where preadvice has not been initiated',
    ordersFoundCount: '{{count}} order found',
    ordersFoundCount_other: '{{count}} orders found',
    FAILED_ORDERS: 'Failed orders',
    MANUAL_PRE_ADVICE: 'Manual preadvice',
    PRE_ADVICE_LOCKED: 'Preadvice locked',
    MISSING_RULES: 'Missing rules',
    IN_PROGRESS: 'In progress',
    NOT_STARTED: 'Not started',
    ordersAlreadyHandled: 'All orders are handled',
    ordersAlreadyHandledDescription: "We couldn't find any unhandled orders.",
    updatePhoneNumber: 'Change or add phone number',
    updateEmailAddress: 'Change or add email address',
    removeShipmentFromPreAdvice: 'Remove shipment from preadvice',
    bookDateAndTime: 'Book date and time',
    manuallyPreAdvice: 'Manual preadvice',
    unlockPreAdvice: 'Unlock preadvice',
    lockPreAdvice: 'Lock preadvice',
    triggerPreAdvice: 'Trigger preadvice',
    selectedCustomers: '{{count}} customer',
    selectedCustomers_other: '{{count}} customers',
    allCustomers: 'All Customers',
    selectRowWithOrderId: 'Select row with order id {{id}}',
    updateRecipientPhoneNumber: 'Update phone number',
    phoneNumberUpdated: 'Phone number has been updated for Shipment ID: {{shipmentId}}',
    phoneNumberUpdatedAndPreAdviceSent: 'Phone number updated and preadvice sent for Shipment ID: {{shipmentId}}',
    samePhoneNumberAlreadySet: 'Same phone number is already set on the shipment.',
    updateRecipientEmailAddress: 'Update email address',
    emailAddressUpdated: 'Email address has been updated for Shipment ID: {{shipmentId}}',
    emailAddressUpdatedAndPreAdviceSent: 'Email address updated and preadvice sent for Shipment ID: {{shipmentId}}',
    emailAddressUpdatedBulk: 'Email address has been updated for {{count}} shipment',
    emailAddressUpdatedBulk_other: 'Email address has been updated for {{count}} shipments',
    emailAddressUpdatedAndPreAdviceSentBulk: 'Email address updated and preadvice sent for {{count}} shipment',
    emailAddressUpdatedAndPreAdviceSentBulk_other: 'Email address updated and preadvice sent for {{count}} shipments',
    sameEmailAddressAlreadySet: 'Same email address is already set on the shipment.',
    manuallyPreAdvicedSuccess: 'Successfully triggered preadvice for {{count}} shipments',
    nrOfSelected: '{{count}} selected',
    nrOfSelected_other: '{{count}} selected',
    sendPreAdvice: 'Send preadvice',
    unlockPreAdviceSuccess: 'Successfully unlocked preadvice for {{count}} shipments',
    unlockPreAdviceAndPreAdviceSent: 'Successfully unlocked preadvice and sent preadvice for {{count}} shipments',
    lockPreAdviceSuccess: 'Successfully locked preadvice for {{count}} shipments',
    saveAndSendPreAdvice: 'Save and send preadvice',
    finishPreAdviceFollowupSuccess: 'Successfully removed {{count}} shipments from preadvice'
  },
  articles: {
    title: 'Articles',
    number: 'Article number',
    name: 'Article name',
    quantity: 'Quantity',
    shipmentArticles: 'Shipment articles',
    noArticlesPresent: 'No articles present'
  },
  deliveryNote: {
    title: 'Delivery Note',
    vatNumber: 'VAT no',
    orderNumber: 'Order number',
    sender: 'Sender',
    receiver: 'Receiver',
    phone: 'Phone',
    shipmentId: 'Shipment ID',
    articles: 'Articles',
    orderDate: 'Order Date',
    deliveryDate: 'Delivery Date',
    deliveryTime: 'Delivery Time',
    printedDate: 'Printed Date',
    receiversReference: "Receiver's reference",
    receiversReferenceNote: 'Please use this number in all contact with us',
    articleNumber: 'Number',
    articleName: 'Name',
    articlePrice: 'Price per unit',
    articleQuantity: 'Quantity',
    numberOfPackages: 'Number of packages',
    totalWeight: 'Total weight',
    totalVolume: 'Total volume',
    print: 'Print delivery note'
  },
  userRolesAdmin: {
    price: 'Price',
    searchPlaceholder: 'Search for user role',
    userRoles: 'User roles',
    successCreateMessage: '{{name}} was successfully created',
    successUpdateMessage: '{{name}} was successfully updated',
    saveRole: 'Save role',
    editRole: 'Edit {{name}}',
    createNewRole: 'Create new role',
    nameOfRole: 'Name of role',
    nameRequired: 'Name is required',
    descriptionRequired: 'Description is required',
    descriptionLabel: 'Description (max 240 characters)',
    iconLabel: 'Select which icon you want for the user role',
    selectRoleTitle: 'Select access rights for role',
    emptyState: 'No roles found for search phrase',
    deleteConfirm: 'Are you sure you want to delete {{name}}?',
    deleteSuccess: 'Role {{name}} was successfully deleted',
    settings: 'Settings',
    accessRights: 'Access rights',
    settingsTitle: 'Settings for role',
    settingsDescription: 'English is required. If no other languages is selected, English will be fallback',
    additionalLanguagesTitle: 'Add additional languages',
    customerPortalAccess: 'Customer Portal access',
    event: 'Event',
    financialAccess: 'Financial rights',
    invoiceActions: 'Invoice actions',
    orderAttributes: 'Order attributes',
    findApiOrder: 'Find API Order',
    optimus: 'Optimus',
    noAccess: 'No access',
    noAccessToApiOrder: 'No access to Find API Order',
    noAccessToOptimus: 'No access to Optimus',
    optimusViewDescription: 'User can view services on departments and customers, but cannot make changes',
    optimusFullDescription: 'User can add and edit services for departments and customers',
    ordersApiSearchRestrictedDescription: 'User can search for orders from departments or customers it has access to',
    ordersApiSearchFullDescription: 'User can search for orders from all departments and customers',
    addRole: 'Add role',
    addedRole: 'Added role',
    removeRole: 'Remove role',
    defaultForUserRole: 'Use as default role (optional)',
    importExport: 'Import / Export',
    importExportExtendedDescription: 'Including access to Extended Courier report.',
    importExportExtendedSaaSDescription: 'Including access to End of day report.',
    billingOrdersReadOnlyDescription: 'Limited read-only access to {{billingOrderTypes}}',
    billingOrdersDescription: 'Full access to {{billingOrderTypes}}'
  },
  webhook: {
    messages: {
      title: 'Webhook Messages',
      resendConfirmation: 'Webhook message resent'
    },
    resend: 'Resend',
    requestedAfter: 'Requested after',

    messageDetails: {
      title: 'Webhook Message',
      generalHeading: 'General information',
      requestHeading: 'Request information',
      loading: 'Fetching webhook message...',
      copyTooltip: 'Copy payload',
      copied: 'Payload has been copied'
    },
    messageId: 'Message ID',
    messageCreatedAt: 'Message created at',
    eventType: 'Event type',
    packageId: 'Package ID',
    shipmentId: 'Shipment ID',
    subscriptionUrl: 'Subscription URL',
    subscriptionId: 'Subscription ID',
    request: {
      at: 'Request at',
      after: 'Request at',
      retry: 'Retry of message'
    },
    response: {
      heading: 'Response information',
      at: 'Response at',
      status: 'Response status'
    },
    responseCategories: {
      Informational: 'Informational (100-199)',
      Successful: 'Successful (200-299)',
      Redirect: 'Redirect (300-399)',
      ClientError: 'Client Error (400-499)',
      ServerError: 'Server Error (500-599)',
      UnknownError: 'Unknown Error',
      Pending: 'Pending'
    }
  },
  roles: {
    ADMIN_OPTIMIZING: 'Optimizing',
    ADMIN_LM_EVENTS: 'LM Events',
    ADMIN_PH: 'ParcelHub',
    ADMIN_INTEGRATIONS: 'Integrations',
    ADMIN_NUMBER_SERIES: 'Number Series',
    ADMIN_TEXTS: 'Services',
    ADMIN_JOBS: 'Jobs Monitoring',
    ADMIN_PRE_ADVICE: 'Preadvice',
    ADMIN_SETTINGS: 'Settings',
    ADMIN_SHD: 'SHD',
    ADMIN_CUSTOMER: 'Light access',
    ADMIN_CUSTOMER_GROUP: 'Customer Groups',
    ADMIN_HOLIDAYS: 'Holidays',
    ADMIN_MATRIX: 'Matrix',
    ADMIN_USERS: 'Users',
    ADMIN_DEPARTMENT: 'Departments',
    ADMIN_DEPARTMENT_GROUP: 'Department Groups',
    ADMIN_CUSTOMER_ALL: 'Full access',
    ADMIN_VENDORS: 'Vendors',
    ADMIN_PRICE_ARTICLE: 'Create and maintain articles',
    ADMIN_PRICE_ACCOUNTING: 'Change accounting system settings',
    ADMIN_PRODUCTION_TIME_WINDOW: 'Production time window',
    OPTIMUS_VIEW: 'View access to Optimus',
    OPTIMUS_EDIT: 'Full access to Optimus',
    ORDERS_API_SEARCH_RESTRICTED: 'Light search access to Find API Order',
    ORDERS_API_SEARCH_FULL: 'Full search access to Find API Order',
    CUSTOMER_PORTAL: 'Customer access to Customer Portal',
    CUSTOMER_PORTAL_ADMIN: 'Admin access to Customer Portal',
    CUSTOMER_PORTAL_VIEW_PRICE: 'Can see prices in Customer Portal',
    VIEW_PRICE: 'Can see prices',
    VIEW_PRICE_EVENTS: 'Can see price events',
    FINANCIAL_VIEW_CUSTOMER_AND_UNIT_PRICE: 'Can see prices on routes',
    BOOK_SHIPMENT: 'Can book shipments',
    PLANNER_ADDRESSES: 'Addresses',
    PLANNER_BILLING_ORDERS: 'Billing orders',
    PLANNER_BILLING_ORDERS_READ: 'Billing orders (read only)',
    PLANNER_BOOKING: 'Booking',
    PLANNER_CORRECTIONS: 'Corrections',
    PLANNER_COURIERS: 'Couriers',
    PLANNER_DISPATCHING: 'Dispatching',
    PLANNER_IMPORT_EXPORT: 'Limited access to reports',
    PLANNER_IMPORT_EXPORT_EXTENDED: 'Access to all reports',
    PLANNER_INVOICING: 'Invoicing',
    PLANNER_LIVE: 'Live',
    PLANNER_MANAGE_RETURNS: 'Manage Returns',
    PLANNER_PICKUP_ORDERS: 'Pickup Orders',
    PLANNER_RECURRING_ORDERS: 'Recurring',
    PLANNER_ROUTE_PLANNING: 'Route Planning',
    PLANNER_SHIPMENTS: 'Shipments',
    PLANNER_UNITS: 'Units',
    PLANNER_UNITS_REMOVE: 'Remove units from department',
    PLANNER_UNRESOLVED: 'Unresolved',
    PLANNER_REPORTS: 'Reports',
    PLANNER_VEHICLES: 'Vehicles',
    PLANNER_PRE_ADVICE: 'Preadvice',
    ADMIN_ALCOHOL_DELIVERY_EDUCATION: 'Can add alcohol delivery education for couriers',
    FINANCIAL_SHOW_INVOICING_PAYLOAD: 'Show invoice payload',
    FINANCIAL_DOWNLOAD_INVOICE: 'Download invoice',
    FINANCIAL_CREDIT_NOTE: 'Credit note',
    FINANCIAL_COPY_TO_BILLING_ORDER: 'Copy to billing order',
    FINANCIAL_VIEW_GROUP: 'View group',
    FINANCIAL_VIEW_MULTILEG: 'View multileg',
    FINANCIAL_REINVOICE_INVOICED_ORDERS: 'Reinvoice invoiced orders',
    FINANCIAL_INVOICE_ACTIONS: 'Invoice actions on shipments',
    PRICING_ENGINE: 'Pricing Engine',
    READ_ANY_SHIPMENT: 'Shipment'
  },
  coordinates: {
    title: 'Set correct coordinates for addresses',
    setCoordinatesCount: 'Set coordinates ({{count}})',
    zipCodeRange: 'Postal code range',
    goodJob: 'Good job',
    noUnresolvedShipments: 'No unresolved shipments found for this department or department group',
    coordinateSaved: 'Coordinates successfully resolved for {{address}}',
    setCoordinates: 'Set coordinates',
    checkMapProvider: 'Check {{name}}',
    noDeliveryDate: 'No delivery date',
    created: 'Created',
    withDeliveryDate: 'With delivery date ({{count}})',
    withoutDeliveryDate: 'Without delivery date ({{count}})',
    applyFilter: 'Apply filter',
    thereAreUnsetCoordinates: 'You have {{count}} coordinate to be set.',
    thereAreUnsetCoordinates_other: 'You have {{count}} coordinates to be set.',
    noCoordinateFound:
      'We could not find coordinates for the address. Search for the address or insert coordinates, (eg. 59.289976807684084, 18.010318840107406) in the search field.'
  },
  relatedOrders: {
    NONE: 'No related orders',
    MULTILEG: 'Multileg',
    PICKUP: 'Pickup leg',
    TRANSPORT: 'Transport leg',
    DELIVERY: 'Delivery leg',
    CUSTOMER: 'Order made by customer'
  },
  vendors: {
    title: 'Vendors',
    viewDetails: 'View details',
    searchLabel: 'Search for vendor name, vendor ID or unit ID',
    searchVendorPlaceholder: 'Search for vendor name or vendor ID',
    searchUnitPlaceholder: 'Search for unit ID',
    vendorOption: 'Vendor name/ID',
    unitOption: 'Unit ID',
    notFound: 'Could not find vendors with search phrase',
    initialSearch: 'Search to find vendors',
    informationAboutTheVendor: 'Information about the vendor',
    connectUnit: 'Connect unit',
    connectUnits: 'Connect units',
    connectedUnits: 'Connected unit ({{count}})',
    connectedUnits_other: 'Connected units ({{count}})',
    unitsConnected: '{{count}} Unit connected',
    unitsConnected_other: '{{count}} Units connected',
    unitsConnected_zero: 'No units connected',
    paymentTerms: 'Payment terms',
    connected: 'Connected',
    searchForUnitDescription: 'Selecting a unit means that the department the unit is added to will take the cost.',
    searchForUnitTitle: '{{vendorSite}} for {{operatingUnitName}}',
    successToast: 'Updated connected units to vendor {{name}}',
    showConnectedUnits: 'Show connected units',
    editConnectedUnits: 'Edit connected units',
    searchForUnit: 'Search for unit',
    searchPage: 'Search page',
    currencyCode: 'Currency code',
    connectedToCompany: 'Connected to this company',
    noConnection: 'No connection',
    connectedTo: 'Connected to',
    nothingHereYet: 'Nothing here yet',
    emptyStateSelectedVendor: 'Select a site code to link units or view existing connections.',
    selfBilling: 'Selfbilling',
    setUnitSettingsTitle: 'Update unit settings for {{name}}',
    setUnitSettingsSelfBillingInternalTrade: 'Self billing and internal trade transaction is active.',
    setUnitSettingsNone: 'Self billing and internal trade transaction is not active.',
    setUnitSettingsInternalTrade: 'Self billing is not active while internal trade transaction is active.',
    state: {
      COMPLETE: 'Complete',
      INCOMPLETE: 'Incomplete',
      ALL: 'All',
      label: 'Select vendor state'
    }
  },
  shipmentDetailsBilling: {
    finanicalStakeholder: 'Financial stakeholders',
    item: 'Item',
    customerTotal: 'Customer total',
    unitTotal: 'Unit total',
    orderTotal: 'Order total',
    disconnectToOrginalOrder: 'Disconnect from original shipment number'
  },
  upsalesRulesAdmin: {
    title: 'Upsales rules',
    titleSingular: 'Upsales rule',
    name: 'Name',
    type: 'Type',
    searchPlaceholder: 'Search upsales rules',
    settings: 'Settings',
    successfullyAdded: '{{name}} was successfully added to the list',
    successfullyUpdated: '{{name}} was successfully updated',
    createNewRule: 'Create new upsales rule',
    edit: 'Edit',
    serviceUpgrade: 'Service upgrade',
    SERVICE_UPGRADE: '$t(upsalesRulesAdmin.serviceUpgrade)',
    shorterTimeWindow: 'Shorter time window',
    SHORTER_TIME_WINDOW: '$t(upsalesRulesAdmin.shorterTimeWindow)',
    ruleName: 'Name of upsales rule',
    serviceUpgradeDescription1: 'Service will be upgraded from 3123 to 2870.',
    serviceUpgradeDescription2: 'VAS 1381 will automatically added to make sure driver get the correct payment.',
    zipCodeRangeTitle: 'Postal code',
    zipCodeRangeDescription:
      'Select the postal codes you want to include or exclude in the rule. If you need to remove a specific postal code or a range from a included area, use the exclusion option to fine-tune your selection.',
    fromZipCode: 'Postal code from',
    toZipCode: 'Postal code to',
    addRange: 'Add postal code range',
    addZipCode: 'Add postal code',
    noZipCodeRangesAdded: 'You must provide a postal code range',
    zipCodeRangeError: '"Postal code from" must not be greater than "Postal code to"',
    deleteModalTitle: 'Delete upsales rule',
    deleteModalDescription: 'You will not be able to recover this action',
    successfullyDeleted: 'Upsales rule was successfully deleted',
    shorterTimeWindowDescription1: 'Shorter time window is available for 3332',
    windowOnlyInEvening: 'Shorter time window should only be available in the evening',
    timeWindowOffer: 'What time window should be offered to the recipient?',
    oneHour: '1 hour',
    twoHours: '2 hours',
    threeHours: '3 hours',
    mustSelectTimeWindow: 'You must provide time window offered to the recipient',
    include: 'Include',
    exclude: 'Exclude',
    zipCodeRangeType: 'Type',
    exactZipCode: 'Exact',
    zipCodeRange: 'Range',
    zipCode: 'Postal code',
    mustSelectCountry: 'You must select a country first',
    includedZipCodes: 'Included postal codes ({{count}})',
    excludedZipCodes: 'Excluded postal codes ({{count}})',
    noZipCodesAddedYet: 'No postal codes added yet',
    noMatchOnZipCodeSearch: 'No postal code found. Try filtering with another postal code range.',
    zipCodesFound: '{{count}} postal code found',
    zipCodesFound_other: '{{count}} postal codes found',
    filterOnDepartments: 'Filter on departments',
    UPSALES_RULE_COLLISION_OCCURRED:
      'Rule already exists! Please remove either the following departments: {{departments}} or the following customers: {{customers}}',
    status: 'Status',
    active: 'Active',
    paused: 'Paused',
    pauseRule: 'Pause rule',
    activateRule: 'Activate rule',
    activateRuleModalDescription:
      'You are about to activated the rule. This means that upsales will be available for the recipients. Do you wish to continue?',
    pauseRuleModalDescription:
      'You are about to pause the rule. This means that upsales will not be available for the recipients. Do you wish to continue?',
    successfullyActivated: 'Upsales rule was successfully activated',
    successfullyPaused: 'Upsales rule was successfully paused'
  },
  productionTimeWindow: {
    addNew: 'Add new production time window',
    search: 'Search production time windows',
    description:
      'Here you can set a production time window for orders that have a recipient ID. You can search by recipient ID or by postal code range - searching by postal code range also requires selecting a country. To add a production time window, click "Add new" or search for an existing one to edit.',
    addNewDescription:
      'Add time window for when we can deliver packages for the Recipient ID. If production time window is added this information will be used when routing instead of service time window.',
    recipientId: 'Recipient ID',
    searchForRecipientId: 'Search for recipient ID',
    recipientName: 'Recipient name',
    address: 'Address',
    postalCode: 'Postal code',
    country: 'Country',
    selectCountry: 'Select country',
    addedSuccess: 'Production time window for {{recipientId}} was successfully added.',
    recipientIdValidation: 'You must provide recipient ID',
    timeWindowValidation: 'You must provide a time window',
    invalidRecipientId: 'Invalid recipient ID',
    postalCodeRangeRequiredTogether: 'Postal code from and to are both required together',
    postalCodeRangeRequiresCountry: 'Select a country to search by postal code range',
    createdAt: 'Created at',
    from: 'From',
    to: 'To',
    editSuccess: 'Production time window for {{recipientId}} was successfully changed.',
    delete: 'Delete production time window for {{recipientId}}?',
    deleteDescription:
      'Deleting the production time window means that service time window will be used when routing for this recipient ID. Do you wish to continue?',
    deleteSuccess: 'Production time window for {{recipientId}} was successfully deleted.',
    noResults: 'No production time window found',
    noResultsDescription:
      'Try searching with another recipient ID, or search by postal code range instead. You can also create a new production time window by pressing the button in the top right corner.',
    noResultsPostalCodeDescription:
      'No production time window matches this postal code range. Try searching by recipient ID without a postal code range instead.',
    fromTimeAfterToTime: "'From' time must be before 'to' time"
  },
  loadCarrierModal: {
    title: 'Load Carrier Group: {{loadCarrierId}}',
    description: 'Shipments in group'
  },
  routesOverview: {
    palletRuleOverridden: 'Pallet rule overridden',
    routeNotFoundTitle: 'Route not found',
    routeNotFoundDescription: 'It may have been deleted.',
    shipmentStatus: {
      CREATED: 'Created',
      ASSIGNED: 'Assigned',
      UNASSIGNED: 'Unassigned',
      COLLECTED: 'Collected',
      DELIVERED: 'Delivered',
      DEVIATED: 'Deviated',
      COMMENT: 'Comment',
      RESOLVED: 'Resolved',
      UNRESOLVED: 'Unresolved',
      OFFERED: 'Offered',
      REJECTED: 'Rejected',
      ACCEPTED: 'Accepted',
      RETURNED: 'Returned',
      DELETED: 'Deleted',
      UNCONFIRMED: 'Unconfirmed',
      REFUSED: 'Refused'
    },
    offeredAtTime: 'Order offered at {{time}}',
    plannedRoute: 'Planned Route',
    routes: 'Routes',
    routesCount: '{{filtered}} of {{total}} routes',
    searchRouteOrDriver: 'Search route name or driver name',
    manuallyAdjustRoute: 'Manually adjust route',
    changeRoute: 'Change route',
    plannedRouteTime: 'Planned route time',
    notOptimized: {
      title: 'Route is not optimized',
      optimizationFailed:
        'Route optimization failed, so the route uses a non-optimized fallback. ETA and ETD are not available.',
      manuallyPlanned: 'The route was planned manually without optimization, so ETA and ETD are not available.'
    },
    statusOfRoute: 'Status of route',
    incorrectETA: 'Recipient tracking page is displaying incorrect ETAs',
    adjustedFinishTime: 'Adjusted time of last delivery: {{time}}',
    driverIsDelayed: 'Driver is {{delayed}} min {{suffix}}.',
    deviations: '{{count}} deviation',
    deviations_other: '{{count}} deviations',
    successfullyDeleted: 'Successfully deleted {{name}}',
    successfullyReversedDeliveryOrder: 'Successfully reversed delivery order',
    colorPicker: 'Color picker',
    deleteAllRoutesConfirmDialogText: 'Are you sure you want to delete all slots?',
    stops: 'Stops',
    stop: 'Stop',
    waitingTime: 'Waiting time',
    totalWaitingTime: 'Total waiting time',
    stopsAfterPlannedEndTime: '{{count}} delivery after planned route time ({{time}}).',
    stopsAfterPlannedEndTime_other: '{{count}} deliveries after planned route time ({{time}}).',
    unassignShipmentFromRoute: 'Unassign shipment from route',
    unassign: 'Unassign',
    priceInformation: 'Price information',
    billingOrderShipment: 'Billing order',
    trips: 'Trips',
    routeSettings: 'Route settings',
    driverPhoneNumber: 'Driver phone number',
    selectVehicle: 'Select vehicle',
    nameOfRoute: 'Name of route',
    setStartTime: 'Set start time',
    setEndDate: 'End date',
    setEndTime: 'Set end time',
    endDateValidationError: 'End date must be the route date or the day after',
    endTimeValidationError: 'End time needs to be after start time',
    addMapArea: 'Add map area',
    editMapArea: 'Edit map area',
    areaWasUpdated: 'Map area edited on {{name}} successfully',
    areaWasCreated: 'Map area added to {{name}} successfully',
    areaWasDeleted: 'Map area deleted on {{name}} successfully',
    addAreaRoute: 'Add area to route',
    updateAreaRoute: 'Update area for route',
    deleteMapArea: 'Delete map area',
    templates: 'Templates',
    loadTemplate: 'Load template',
    deleteTemplate: 'Delete template',
    saveAsTemplate: 'Save as template',
    saveTemplate: 'Save template',
    templateWasCreated: '{{name}} was successfully created',
    templateWasLoaded: '{{name}} was successfully loaded',
    templateWasDeleted: '{{name}} was successfully deleted',
    loadTemplateSubHeading: 'Select the template you want to add.',
    createANew: 'Create a new',
    orUpdateExisting: 'or update existing',
    saveTemplateRulesNote:
      'Only postal codes connected to a route rule are carried into the template. Standalone postal codes are not saved.',
    saveTemplateDepartmentGroupNote:
      'This view spans multiple departments. Route rules from other departments will not be carried into this template.',
    deleteTemplateSubHeading: 'Select the template you want to delete.',
    defaultTemplate: 'Default template',
    defaultTemplateSubHeading:
      'Select the template you want to use as the default. This template can then be used for automatic route creation, which is activated in the Departments section under Administration.',
    setDefaultTemplates: 'Set default template',
    selectDefaultTemplate: 'Select default template for {{department}}',
    defaultTemplates: 'Default templates',
    normalTemplates: 'Normal templates',
    templateDefaultsSet: 'Default templates set',
    selectTemplate: 'Select template',
    selectTemplateToOverride: 'Select template to override',
    nameOfTemplate: 'Name of template',
    templateIsRequired: 'Template must be selected',
    templateOrNameIsRequired: 'Template or name must be selected',
    areYouDonePlanning: 'Are you done route planning',
    noBackPage: 'No, back to page',
    yesDone: 'Yes, I am done',
    manageRouteRules: 'Manage route rules',
    eligibleForAutoDispatch: 'Eligible for auto-dispatch of pickup orders',
    postalCodeRangesSet: 'Postal code ranges set',
    unsavedPostalCodeRule: 'Add the postal code rule before saving',
    applyToConnectedRule: 'Apply these changes to the connected route rule "{{name}}"',
    serviceExclusionDescription:
      'Orders with one of these service codes are never assigned to this route by auto-dispatch.',
    postalCodeRulesSaved: 'Postal code rules were successfully updated',
    postalCodeRulesSavedAndApplied:
      'Postal code rules were successfully updated and also applied to the rule "{{name}}"',
    postalCodesTab: 'Postal codes',
    routeRuleTab: 'Route rule',
    connectRouteRuleSubHeading:
      'Connect a route rule to this route. The postal code rules on the route will be overridden by the ones from the selected rule.',
    selectRouteRule: 'Select route rule',
    routeRuleIsRequired: 'Route rule must be selected',
    routeRuleConnected: 'Postal code rules were overridden from the route rule "{{name}}"',
    postalCodeRuleType: 'Rule type',
    includePostalCodes: 'Include',
    excludePostalCodes: 'Exclude',
    postalCodeRange: 'Range',
    exactPostalCode: 'Exact postal code',
    postalCodeFrom: 'From postal code',
    postalCodeTo: 'To postal code',
    addPostalCodeRule: 'Add postal code rule',
    noPostalCodeRules: 'None added yet',
    savedPostalCodeRules: 'Saved postal code rules',
    postalCodeRuleRequired: 'Postal code is required',
    postalCodeRuleConflict: {
      duplicate: 'This postal code rule already exists',
      overlap: 'The rule overlaps the existing rule "{{rule}}"',
      excludeNotContained: 'The exclude rule "{{rule}}" must be within an include range',
      excludeCoversInclude: 'An exclude rule cannot cover the entire include range "{{rule}}"'
    },
    skipAutoDispatch: 'Disable auto-dispatch',
    enableAutoDispatch: 'Enable auto-dispatch',
    skipAutoDispatchSuccess: '{{name}} was successfully disabled for auto-dispatch',
    enableAutoDispatchSuccess: '{{name}} was successfully enabled for auto-dispatch',
    completedRoute: '{{name}} has been completed',
    routeCreatedMessage: 'Route successfully saved and added to route list',
    createRoute: 'Create Route',
    saveAndCreateRoute: 'Save and create new route',
    routeWasDeleted: 'Route was successfully deleted',
    routeWasUpdated: 'Route was successfully updated',
    routeWasUpdated_other: 'Routes was successfully updated',
    routeWasDeleted_other: 'Routes was successfully deleted',
    sendPrePickupSms: 'Pre-send tracking SMS',
    deleteAllRoutes: 'Delete all routes',
    routesNotStarted: 'Routes not started',
    noRoutes: 'No routes created yet',
    viewStopsGrouped: 'Group stops',
    showCompletedDeliveries: 'Show completed',
    showRemainingDeliveries: 'Show remaining',
    orders: 'Orders',
    onlyUnaccepted: 'only unaccepted',
    onlyRoutesWithUnacceptedOrders: 'Only display routes with unaccepted orders',
    activeFilters: 'Active filters',
    clearFilters: 'Clear filter',
    clearSearch: 'Clear search',
    removeFilter: 'Remove filter {{name}}',
    selectedCount: '{{count}} selected',
    selectedCount_other: '{{count}} selected',
    selectedCount_zero: 'none selected',
    routeState: 'Route State',
    routeLabels: 'Route labels',
    state: 'State',
    routeNameAZ: 'Route name A-Z',
    routeNameZA: 'Route name Z-A',
    routeStartedAZ: 'Route started A-Z',
    routeNotStartedAZ: 'Route not started A-Z',
    deletePlannedStopFromSlot: 'Delete planned stop from slot',
    deleteBreakFromSlot: 'Delete break time from slot',
    plannedStopDeletedFromSlot: 'Planned stop was successfully deleted from slot',
    movedOrderToRouteSuccess: 'Successfully moved order to route {{routeName}}',
    movedOrderToRouteSuccess_other: 'Successfully moved {{count}} orders to route {{routeName}}',
    moveOrderToRouteQuestion: 'Move order to route {{routeName}}?',
    moveOrderToRouteQuestion_other: 'Move {{count}} orders to route {{routeName}}?',
    couldNotMoveOrderToRoute: 'Could not move order to route {{routeName}}',
    failedToOptimizeSlotAfterDeletingPlannedStop: 'Failed to optimize slot after deleting planned stop',
    actionsForAllShipments: 'Actions for all shipments',
    removePlannedStopFromRouteAndReoptimize:
      'The planned stop will be removed from the route and the route will automatically be re-optimized.',
    unassignShipmentFromRouteAndReoptimize:
      'The shipment will be unassigned and the route will automatically be re-optimized.',
    unassignShipmentFromRouteAndReoptimize_other:
      'The shipments will be unassigned and the route will automatically be re-optimized.',
    quickEditDisabledTooltip: 'You are missing access to the department of this order.',
    routeLabel: 'Route label',
    selectRouteLabel: 'Select route label',
    labelFilter: {
      title: 'Filter routes by label',
      description: 'This department has route labels. Choose one or more labels to narrow down which routes are shown.',
      selectLabels: 'Select labels',
      apply: 'Apply filter',
      showAll: 'Show all routes',
      or: 'OR',
      and: 'AND'
    },
    mustSelectVehicle: 'You must select a vehicle'
  },
  reports: {
    serviceTimeWindow: 'Delivered within Service Time Window',
    estimatedTimeWindow: 'Delivered within Estimated Time',
    correctLocation: 'Delivered in correct Location',
    withinSTW: 'Within STW',
    withinETD: 'Within ETD',
    withinPAW: 'Within PAW',
    followedRoutes: 'Followed Routes',
    departmentTitle: 'Reports for {{name}}',
    serviceWindow: 'Service window',
    estimatedWindow: 'Estimated window',
    quality: 'Quality',
    scrollToStop: 'Scroll to stop',
    stopGraphLabel: 'Stop data',
    hiddenStopsTooltip: 'This graph contains hidden stops. Click to see which stops',
    graphContainsHiddenStops: 'This graph contains hidden stops',
    stopWasHiddenDueToDeliveryDateSetTo: 'Stop {{stopNumber}} was hidden because delivery date was {{date}}',
    stopWasHiddenDueToDeliveryDateNotSet: "Stop {{stopNumber}} was hidden because it wasn't completed",
    productionAccuracy: 'Production window',
    productionAccuracyTimeWindow: 'Delivered within Production Window',
    productionAccuracyTooltip: '{{number}} stops delivered within production window.',
    actualStop: 'Actual stop order',
    plannedStop: 'Planned stop order',
    serviceTimeWindowTooltip: '{{number}} stops delivered within service time window.',
    estimatedTimeWindowTooltip: '{{number}} stops delivered within the estimated time window.',
    correctLocationTooltip: '{{number}} stops delivered to the correct location.',
    followedRoutesTooltipStops: '{{number}} stops completed in the correct order.',
    followedRoutesTooltipOrders: '{{number}} orders delivered in the correct order.'
  },
  settings: {
    profile: 'Profile',
    departmentsSaved: 'Your departments were saved'
  },
  iamOnboarding: {
    description:
      'It looks like you don’t have any departments connected to your account yet. You can add the departments you need access to via Settings in the menu on the left.',
    goToSettings: 'Go to Settings'
  },
  iamMigrationModal: {
    title: 'Action required: apply for the Glow One Identity role',
    body: 'As a Posten & Bring employee, you now need the role below to log in to Glow. Please apply for this role in One Identity.',
    instructions:
      'Go to <a>{{iamUrl}}</a> and apply for the role. Once your application has been approved, you can sign in to Glow using your Posten account.',
    roleLabel: 'Role to apply for',
    copyRole: 'Copy role name',
    copied: 'Copied',
    applyForRole: 'Apply for role',
    confirmCheckbox: 'I confirm that I have applied for the role F_APP_S55475-GLOW_USR',
    confirm: 'Continue'
  }
}

export default en
